var L0 = "4.13.0";
function qt(n, t) {
  return n < t ? -1 : n > t ? 1 : n >= t ? 0 : NaN;
}
function oa(n) {
  return n.length === 1 && (n = D0(n)), {
    left: function(t, e, r, i) {
      for (r == null && (r = 0), i == null && (i = t.length); r < i; ) {
        var u = r + i >>> 1;
        n(t[u], e) < 0 ? r = u + 1 : i = u;
      }
      return r;
    },
    right: function(t, e, r, i) {
      for (r == null && (r = 0), i == null && (i = t.length); r < i; ) {
        var u = r + i >>> 1;
        n(t[u], e) > 0 ? i = u : r = u + 1;
      }
      return r;
    }
  };
}
function D0(n) {
  return function(t, e) {
    return qt(n(t), e);
  };
}
var bf = oa(qt), It = bf.right, O0 = bf.left;
function U0(n, t) {
  t == null && (t = Mf);
  for (var e = 0, r = n.length - 1, i = n[0], u = new Array(r < 0 ? 0 : r); e < r; ) u[e] = t(i, i = n[++e]);
  return u;
}
function Mf(n, t) {
  return [n, t];
}
function F0(n, t, e) {
  var r = n.length, i = t.length, u = new Array(r * i), o, a, s, c;
  for (e == null && (e = Mf), o = s = 0; o < r; ++o)
    for (c = n[o], a = 0; a < i; ++a, ++s)
      u[s] = e(c, t[a]);
  return u;
}
function Y0(n, t) {
  return t < n ? -1 : t > n ? 1 : t >= n ? 0 : NaN;
}
function vt(n) {
  return n === null ? NaN : +n;
}
function Sf(n, t) {
  var e = n.length, r = 0, i = -1, u = 0, o, a, s = 0;
  if (t == null)
    for (; ++i < e; )
      isNaN(o = vt(n[i])) || (a = o - u, u += a / ++r, s += a * (o - u));
  else
    for (; ++i < e; )
      isNaN(o = vt(t(n[i], i, n))) || (a = o - u, u += a / ++r, s += a * (o - u));
  if (r > 1) return s / (r - 1);
}
function Tf(n, t) {
  var e = Sf(n, t);
  return e && Math.sqrt(e);
}
function Nf(n, t) {
  var e = n.length, r = -1, i, u, o;
  if (t == null) {
    for (; ++r < e; )
      if ((i = n[r]) != null && i >= i)
        for (u = o = i; ++r < e; )
          (i = n[r]) != null && (u > i && (u = i), o < i && (o = i));
  } else
    for (; ++r < e; )
      if ((i = t(n[r], r, n)) != null && i >= i)
        for (u = o = i; ++r < e; )
          (i = t(n[r], r, n)) != null && (u > i && (u = i), o < i && (o = i));
  return [u, o];
}
var Ef = Array.prototype, q0 = Ef.slice, H0 = Ef.map;
function Lr(n) {
  return function() {
    return n;
  };
}
function B0(n) {
  return n;
}
function qn(n, t, e) {
  n = +n, t = +t, e = (i = arguments.length) < 2 ? (t = n, n = 0, 1) : i < 3 ? 1 : +e;
  for (var r = -1, i = Math.max(0, Math.ceil((t - n) / e)) | 0, u = new Array(i); ++r < i; )
    u[r] = n + r * e;
  return u;
}
var ho = Math.sqrt(50), po = Math.sqrt(10), go = Math.sqrt(2);
function aa(n, t, e) {
  var r, i = -1, u, o, a;
  if (t = +t, n = +n, e = +e, n === t && e > 0) return [n];
  if ((r = t < n) && (u = n, n = t, t = u), (a = Ke(n, t, e)) === 0 || !isFinite(a)) return [];
  if (a > 0)
    for (n = Math.ceil(n / a), t = Math.floor(t / a), o = new Array(u = Math.ceil(t - n + 1)); ++i < u; ) o[i] = (n + i) * a;
  else
    for (n = Math.floor(n * a), t = Math.ceil(t * a), o = new Array(u = Math.ceil(n - t + 1)); ++i < u; ) o[i] = (n - i) / a;
  return r && o.reverse(), o;
}
function Ke(n, t, e) {
  var r = (t - n) / Math.max(0, e), i = Math.floor(Math.log(r) / Math.LN10), u = r / Math.pow(10, i);
  return i >= 0 ? (u >= ho ? 10 : u >= po ? 5 : u >= go ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (u >= ho ? 10 : u >= po ? 5 : u >= go ? 2 : 1);
}
function er(n, t, e) {
  var r = Math.abs(t - n) / Math.max(0, e), i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)), u = r / i;
  return u >= ho ? i *= 10 : u >= po ? i *= 5 : u >= go && (i *= 2), t < n ? -i : i;
}
function kf(n) {
  return Math.ceil(Math.log(n.length) / Math.LN2) + 1;
}
function X0() {
  var n = B0, t = Nf, e = kf;
  function r(i) {
    var u, o = i.length, a, s = new Array(o);
    for (u = 0; u < o; ++u)
      s[u] = n(i[u], u, i);
    var c = t(s), l = c[0], h = c[1], f = e(s, l, h);
    Array.isArray(f) || (f = er(l, h, f), f = qn(Math.ceil(l / f) * f, Math.floor(h / f) * f, f));
    for (var p = f.length; f[0] <= l; ) f.shift(), --p;
    for (; f[p - 1] > h; ) f.pop(), --p;
    var g = new Array(p + 1), d;
    for (u = 0; u <= p; ++u)
      d = g[u] = [], d.x0 = u > 0 ? f[u - 1] : l, d.x1 = u < p ? f[u] : h;
    for (u = 0; u < o; ++u)
      a = s[u], l <= a && a <= h && g[It(f, a, 0, p)].push(i[u]);
    return g;
  }
  return r.value = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : Lr(i), r) : n;
  }, r.domain = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : Lr([i[0], i[1]]), r) : t;
  }, r.thresholds = function(i) {
    return arguments.length ? (e = typeof i == "function" ? i : Array.isArray(i) ? Lr(q0.call(i)) : Lr(i), r) : e;
  }, r;
}
function rr(n, t, e) {
  if (e == null && (e = vt), !!(r = n.length)) {
    if ((t = +t) <= 0 || r < 2) return +e(n[0], 0, n);
    if (t >= 1) return +e(n[r - 1], r - 1, n);
    var r, i = (r - 1) * t, u = Math.floor(i), o = +e(n[u], u, n), a = +e(n[u + 1], u + 1, n);
    return o + (a - o) * (i - u);
  }
}
function W0(n, t, e) {
  return n = H0.call(n, vt).sort(qt), Math.ceil((e - t) / (2 * (rr(n, 0.75) - rr(n, 0.25)) * Math.pow(n.length, -1 / 3)));
}
function V0(n, t, e) {
  return Math.ceil((e - t) / (3.5 * Tf(n) * Math.pow(n.length, -1 / 3)));
}
function Z0(n, t) {
  var e = n.length, r = -1, i, u;
  if (t == null) {
    for (; ++r < e; )
      if ((i = n[r]) != null && i >= i)
        for (u = i; ++r < e; )
          (i = n[r]) != null && i > u && (u = i);
  } else
    for (; ++r < e; )
      if ((i = t(n[r], r, n)) != null && i >= i)
        for (u = i; ++r < e; )
          (i = t(n[r], r, n)) != null && i > u && (u = i);
  return u;
}
function G0(n, t) {
  var e = n.length, r = e, i = -1, u, o = 0;
  if (t == null)
    for (; ++i < e; )
      isNaN(u = vt(n[i])) ? --r : o += u;
  else
    for (; ++i < e; )
      isNaN(u = vt(t(n[i], i, n))) ? --r : o += u;
  if (r) return o / r;
}
function Q0(n, t) {
  var e = n.length, r = -1, i, u = [];
  if (t == null)
    for (; ++r < e; )
      isNaN(i = vt(n[r])) || u.push(i);
  else
    for (; ++r < e; )
      isNaN(i = vt(t(n[r], r, n))) || u.push(i);
  return rr(u.sort(qt), 0.5);
}
function sa(n) {
  for (var t = n.length, e, r = -1, i = 0, u, o; ++r < t; ) i += n[r].length;
  for (u = new Array(i); --t >= 0; )
    for (o = n[t], e = o.length; --e >= 0; )
      u[--i] = o[e];
  return u;
}
function Cf(n, t) {
  var e = n.length, r = -1, i, u;
  if (t == null) {
    for (; ++r < e; )
      if ((i = n[r]) != null && i >= i)
        for (u = i; ++r < e; )
          (i = n[r]) != null && u > i && (u = i);
  } else
    for (; ++r < e; )
      if ((i = t(n[r], r, n)) != null && i >= i)
        for (u = i; ++r < e; )
          (i = t(n[r], r, n)) != null && u > i && (u = i);
  return u;
}
function K0(n, t) {
  for (var e = t.length, r = new Array(e); e--; ) r[e] = n[t[e]];
  return r;
}
function J0(n, t) {
  if (e = n.length) {
    var e, r = 0, i = 0, u, o = n[i];
    for (t == null && (t = qt); ++r < e; )
      (t(u = n[r], o) < 0 || t(o, o) !== 0) && (o = u, i = r);
    if (t(o, o) === 0) return i;
  }
}
function j0(n, t, e) {
  for (var r = (e ?? n.length) - (t = t == null ? 0 : +t), i, u; r; )
    u = Math.random() * r-- | 0, i = n[r + t], n[r + t] = n[u + t], n[u + t] = i;
  return n;
}
function n1(n, t) {
  var e = n.length, r = -1, i, u = 0;
  if (t == null)
    for (; ++r < e; )
      (i = +n[r]) && (u += i);
  else
    for (; ++r < e; )
      (i = +t(n[r], r, n)) && (u += i);
  return u;
}
function Af(n) {
  if (!(u = n.length)) return [];
  for (var t = -1, e = Cf(n, t1), r = new Array(e); ++t < e; )
    for (var i = -1, u, o = r[t] = new Array(u); ++i < u; )
      o[i] = n[i][t];
  return r;
}
function t1(n) {
  return n.length;
}
function e1() {
  return Af(arguments);
}
var Ru = Array.prototype.slice;
function r1(n) {
  return n;
}
var ii = 1, ui = 2, vo = 3, Ie = 4, Ss = 1e-6;
function i1(n) {
  return "translate(" + (n + 0.5) + ",0)";
}
function u1(n) {
  return "translate(0," + (n + 0.5) + ")";
}
function o1(n) {
  return function(t) {
    return +n(t);
  };
}
function a1(n) {
  var t = Math.max(0, n.bandwidth() - 1) / 2;
  return n.round() && (t = Math.round(t)), function(e) {
    return +n(e) + t;
  };
}
function s1() {
  return !this.__axis;
}
function eu(n, t) {
  var e = [], r = null, i = null, u = 6, o = 6, a = 3, s = n === ii || n === Ie ? -1 : 1, c = n === Ie || n === ui ? "x" : "y", l = n === ii || n === vo ? i1 : u1;
  function h(f) {
    var p = r ?? (t.ticks ? t.ticks.apply(t, e) : t.domain()), g = i ?? (t.tickFormat ? t.tickFormat.apply(t, e) : r1), d = Math.max(u, 0) + a, v = t.range(), y = +v[0] + 0.5, x = +v[v.length - 1] + 0.5, m = (t.bandwidth ? a1 : o1)(t.copy()), w = f.selection ? f.selection() : f, M = w.selectAll(".domain").data([null]), N = w.selectAll(".tick").data(p, t).order(), S = N.exit(), E = N.enter().append("g").attr("class", "tick"), T = N.select("line"), $ = N.select("text");
    M = M.merge(M.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "#000")), N = N.merge(E), T = T.merge(E.append("line").attr("stroke", "#000").attr(c + "2", s * u)), $ = $.merge(E.append("text").attr("fill", "#000").attr(c, s * d).attr("dy", n === ii ? "0em" : n === vo ? "0.71em" : "0.32em")), f !== w && (M = M.transition(f), N = N.transition(f), T = T.transition(f), $ = $.transition(f), S = S.transition(f).attr("opacity", Ss).attr("transform", function(A) {
      return isFinite(A = m(A)) ? l(A) : this.getAttribute("transform");
    }), E.attr("opacity", Ss).attr("transform", function(A) {
      var k = this.parentNode.__axis;
      return l(k && isFinite(k = k(A)) ? k : m(A));
    })), S.remove(), M.attr("d", n === Ie || n == ui ? "M" + s * o + "," + y + "H0.5V" + x + "H" + s * o : "M" + y + "," + s * o + "V0.5H" + x + "V" + s * o), N.attr("opacity", 1).attr("transform", function(A) {
      return l(m(A));
    }), T.attr(c + "2", s * u), $.attr(c, s * d).text(g), w.filter(s1).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", n === ui ? "start" : n === Ie ? "end" : "middle"), w.each(function() {
      this.__axis = m;
    });
  }
  return h.scale = function(f) {
    return arguments.length ? (t = f, h) : t;
  }, h.ticks = function() {
    return e = Ru.call(arguments), h;
  }, h.tickArguments = function(f) {
    return arguments.length ? (e = f == null ? [] : Ru.call(f), h) : e.slice();
  }, h.tickValues = function(f) {
    return arguments.length ? (r = f == null ? null : Ru.call(f), h) : r && r.slice();
  }, h.tickFormat = function(f) {
    return arguments.length ? (i = f, h) : i;
  }, h.tickSize = function(f) {
    return arguments.length ? (u = o = +f, h) : u;
  }, h.tickSizeInner = function(f) {
    return arguments.length ? (u = +f, h) : u;
  }, h.tickSizeOuter = function(f) {
    return arguments.length ? (o = +f, h) : o;
  }, h.tickPadding = function(f) {
    return arguments.length ? (a = +f, h) : a;
  }, h;
}
function c1(n) {
  return eu(ii, n);
}
function f1(n) {
  return eu(ui, n);
}
function l1(n) {
  return eu(vo, n);
}
function h1(n) {
  return eu(Ie, n);
}
var p1 = { value: function() {
} };
function xt() {
  for (var n = 0, t = arguments.length, e = {}, r; n < t; ++n) {
    if (!(r = arguments[n] + "") || r in e) throw new Error("illegal type: " + r);
    e[r] = [];
  }
  return new oi(e);
}
function oi(n) {
  this._ = n;
}
function g1(n, t) {
  return n.trim().split(/^|\s+/).map(function(e) {
    var r = "", i = e.indexOf(".");
    if (i >= 0 && (r = e.slice(i + 1), e = e.slice(0, i)), e && !t.hasOwnProperty(e)) throw new Error("unknown type: " + e);
    return { type: e, name: r };
  });
}
oi.prototype = xt.prototype = {
  constructor: oi,
  on: function(n, t) {
    var e = this._, r = g1(n + "", e), i, u = -1, o = r.length;
    if (arguments.length < 2) {
      for (; ++u < o; ) if ((i = (n = r[u]).type) && (i = d1(e[i], n.name))) return i;
      return;
    }
    if (t != null && typeof t != "function") throw new Error("invalid callback: " + t);
    for (; ++u < o; )
      if (i = (n = r[u]).type) e[i] = Ts(e[i], n.name, t);
      else if (t == null) for (i in e) e[i] = Ts(e[i], n.name, null);
    return this;
  },
  copy: function() {
    var n = {}, t = this._;
    for (var e in t) n[e] = t[e].slice();
    return new oi(n);
  },
  call: function(n, t) {
    if ((i = arguments.length - 2) > 0) for (var e = new Array(i), r = 0, i, u; r < i; ++r) e[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    for (u = this._[n], r = 0, i = u.length; r < i; ++r) u[r].value.apply(t, e);
  },
  apply: function(n, t, e) {
    if (!this._.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    for (var r = this._[n], i = 0, u = r.length; i < u; ++i) r[i].value.apply(t, e);
  }
};
function d1(n, t) {
  for (var e = 0, r = n.length, i; e < r; ++e)
    if ((i = n[e]).name === t)
      return i.value;
}
function Ts(n, t, e) {
  for (var r = 0, i = n.length; r < i; ++r)
    if (n[r].name === t) {
      n[r] = p1, n = n.slice(0, r).concat(n.slice(r + 1));
      break;
    }
  return e != null && n.push({ name: t, value: e }), n;
}
var yo = "http://www.w3.org/1999/xhtml";
const mo = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: yo,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function Tr(n) {
  var t = n += "", e = t.indexOf(":");
  return e >= 0 && (t = n.slice(0, e)) !== "xmlns" && (n = n.slice(e + 1)), mo.hasOwnProperty(t) ? { space: mo[t], local: n } : n;
}
function v1(n) {
  return function() {
    var t = this.ownerDocument, e = this.namespaceURI;
    return e === yo && t.documentElement.namespaceURI === yo ? t.createElement(n) : t.createElementNS(e, n);
  };
}
function y1(n) {
  return function() {
    return this.ownerDocument.createElementNS(n.space, n.local);
  };
}
function ru(n) {
  var t = Tr(n);
  return (t.local ? y1 : v1)(t);
}
function m1() {
}
function iu(n) {
  return n == null ? m1 : function() {
    return this.querySelector(n);
  };
}
function _1(n) {
  typeof n != "function" && (n = iu(n));
  for (var t = this._groups, e = t.length, r = new Array(e), i = 0; i < e; ++i)
    for (var u = t[i], o = u.length, a = r[i] = new Array(o), s, c, l = 0; l < o; ++l)
      (s = u[l]) && (c = n.call(s, s.__data__, l, u)) && ("__data__" in s && (c.__data__ = s.__data__), a[l] = c);
  return new Tn(r, this._parents);
}
function w1() {
  return [];
}
function ca(n) {
  return n == null ? w1 : function() {
    return this.querySelectorAll(n);
  };
}
function x1(n) {
  typeof n != "function" && (n = ca(n));
  for (var t = this._groups, e = t.length, r = [], i = [], u = 0; u < e; ++u)
    for (var o = t[u], a = o.length, s, c = 0; c < a; ++c)
      (s = o[c]) && (r.push(n.call(s, s.__data__, c, o)), i.push(s));
  return new Tn(r, i);
}
var Rf = function(n) {
  return function() {
    return this.matches(n);
  };
};
if (typeof document < "u") {
  var Me = document.documentElement;
  if (!Me.matches) {
    var b1 = Me.webkitMatchesSelector || Me.msMatchesSelector || Me.mozMatchesSelector || Me.oMatchesSelector;
    Rf = function(n) {
      return function() {
        return b1.call(this, n);
      };
    };
  }
}
const fa = Rf;
function M1(n) {
  typeof n != "function" && (n = fa(n));
  for (var t = this._groups, e = t.length, r = new Array(e), i = 0; i < e; ++i)
    for (var u = t[i], o = u.length, a = r[i] = [], s, c = 0; c < o; ++c)
      (s = u[c]) && n.call(s, s.__data__, c, u) && a.push(s);
  return new Tn(r, this._parents);
}
function $f(n) {
  return new Array(n.length);
}
function S1() {
  return new Tn(this._enter || this._groups.map($f), this._parents);
}
function gi(n, t) {
  this.ownerDocument = n.ownerDocument, this.namespaceURI = n.namespaceURI, this._next = null, this._parent = n, this.__data__ = t;
}
gi.prototype = {
  constructor: gi,
  appendChild: function(n) {
    return this._parent.insertBefore(n, this._next);
  },
  insertBefore: function(n, t) {
    return this._parent.insertBefore(n, t);
  },
  querySelector: function(n) {
    return this._parent.querySelector(n);
  },
  querySelectorAll: function(n) {
    return this._parent.querySelectorAll(n);
  }
};
function T1(n) {
  return function() {
    return n;
  };
}
var Ns = "$";
function N1(n, t, e, r, i, u) {
  for (var o = 0, a, s = t.length, c = u.length; o < c; ++o)
    (a = t[o]) ? (a.__data__ = u[o], r[o] = a) : e[o] = new gi(n, u[o]);
  for (; o < s; ++o)
    (a = t[o]) && (i[o] = a);
}
function E1(n, t, e, r, i, u, o) {
  var a, s, c = {}, l = t.length, h = u.length, f = new Array(l), p;
  for (a = 0; a < l; ++a)
    (s = t[a]) && (f[a] = p = Ns + o.call(s, s.__data__, a, t), p in c ? i[a] = s : c[p] = s);
  for (a = 0; a < h; ++a)
    p = Ns + o.call(n, u[a], a, u), (s = c[p]) ? (r[a] = s, s.__data__ = u[a], c[p] = null) : e[a] = new gi(n, u[a]);
  for (a = 0; a < l; ++a)
    (s = t[a]) && c[f[a]] === s && (i[a] = s);
}
function k1(n, t) {
  if (!n)
    return p = new Array(this.size()), c = -1, this.each(function(N) {
      p[++c] = N;
    }), p;
  var e = t ? E1 : N1, r = this._parents, i = this._groups;
  typeof n != "function" && (n = T1(n));
  for (var u = i.length, o = new Array(u), a = new Array(u), s = new Array(u), c = 0; c < u; ++c) {
    var l = r[c], h = i[c], f = h.length, p = n.call(l, l && l.__data__, c, r), g = p.length, d = a[c] = new Array(g), v = o[c] = new Array(g), y = s[c] = new Array(f);
    e(l, h, d, v, y, p, t);
    for (var x = 0, m = 0, w, M; x < g; ++x)
      if (w = d[x]) {
        for (x >= m && (m = x + 1); !(M = v[m]) && ++m < g; ) ;
        w._next = M || null;
      }
  }
  return o = new Tn(o, r), o._enter = a, o._exit = s, o;
}
function C1() {
  return new Tn(this._exit || this._groups.map($f), this._parents);
}
function A1(n) {
  for (var t = this._groups, e = n._groups, r = t.length, i = e.length, u = Math.min(r, i), o = new Array(r), a = 0; a < u; ++a)
    for (var s = t[a], c = e[a], l = s.length, h = o[a] = new Array(l), f, p = 0; p < l; ++p)
      (f = s[p] || c[p]) && (h[p] = f);
  for (; a < r; ++a)
    o[a] = t[a];
  return new Tn(o, this._parents);
}
function R1() {
  for (var n = this._groups, t = -1, e = n.length; ++t < e; )
    for (var r = n[t], i = r.length - 1, u = r[i], o; --i >= 0; )
      (o = r[i]) && (u && u !== o.nextSibling && u.parentNode.insertBefore(o, u), u = o);
  return this;
}
function $1(n) {
  n || (n = P1);
  function t(h, f) {
    return h && f ? n(h.__data__, f.__data__) : !h - !f;
  }
  for (var e = this._groups, r = e.length, i = new Array(r), u = 0; u < r; ++u) {
    for (var o = e[u], a = o.length, s = i[u] = new Array(a), c, l = 0; l < a; ++l)
      (c = o[l]) && (s[l] = c);
    s.sort(t);
  }
  return new Tn(i, this._parents).order();
}
function P1(n, t) {
  return n < t ? -1 : n > t ? 1 : n >= t ? 0 : NaN;
}
function z1() {
  var n = arguments[0];
  return arguments[0] = this, n.apply(null, arguments), this;
}
function I1() {
  var n = new Array(this.size()), t = -1;
  return this.each(function() {
    n[++t] = this;
  }), n;
}
function L1() {
  for (var n = this._groups, t = 0, e = n.length; t < e; ++t)
    for (var r = n[t], i = 0, u = r.length; i < u; ++i) {
      var o = r[i];
      if (o) return o;
    }
  return null;
}
function D1() {
  var n = 0;
  return this.each(function() {
    ++n;
  }), n;
}
function O1() {
  return !this.node();
}
function U1(n) {
  for (var t = this._groups, e = 0, r = t.length; e < r; ++e)
    for (var i = t[e], u = 0, o = i.length, a; u < o; ++u)
      (a = i[u]) && n.call(a, a.__data__, u, i);
  return this;
}
function F1(n) {
  return function() {
    this.removeAttribute(n);
  };
}
function Y1(n) {
  return function() {
    this.removeAttributeNS(n.space, n.local);
  };
}
function q1(n, t) {
  return function() {
    this.setAttribute(n, t);
  };
}
function H1(n, t) {
  return function() {
    this.setAttributeNS(n.space, n.local, t);
  };
}
function B1(n, t) {
  return function() {
    var e = t.apply(this, arguments);
    e == null ? this.removeAttribute(n) : this.setAttribute(n, e);
  };
}
function X1(n, t) {
  return function() {
    var e = t.apply(this, arguments);
    e == null ? this.removeAttributeNS(n.space, n.local) : this.setAttributeNS(n.space, n.local, e);
  };
}
function W1(n, t) {
  var e = Tr(n);
  if (arguments.length < 2) {
    var r = this.node();
    return e.local ? r.getAttributeNS(e.space, e.local) : r.getAttribute(e);
  }
  return this.each((t == null ? e.local ? Y1 : F1 : typeof t == "function" ? e.local ? X1 : B1 : e.local ? H1 : q1)(e, t));
}
function la(n) {
  return n.ownerDocument && n.ownerDocument.defaultView || n.document && n || n.defaultView;
}
function V1(n) {
  return function() {
    this.style.removeProperty(n);
  };
}
function Z1(n, t, e) {
  return function() {
    this.style.setProperty(n, t, e);
  };
}
function G1(n, t, e) {
  return function() {
    var r = t.apply(this, arguments);
    r == null ? this.style.removeProperty(n) : this.style.setProperty(n, r, e);
  };
}
function Q1(n, t, e) {
  return arguments.length > 1 ? this.each((t == null ? V1 : typeof t == "function" ? G1 : Z1)(n, t, e ?? "")) : Lt(this.node(), n);
}
function Lt(n, t) {
  return n.style.getPropertyValue(t) || la(n).getComputedStyle(n, null).getPropertyValue(t);
}
function K1(n) {
  return function() {
    delete this[n];
  };
}
function J1(n, t) {
  return function() {
    this[n] = t;
  };
}
function j1(n, t) {
  return function() {
    var e = t.apply(this, arguments);
    e == null ? delete this[n] : this[n] = e;
  };
}
function np(n, t) {
  return arguments.length > 1 ? this.each((t == null ? K1 : typeof t == "function" ? j1 : J1)(n, t)) : this.node()[n];
}
function Pf(n) {
  return n.trim().split(/^|\s+/);
}
function ha(n) {
  return n.classList || new zf(n);
}
function zf(n) {
  this._node = n, this._names = Pf(n.getAttribute("class") || "");
}
zf.prototype = {
  add: function(n) {
    var t = this._names.indexOf(n);
    t < 0 && (this._names.push(n), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(n) {
    var t = this._names.indexOf(n);
    t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(n) {
    return this._names.indexOf(n) >= 0;
  }
};
function If(n, t) {
  for (var e = ha(n), r = -1, i = t.length; ++r < i; ) e.add(t[r]);
}
function Lf(n, t) {
  for (var e = ha(n), r = -1, i = t.length; ++r < i; ) e.remove(t[r]);
}
function tp(n) {
  return function() {
    If(this, n);
  };
}
function ep(n) {
  return function() {
    Lf(this, n);
  };
}
function rp(n, t) {
  return function() {
    (t.apply(this, arguments) ? If : Lf)(this, n);
  };
}
function ip(n, t) {
  var e = Pf(n + "");
  if (arguments.length < 2) {
    for (var r = ha(this.node()), i = -1, u = e.length; ++i < u; ) if (!r.contains(e[i])) return !1;
    return !0;
  }
  return this.each((typeof t == "function" ? rp : t ? tp : ep)(e, t));
}
function up() {
  this.textContent = "";
}
function op(n) {
  return function() {
    this.textContent = n;
  };
}
function ap(n) {
  return function() {
    var t = n.apply(this, arguments);
    this.textContent = t ?? "";
  };
}
function sp(n) {
  return arguments.length ? this.each(n == null ? up : (typeof n == "function" ? ap : op)(n)) : this.node().textContent;
}
function cp() {
  this.innerHTML = "";
}
function fp(n) {
  return function() {
    this.innerHTML = n;
  };
}
function lp(n) {
  return function() {
    var t = n.apply(this, arguments);
    this.innerHTML = t ?? "";
  };
}
function hp(n) {
  return arguments.length ? this.each(n == null ? cp : (typeof n == "function" ? lp : fp)(n)) : this.node().innerHTML;
}
function pp() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function gp() {
  return this.each(pp);
}
function dp() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function vp() {
  return this.each(dp);
}
function yp(n) {
  var t = typeof n == "function" ? n : ru(n);
  return this.select(function() {
    return this.appendChild(t.apply(this, arguments));
  });
}
function mp() {
  return null;
}
function _p(n, t) {
  var e = typeof n == "function" ? n : ru(n), r = t == null ? mp : typeof t == "function" ? t : iu(t);
  return this.select(function() {
    return this.insertBefore(e.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function wp() {
  var n = this.parentNode;
  n && n.removeChild(this);
}
function xp() {
  return this.each(wp);
}
function bp() {
  return this.parentNode.insertBefore(this.cloneNode(!1), this.nextSibling);
}
function Mp() {
  return this.parentNode.insertBefore(this.cloneNode(!0), this.nextSibling);
}
function Sp(n) {
  return this.select(n ? Mp : bp);
}
function Tp(n) {
  return arguments.length ? this.property("__data__", n) : this.node().__data__;
}
var Df = {}, L = null;
if (typeof document < "u") {
  var Np = document.documentElement;
  "onmouseenter" in Np || (Df = { mouseenter: "mouseover", mouseleave: "mouseout" });
}
function Ep(n, t, e) {
  return n = Of(n, t, e), function(r) {
    var i = r.relatedTarget;
    (!i || i !== this && !(i.compareDocumentPosition(this) & 8)) && n.call(this, r);
  };
}
function Of(n, t, e) {
  return function(r) {
    var i = L;
    L = r;
    try {
      n.call(this, this.__data__, t, e);
    } finally {
      L = i;
    }
  };
}
function kp(n) {
  return n.trim().split(/^|\s+/).map(function(t) {
    var e = "", r = t.indexOf(".");
    return r >= 0 && (e = t.slice(r + 1), t = t.slice(0, r)), { type: t, name: e };
  });
}
function Cp(n) {
  return function() {
    var t = this.__on;
    if (t) {
      for (var e = 0, r = -1, i = t.length, u; e < i; ++e)
        u = t[e], (!n.type || u.type === n.type) && u.name === n.name ? this.removeEventListener(u.type, u.listener, u.capture) : t[++r] = u;
      ++r ? t.length = r : delete this.__on;
    }
  };
}
function Ap(n, t, e) {
  var r = Df.hasOwnProperty(n.type) ? Ep : Of;
  return function(i, u, o) {
    var a = this.__on, s, c = r(t, u, o);
    if (a) {
      for (var l = 0, h = a.length; l < h; ++l)
        if ((s = a[l]).type === n.type && s.name === n.name) {
          this.removeEventListener(s.type, s.listener, s.capture), this.addEventListener(s.type, s.listener = c, s.capture = e), s.value = t;
          return;
        }
    }
    this.addEventListener(n.type, c, e), s = { type: n.type, name: n.name, value: t, listener: c, capture: e }, a ? a.push(s) : this.__on = [s];
  };
}
function Rp(n, t, e) {
  var r = kp(n + ""), i, u = r.length, o;
  if (arguments.length < 2) {
    var a = this.node().__on;
    if (a) {
      for (var s = 0, c = a.length, l; s < c; ++s)
        for (i = 0, l = a[s]; i < u; ++i)
          if ((o = r[i]).type === l.type && o.name === l.name)
            return l.value;
    }
    return;
  }
  for (a = t ? Ap : Cp, e == null && (e = !1), i = 0; i < u; ++i) this.each(a(r[i], t, e));
  return this;
}
function ir(n, t, e, r) {
  var i = L;
  n.sourceEvent = L, L = n;
  try {
    return t.apply(e, r);
  } finally {
    L = i;
  }
}
function Uf(n, t, e) {
  var r = la(n), i = r.CustomEvent;
  typeof i == "function" ? i = new i(t, e) : (i = r.document.createEvent("Event"), e ? (i.initEvent(t, e.bubbles, e.cancelable), i.detail = e.detail) : i.initEvent(t, !1, !1)), n.dispatchEvent(i);
}
function $p(n, t) {
  return function() {
    return Uf(this, n, t);
  };
}
function Pp(n, t) {
  return function() {
    return Uf(this, n, t.apply(this, arguments));
  };
}
function zp(n, t) {
  return this.each((typeof t == "function" ? Pp : $p)(n, t));
}
var pa = [null];
function Tn(n, t) {
  this._groups = n, this._parents = t;
}
function Ht() {
  return new Tn([[document.documentElement]], pa);
}
Tn.prototype = Ht.prototype = {
  constructor: Tn,
  select: _1,
  selectAll: x1,
  filter: M1,
  data: k1,
  enter: S1,
  exit: C1,
  merge: A1,
  order: R1,
  sort: $1,
  call: z1,
  nodes: I1,
  node: L1,
  size: D1,
  empty: O1,
  each: U1,
  attr: W1,
  style: Q1,
  property: np,
  classed: ip,
  text: sp,
  html: hp,
  raise: gp,
  lower: vp,
  append: yp,
  insert: _p,
  remove: xp,
  clone: Sp,
  datum: Tp,
  on: Rp,
  dispatch: zp
};
function kn(n) {
  return typeof n == "string" ? new Tn([[document.querySelector(n)]], [document.documentElement]) : new Tn([[n]], pa);
}
function Ip(n) {
  return kn(ru(n).call(document.documentElement));
}
var Lp = 0;
function Ff() {
  return new _o();
}
function _o() {
  this._ = "@" + (++Lp).toString(36);
}
_o.prototype = Ff.prototype = {
  constructor: _o,
  get: function(n) {
    for (var t = this._; !(t in n); ) if (!(n = n.parentNode)) return;
    return n[t];
  },
  set: function(n, t) {
    return n[this._] = t;
  },
  remove: function(n) {
    return this._ in n && delete n[this._];
  },
  toString: function() {
    return this._;
  }
};
function ga() {
  for (var n = L, t; t = n.sourceEvent; ) n = t;
  return n;
}
function uu(n, t) {
  var e = n.ownerSVGElement || n;
  if (e.createSVGPoint) {
    var r = e.createSVGPoint();
    return r.x = t.clientX, r.y = t.clientY, r = r.matrixTransform(n.getScreenCTM().inverse()), [r.x, r.y];
  }
  var i = n.getBoundingClientRect();
  return [t.clientX - i.left - n.clientLeft, t.clientY - i.top - n.clientTop];
}
function ht(n) {
  var t = ga();
  return t.changedTouches && (t = t.changedTouches[0]), uu(n, t);
}
function Dp(n) {
  return typeof n == "string" ? new Tn([document.querySelectorAll(n)], [document.documentElement]) : new Tn([n ?? []], pa);
}
function di(n, t, e) {
  arguments.length < 3 && (e = t, t = ga().changedTouches);
  for (var r = 0, i = t ? t.length : 0, u; r < i; ++r)
    if ((u = t[r]).identifier === e)
      return uu(n, u);
  return null;
}
function Op(n, t) {
  t == null && (t = ga().touches);
  for (var e = 0, r = t ? t.length : 0, i = new Array(r); e < r; ++e)
    i[e] = uu(n, t[e]);
  return i;
}
function $u() {
  L.stopImmediatePropagation();
}
function re() {
  L.preventDefault(), L.stopImmediatePropagation();
}
function ou(n) {
  var t = n.document.documentElement, e = kn(n).on("dragstart.drag", re, !0);
  "onselectstart" in t ? e.on("selectstart.drag", re, !0) : (t.__noselect = t.style.MozUserSelect, t.style.MozUserSelect = "none");
}
function au(n, t) {
  var e = n.document.documentElement, r = kn(n).on("dragstart.drag", null);
  t && (r.on("click.drag", re, !0), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in e ? r.on("selectstart.drag", null) : (e.style.MozUserSelect = e.__noselect, delete e.__noselect);
}
function Dr(n) {
  return function() {
    return n;
  };
}
function wo(n, t, e, r, i, u, o, a, s, c) {
  this.target = n, this.type = t, this.subject = e, this.identifier = r, this.active = i, this.x = u, this.y = o, this.dx = a, this.dy = s, this._ = c;
}
wo.prototype.on = function() {
  var n = this._.on.apply(this._, arguments);
  return n === this._ ? this : n;
};
function Up() {
  return !L.button;
}
function Fp() {
  return this.parentNode;
}
function Yp(n) {
  return n ?? { x: L.x, y: L.y };
}
function qp() {
  return "ontouchstart" in this;
}
function Hp() {
  var n = Up, t = Fp, e = Yp, r = qp, i = {}, u = xt("start", "drag", "end"), o = 0, a, s, c, l, h = 0;
  function f(w) {
    w.on("mousedown.drag", p).filter(r).on("touchstart.drag", v).on("touchmove.drag", y).on("touchend.drag touchcancel.drag", x).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function p() {
    if (!(l || !n.apply(this, arguments))) {
      var w = m("mouse", t.apply(this, arguments), ht, this, arguments);
      w && (kn(L.view).on("mousemove.drag", g, !0).on("mouseup.drag", d, !0), ou(L.view), $u(), c = !1, a = L.clientX, s = L.clientY, w("start"));
    }
  }
  function g() {
    if (re(), !c) {
      var w = L.clientX - a, M = L.clientY - s;
      c = w * w + M * M > h;
    }
    i.mouse("drag");
  }
  function d() {
    kn(L.view).on("mousemove.drag mouseup.drag", null), au(L.view, c), re(), i.mouse("end");
  }
  function v() {
    if (n.apply(this, arguments)) {
      var w = L.changedTouches, M = t.apply(this, arguments), N = w.length, S, E;
      for (S = 0; S < N; ++S)
        (E = m(w[S].identifier, M, di, this, arguments)) && ($u(), E("start"));
    }
  }
  function y() {
    var w = L.changedTouches, M = w.length, N, S;
    for (N = 0; N < M; ++N)
      (S = i[w[N].identifier]) && (re(), S("drag"));
  }
  function x() {
    var w = L.changedTouches, M = w.length, N, S;
    for (l && clearTimeout(l), l = setTimeout(function() {
      l = null;
    }, 500), N = 0; N < M; ++N)
      (S = i[w[N].identifier]) && ($u(), S("end"));
  }
  function m(w, M, N, S, E) {
    var T = N(M, w), $, A, k, _ = u.copy();
    if (ir(new wo(f, "beforestart", $, w, o, T[0], T[1], 0, 0, _), function() {
      return (L.subject = $ = e.apply(S, E)) == null ? !1 : (A = $.x - T[0] || 0, k = $.y - T[1] || 0, !0);
    }))
      return function b(C) {
        var R = T, P;
        switch (C) {
          case "start":
            i[w] = b, P = o++;
            break;
          case "end":
            delete i[w], --o;
          case "drag":
            T = N(M, w), P = o;
            break;
        }
        ir(new wo(f, C, $, w, P, T[0] + A, T[1] + k, T[0] - R[0], T[1] - R[1], _), _.apply, _, [C, S, E]);
      };
  }
  return f.filter = function(w) {
    return arguments.length ? (n = typeof w == "function" ? w : Dr(!!w), f) : n;
  }, f.container = function(w) {
    return arguments.length ? (t = typeof w == "function" ? w : Dr(w), f) : t;
  }, f.subject = function(w) {
    return arguments.length ? (e = typeof w == "function" ? w : Dr(w), f) : e;
  }, f.touchable = function(w) {
    return arguments.length ? (r = typeof w == "function" ? w : Dr(!!w), f) : r;
  }, f.on = function() {
    var w = u.on.apply(u, arguments);
    return w === u ? f : w;
  }, f.clickDistance = function(w) {
    return arguments.length ? (h = (w = +w) * w, f) : Math.sqrt(h);
  }, f;
}
function _e(n, t, e) {
  n.prototype = t.prototype = e, e.constructor = n;
}
function Nr(n, t) {
  var e = Object.create(n.prototype);
  for (var r in t) e[r] = t[r];
  return e;
}
function bt() {
}
var Dt = 0.7, ce = 1 / Dt, ie = "\\s*([+-]?\\d+)\\s*", ur = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", Qn = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Bp = /^#([0-9a-f]{3})$/, Xp = /^#([0-9a-f]{6})$/, Wp = new RegExp("^rgb\\(" + [ie, ie, ie] + "\\)$"), Vp = new RegExp("^rgb\\(" + [Qn, Qn, Qn] + "\\)$"), Zp = new RegExp("^rgba\\(" + [ie, ie, ie, ur] + "\\)$"), Gp = new RegExp("^rgba\\(" + [Qn, Qn, Qn, ur] + "\\)$"), Qp = new RegExp("^hsl\\(" + [ur, Qn, Qn] + "\\)$"), Kp = new RegExp("^hsla\\(" + [ur, Qn, Qn, ur] + "\\)$"), Es = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
_e(bt, yt, {
  displayable: function() {
    return this.rgb().displayable();
  },
  toString: function() {
    return this.rgb() + "";
  }
});
function yt(n) {
  var t;
  return n = (n + "").trim().toLowerCase(), (t = Bp.exec(n)) ? (t = parseInt(t[1], 16), new gn(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1)) : (t = Xp.exec(n)) ? ks(parseInt(t[1], 16)) : (t = Wp.exec(n)) ? new gn(t[1], t[2], t[3], 1) : (t = Vp.exec(n)) ? new gn(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Zp.exec(n)) ? Cs(t[1], t[2], t[3], t[4]) : (t = Gp.exec(n)) ? Cs(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Qp.exec(n)) ? As(t[1], t[2] / 100, t[3] / 100, 1) : (t = Kp.exec(n)) ? As(t[1], t[2] / 100, t[3] / 100, t[4]) : Es.hasOwnProperty(n) ? ks(Es[n]) : n === "transparent" ? new gn(NaN, NaN, NaN, 0) : null;
}
function ks(n) {
  return new gn(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
function Cs(n, t, e, r) {
  return r <= 0 && (n = t = e = NaN), new gn(n, t, e, r);
}
function da(n) {
  return n instanceof bt || (n = yt(n)), n ? (n = n.rgb(), new gn(n.r, n.g, n.b, n.opacity)) : new gn();
}
function or(n, t, e, r) {
  return arguments.length === 1 ? da(n) : new gn(n, t, e, r ?? 1);
}
function gn(n, t, e, r) {
  this.r = +n, this.g = +t, this.b = +e, this.opacity = +r;
}
_e(gn, or, Nr(bt, {
  brighter: function(n) {
    return n = n == null ? ce : Math.pow(ce, n), new gn(this.r * n, this.g * n, this.b * n, this.opacity);
  },
  darker: function(n) {
    return n = n == null ? Dt : Math.pow(Dt, n), new gn(this.r * n, this.g * n, this.b * n, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return 0 <= this.r && this.r <= 255 && 0 <= this.g && this.g <= 255 && 0 <= this.b && this.b <= 255 && 0 <= this.opacity && this.opacity <= 1;
  },
  toString: function() {
    var n = this.opacity;
    return n = isNaN(n) ? 1 : Math.max(0, Math.min(1, n)), (n === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (n === 1 ? ")" : ", " + n + ")");
  }
}));
function As(n, t, e, r) {
  return r <= 0 ? n = t = e = NaN : e <= 0 || e >= 1 ? n = t = NaN : t <= 0 && (n = NaN), new Vn(n, t, e, r);
}
function Jp(n) {
  if (n instanceof Vn) return new Vn(n.h, n.s, n.l, n.opacity);
  if (n instanceof bt || (n = yt(n)), !n) return new Vn();
  if (n instanceof Vn) return n;
  n = n.rgb();
  var t = n.r / 255, e = n.g / 255, r = n.b / 255, i = Math.min(t, e, r), u = Math.max(t, e, r), o = NaN, a = u - i, s = (u + i) / 2;
  return a ? (t === u ? o = (e - r) / a + (e < r) * 6 : e === u ? o = (r - t) / a + 2 : o = (t - e) / a + 4, a /= s < 0.5 ? u + i : 2 - u - i, o *= 60) : a = s > 0 && s < 1 ? 0 : o, new Vn(o, a, s, n.opacity);
}
function vi(n, t, e, r) {
  return arguments.length === 1 ? Jp(n) : new Vn(n, t, e, r ?? 1);
}
function Vn(n, t, e, r) {
  this.h = +n, this.s = +t, this.l = +e, this.opacity = +r;
}
_e(Vn, vi, Nr(bt, {
  brighter: function(n) {
    return n = n == null ? ce : Math.pow(ce, n), new Vn(this.h, this.s, this.l * n, this.opacity);
  },
  darker: function(n) {
    return n = n == null ? Dt : Math.pow(Dt, n), new Vn(this.h, this.s, this.l * n, this.opacity);
  },
  rgb: function() {
    var n = this.h % 360 + (this.h < 0) * 360, t = isNaN(n) || isNaN(this.s) ? 0 : this.s, e = this.l, r = e + (e < 0.5 ? e : 1 - e) * t, i = 2 * e - r;
    return new gn(
      Pu(n >= 240 ? n - 240 : n + 120, i, r),
      Pu(n, i, r),
      Pu(n < 120 ? n + 240 : n - 120, i, r),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  }
}));
function Pu(n, t, e) {
  return (n < 60 ? t + (e - t) * n / 60 : n < 180 ? e : n < 240 ? t + (e - t) * (240 - n) / 60 : t) * 255;
}
var Yf = Math.PI / 180, qf = 180 / Math.PI, yi = 18, Hf = 0.95047, Bf = 1, Xf = 1.08883, Wf = 4 / 29, ue = 6 / 29, Vf = 3 * ue * ue, jp = ue * ue * ue;
function va(n) {
  if (n instanceof rt) return new rt(n.l, n.a, n.b, n.opacity);
  if (n instanceof gt) {
    var t = n.h * Yf;
    return new rt(n.l, Math.cos(t) * n.c, Math.sin(t) * n.c, n.opacity);
  }
  n instanceof gn || (n = da(n));
  var e = Du(n.r), r = Du(n.g), i = Du(n.b), u = zu((0.4124564 * e + 0.3575761 * r + 0.1804375 * i) / Hf), o = zu((0.2126729 * e + 0.7151522 * r + 0.072175 * i) / Bf), a = zu((0.0193339 * e + 0.119192 * r + 0.9503041 * i) / Xf);
  return new rt(116 * o - 16, 500 * (u - o), 200 * (o - a), n.opacity);
}
function mi(n, t, e, r) {
  return arguments.length === 1 ? va(n) : new rt(n, t, e, r ?? 1);
}
function rt(n, t, e, r) {
  this.l = +n, this.a = +t, this.b = +e, this.opacity = +r;
}
_e(rt, mi, Nr(bt, {
  brighter: function(n) {
    return new rt(this.l + yi * (n ?? 1), this.a, this.b, this.opacity);
  },
  darker: function(n) {
    return new rt(this.l - yi * (n ?? 1), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var n = (this.l + 16) / 116, t = isNaN(this.a) ? n : n + this.a / 500, e = isNaN(this.b) ? n : n - this.b / 200;
    return n = Bf * Iu(n), t = Hf * Iu(t), e = Xf * Iu(e), new gn(
      Lu(3.2404542 * t - 1.5371385 * n - 0.4985314 * e),
      // D65 -> sRGB
      Lu(-0.969266 * t + 1.8760108 * n + 0.041556 * e),
      Lu(0.0556434 * t - 0.2040259 * n + 1.0572252 * e),
      this.opacity
    );
  }
}));
function zu(n) {
  return n > jp ? Math.pow(n, 1 / 3) : n / Vf + Wf;
}
function Iu(n) {
  return n > ue ? n * n * n : Vf * (n - Wf);
}
function Lu(n) {
  return 255 * (n <= 31308e-7 ? 12.92 * n : 1.055 * Math.pow(n, 1 / 2.4) - 0.055);
}
function Du(n) {
  return (n /= 255) <= 0.04045 ? n / 12.92 : Math.pow((n + 0.055) / 1.055, 2.4);
}
function ng(n) {
  if (n instanceof gt) return new gt(n.h, n.c, n.l, n.opacity);
  n instanceof rt || (n = va(n));
  var t = Math.atan2(n.b, n.a) * qf;
  return new gt(t < 0 ? t + 360 : t, Math.sqrt(n.a * n.a + n.b * n.b), n.l, n.opacity);
}
function _i(n, t, e, r) {
  return arguments.length === 1 ? ng(n) : new gt(n, t, e, r ?? 1);
}
function gt(n, t, e, r) {
  this.h = +n, this.c = +t, this.l = +e, this.opacity = +r;
}
_e(gt, _i, Nr(bt, {
  brighter: function(n) {
    return new gt(this.h, this.c, this.l + yi * (n ?? 1), this.opacity);
  },
  darker: function(n) {
    return new gt(this.h, this.c, this.l - yi * (n ?? 1), this.opacity);
  },
  rgb: function() {
    return va(this).rgb();
  }
}));
var Zf = -0.14861, ya = 1.78277, ma = -0.29227, su = -0.90649, ar = 1.97294, Rs = ar * su, $s = ar * ya, Ps = ya * ma - su * Zf;
function tg(n) {
  if (n instanceof $t) return new $t(n.h, n.s, n.l, n.opacity);
  n instanceof gn || (n = da(n));
  var t = n.r / 255, e = n.g / 255, r = n.b / 255, i = (Ps * r + Rs * t - $s * e) / (Ps + Rs - $s), u = r - i, o = (ar * (e - i) - ma * u) / su, a = Math.sqrt(o * o + u * u) / (ar * i * (1 - i)), s = a ? Math.atan2(o, u) * qf - 120 : NaN;
  return new $t(s < 0 ? s + 360 : s, a, i, n.opacity);
}
function Bn(n, t, e, r) {
  return arguments.length === 1 ? tg(n) : new $t(n, t, e, r ?? 1);
}
function $t(n, t, e, r) {
  this.h = +n, this.s = +t, this.l = +e, this.opacity = +r;
}
_e($t, Bn, Nr(bt, {
  brighter: function(n) {
    return n = n == null ? ce : Math.pow(ce, n), new $t(this.h, this.s, this.l * n, this.opacity);
  },
  darker: function(n) {
    return n = n == null ? Dt : Math.pow(Dt, n), new $t(this.h, this.s, this.l * n, this.opacity);
  },
  rgb: function() {
    var n = isNaN(this.h) ? 0 : (this.h + 120) * Yf, t = +this.l, e = isNaN(this.s) ? 0 : this.s * t * (1 - t), r = Math.cos(n), i = Math.sin(n);
    return new gn(
      255 * (t + e * (Zf * r + ya * i)),
      255 * (t + e * (ma * r + su * i)),
      255 * (t + e * (ar * r)),
      this.opacity
    );
  }
}));
function Gf(n, t, e, r, i) {
  var u = n * n, o = u * n;
  return ((1 - 3 * n + 3 * u - o) * t + (4 - 6 * u + 3 * o) * e + (1 + 3 * n + 3 * u - 3 * o) * r + o * i) / 6;
}
function Qf(n) {
  var t = n.length - 1;
  return function(e) {
    var r = e <= 0 ? e = 0 : e >= 1 ? (e = 1, t - 1) : Math.floor(e * t), i = n[r], u = n[r + 1], o = r > 0 ? n[r - 1] : 2 * i - u, a = r < t - 1 ? n[r + 2] : 2 * u - i;
    return Gf((e - r / t) * t, o, i, u, a);
  };
}
function Kf(n) {
  var t = n.length;
  return function(e) {
    var r = Math.floor(((e %= 1) < 0 ? ++e : e) * t), i = n[(r + t - 1) % t], u = n[r % t], o = n[(r + 1) % t], a = n[(r + 2) % t];
    return Gf((e - r / t) * t, i, u, o, a);
  };
}
function cu(n) {
  return function() {
    return n;
  };
}
function Jf(n, t) {
  return function(e) {
    return n + e * t;
  };
}
function eg(n, t, e) {
  return n = Math.pow(n, e), t = Math.pow(t, e) - n, e = 1 / e, function(r) {
    return Math.pow(n + r * t, e);
  };
}
function _a(n, t) {
  var e = t - n;
  return e ? Jf(n, e > 180 || e < -180 ? e - 360 * Math.round(e / 360) : e) : cu(isNaN(n) ? t : n);
}
function rg(n) {
  return (n = +n) == 1 ? pn : function(t, e) {
    return e - t ? eg(t, e, n) : cu(isNaN(t) ? e : t);
  };
}
function pn(n, t) {
  var e = t - n;
  return e ? Jf(n, e) : cu(isNaN(n) ? t : n);
}
const sr = function n(t) {
  var e = rg(t);
  function r(i, u) {
    var o = e((i = or(i)).r, (u = or(u)).r), a = e(i.g, u.g), s = e(i.b, u.b), c = pn(i.opacity, u.opacity);
    return function(l) {
      return i.r = o(l), i.g = a(l), i.b = s(l), i.opacity = c(l), i + "";
    };
  }
  return r.gamma = n, r;
}(1);
function jf(n) {
  return function(t) {
    var e = t.length, r = new Array(e), i = new Array(e), u = new Array(e), o, a;
    for (o = 0; o < e; ++o)
      a = or(t[o]), r[o] = a.r || 0, i[o] = a.g || 0, u[o] = a.b || 0;
    return r = n(r), i = n(i), u = n(u), a.opacity = 1, function(s) {
      return a.r = r(s), a.g = i(s), a.b = u(s), a + "";
    };
  };
}
var ig = jf(Qf), ug = jf(Kf);
function nl(n, t) {
  var e = t ? t.length : 0, r = n ? Math.min(e, n.length) : 0, i = new Array(r), u = new Array(e), o;
  for (o = 0; o < r; ++o) i[o] = Er(n[o], t[o]);
  for (; o < e; ++o) u[o] = t[o];
  return function(a) {
    for (o = 0; o < r; ++o) u[o] = i[o](a);
    return u;
  };
}
function tl(n, t) {
  var e = /* @__PURE__ */ new Date();
  return n = +n, t -= n, function(r) {
    return e.setTime(n + t * r), e;
  };
}
function $n(n, t) {
  return n = +n, t -= n, function(e) {
    return n + t * e;
  };
}
function el(n, t) {
  var e = {}, r = {}, i;
  (n === null || typeof n != "object") && (n = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in n ? e[i] = Er(n[i], t[i]) : r[i] = t[i];
  return function(u) {
    for (i in e) r[i] = e[i](u);
    return r;
  };
}
var xo = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Ou = new RegExp(xo.source, "g");
function og(n) {
  return function() {
    return n;
  };
}
function ag(n) {
  return function(t) {
    return n(t) + "";
  };
}
function wa(n, t) {
  var e = xo.lastIndex = Ou.lastIndex = 0, r, i, u, o = -1, a = [], s = [];
  for (n = n + "", t = t + ""; (r = xo.exec(n)) && (i = Ou.exec(t)); )
    (u = i.index) > e && (u = t.slice(e, u), a[o] ? a[o] += u : a[++o] = u), (r = r[0]) === (i = i[0]) ? a[o] ? a[o] += i : a[++o] = i : (a[++o] = null, s.push({ i: o, x: $n(r, i) })), e = Ou.lastIndex;
  return e < t.length && (u = t.slice(e), a[o] ? a[o] += u : a[++o] = u), a.length < 2 ? s[0] ? ag(s[0].x) : og(t) : (t = s.length, function(c) {
    for (var l = 0, h; l < t; ++l) a[(h = s[l]).i] = h.x(c);
    return a.join("");
  });
}
function Er(n, t) {
  var e = typeof t, r;
  return t == null || e === "boolean" ? cu(t) : (e === "number" ? $n : e === "string" ? (r = yt(t)) ? (t = r, sr) : wa : t instanceof yt ? sr : t instanceof Date ? tl : Array.isArray(t) ? nl : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? el : $n)(n, t);
}
function rl(n, t) {
  return n = +n, t -= n, function(e) {
    return Math.round(n + t * e);
  };
}
var zs = 180 / Math.PI, bo = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function il(n, t, e, r, i, u) {
  var o, a, s;
  return (o = Math.sqrt(n * n + t * t)) && (n /= o, t /= o), (s = n * e + t * r) && (e -= n * s, r -= t * s), (a = Math.sqrt(e * e + r * r)) && (e /= a, r /= a, s /= a), n * r < t * e && (n = -n, t = -t, s = -s, o = -o), {
    translateX: i,
    translateY: u,
    rotate: Math.atan2(t, n) * zs,
    skewX: Math.atan(s) * zs,
    scaleX: o,
    scaleY: a
  };
}
var Se, Uu, Is, Or;
function sg(n) {
  return n === "none" ? bo : (Se || (Se = document.createElement("DIV"), Uu = document.documentElement, Is = document.defaultView), Se.style.transform = n, n = Is.getComputedStyle(Uu.appendChild(Se), null).getPropertyValue("transform"), Uu.removeChild(Se), n = n.slice(7, -1).split(","), il(+n[0], +n[1], +n[2], +n[3], +n[4], +n[5]));
}
function cg(n) {
  return n == null || (Or || (Or = document.createElementNS("http://www.w3.org/2000/svg", "g")), Or.setAttribute("transform", n), !(n = Or.transform.baseVal.consolidate())) ? bo : (n = n.matrix, il(n.a, n.b, n.c, n.d, n.e, n.f));
}
function ul(n, t, e, r) {
  function i(c) {
    return c.length ? c.pop() + " " : "";
  }
  function u(c, l, h, f, p, g) {
    if (c !== h || l !== f) {
      var d = p.push("translate(", null, t, null, e);
      g.push({ i: d - 4, x: $n(c, h) }, { i: d - 2, x: $n(l, f) });
    } else (h || f) && p.push("translate(" + h + t + f + e);
  }
  function o(c, l, h, f) {
    c !== l ? (c - l > 180 ? l += 360 : l - c > 180 && (c += 360), f.push({ i: h.push(i(h) + "rotate(", null, r) - 2, x: $n(c, l) })) : l && h.push(i(h) + "rotate(" + l + r);
  }
  function a(c, l, h, f) {
    c !== l ? f.push({ i: h.push(i(h) + "skewX(", null, r) - 2, x: $n(c, l) }) : l && h.push(i(h) + "skewX(" + l + r);
  }
  function s(c, l, h, f, p, g) {
    if (c !== h || l !== f) {
      var d = p.push(i(p) + "scale(", null, ",", null, ")");
      g.push({ i: d - 4, x: $n(c, h) }, { i: d - 2, x: $n(l, f) });
    } else (h !== 1 || f !== 1) && p.push(i(p) + "scale(" + h + "," + f + ")");
  }
  return function(c, l) {
    var h = [], f = [];
    return c = n(c), l = n(l), u(c.translateX, c.translateY, l.translateX, l.translateY, h, f), o(c.rotate, l.rotate, h, f), a(c.skewX, l.skewX, h, f), s(c.scaleX, c.scaleY, l.scaleX, l.scaleY, h, f), c = l = null, function(p) {
      for (var g = -1, d = f.length, v; ++g < d; ) h[(v = f[g]).i] = v.x(p);
      return h.join("");
    };
  };
}
var ol = ul(sg, "px, ", "px)", "deg)"), al = ul(cg, ", ", ")", ")"), Te = Math.SQRT2, Fu = 2, Ls = 4, fg = 1e-12;
function Ds(n) {
  return ((n = Math.exp(n)) + 1 / n) / 2;
}
function lg(n) {
  return ((n = Math.exp(n)) - 1 / n) / 2;
}
function hg(n) {
  return ((n = Math.exp(2 * n)) - 1) / (n + 1);
}
function sl(n, t) {
  var e = n[0], r = n[1], i = n[2], u = t[0], o = t[1], a = t[2], s = u - e, c = o - r, l = s * s + c * c, h, f;
  if (l < fg)
    f = Math.log(a / i) / Te, h = function(x) {
      return [
        e + x * s,
        r + x * c,
        i * Math.exp(Te * x * f)
      ];
    };
  else {
    var p = Math.sqrt(l), g = (a * a - i * i + Ls * l) / (2 * i * Fu * p), d = (a * a - i * i - Ls * l) / (2 * a * Fu * p), v = Math.log(Math.sqrt(g * g + 1) - g), y = Math.log(Math.sqrt(d * d + 1) - d);
    f = (y - v) / Te, h = function(x) {
      var m = x * f, w = Ds(v), M = i / (Fu * p) * (w * hg(Te * m + v) - lg(v));
      return [
        e + M * s,
        r + M * c,
        i * w / Ds(Te * m + v)
      ];
    };
  }
  return h.duration = f * 1e3, h;
}
function cl(n) {
  return function(t, e) {
    var r = n((t = vi(t)).h, (e = vi(e)).h), i = pn(t.s, e.s), u = pn(t.l, e.l), o = pn(t.opacity, e.opacity);
    return function(a) {
      return t.h = r(a), t.s = i(a), t.l = u(a), t.opacity = o(a), t + "";
    };
  };
}
const pg = cl(_a);
var gg = cl(pn);
function dg(n, t) {
  var e = pn((n = mi(n)).l, (t = mi(t)).l), r = pn(n.a, t.a), i = pn(n.b, t.b), u = pn(n.opacity, t.opacity);
  return function(o) {
    return n.l = e(o), n.a = r(o), n.b = i(o), n.opacity = u(o), n + "";
  };
}
function fl(n) {
  return function(t, e) {
    var r = n((t = _i(t)).h, (e = _i(e)).h), i = pn(t.c, e.c), u = pn(t.l, e.l), o = pn(t.opacity, e.opacity);
    return function(a) {
      return t.h = r(a), t.c = i(a), t.l = u(a), t.opacity = o(a), t + "";
    };
  };
}
const vg = fl(_a);
var yg = fl(pn);
function ll(n) {
  return function t(e) {
    e = +e;
    function r(i, u) {
      var o = n((i = Bn(i)).h, (u = Bn(u)).h), a = pn(i.s, u.s), s = pn(i.l, u.l), c = pn(i.opacity, u.opacity);
      return function(l) {
        return i.h = o(l), i.s = a(l), i.l = s(Math.pow(l, e)), i.opacity = c(l), i + "";
      };
    }
    return r.gamma = t, r;
  }(1);
}
const mg = ll(_a);
var fu = ll(pn);
function _g(n, t) {
  for (var e = new Array(t), r = 0; r < t; ++r) e[r] = n(r / (t - 1));
  return e;
}
var fe = 0, Le = 0, Ne = 0, hl = 1e3, wi, De, xi = 0, Ot = 0, lu = 0, cr = typeof performance == "object" && performance.now ? performance : Date, pl = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(n) {
  setTimeout(n, 17);
};
function we() {
  return Ot || (pl(wg), Ot = cr.now() + lu);
}
function wg() {
  Ot = 0;
}
function fr() {
  this._call = this._time = this._next = null;
}
fr.prototype = hu.prototype = {
  constructor: fr,
  restart: function(n, t, e) {
    if (typeof n != "function") throw new TypeError("callback is not a function");
    e = (e == null ? we() : +e) + (t == null ? 0 : +t), !this._next && De !== this && (De ? De._next = this : wi = this, De = this), this._call = n, this._time = e, Mo();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, Mo());
  }
};
function hu(n, t, e) {
  var r = new fr();
  return r.restart(n, t, e), r;
}
function gl() {
  we(), ++fe;
  for (var n = wi, t; n; )
    (t = Ot - n._time) >= 0 && n._call.call(null, t), n = n._next;
  --fe;
}
function Os() {
  Ot = (xi = cr.now()) + lu, fe = Le = 0;
  try {
    gl();
  } finally {
    fe = 0, bg(), Ot = 0;
  }
}
function xg() {
  var n = cr.now(), t = n - xi;
  t > hl && (lu -= t, xi = n);
}
function bg() {
  for (var n, t = wi, e, r = 1 / 0; t; )
    t._call ? (r > t._time && (r = t._time), n = t, t = t._next) : (e = t._next, t._next = null, t = n ? n._next = e : wi = e);
  De = n, Mo(r);
}
function Mo(n) {
  if (!fe) {
    Le && (Le = clearTimeout(Le));
    var t = n - Ot;
    t > 24 ? (n < 1 / 0 && (Le = setTimeout(Os, n - cr.now() - lu)), Ne && (Ne = clearInterval(Ne))) : (Ne || (xi = cr.now(), Ne = setInterval(xg, hl)), fe = 1, pl(Os));
  }
}
function So(n, t, e) {
  var r = new fr();
  return t = t == null ? 0 : +t, r.restart(function(i) {
    r.stop(), n(i + t);
  }, t, e), r;
}
function Mg(n, t, e) {
  var r = new fr(), i = t;
  return t == null ? (r.restart(n, t, e), r) : (t = +t, e = e == null ? we() : +e, r.restart(function u(o) {
    o += i, r.restart(u, i += t, e), n(o);
  }, t, e), r);
}
var Sg = xt("start", "end", "interrupt"), Tg = [], dl = 0, To = 1, bi = 2, Yu = 3, Us = 4, No = 5, ai = 6;
function pu(n, t, e, r, i, u) {
  var o = n.__transition;
  if (!o) n.__transition = {};
  else if (e in o) return;
  Ng(n, e, {
    name: t,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: Sg,
    tween: Tg,
    time: u.time,
    delay: u.delay,
    duration: u.duration,
    ease: u.ease,
    timer: null,
    state: dl
  });
}
function xa(n, t) {
  var e = Xn(n, t);
  if (e.state > dl) throw new Error("too late; already scheduled");
  return e;
}
function Bt(n, t) {
  var e = Xn(n, t);
  if (e.state > bi) throw new Error("too late; already started");
  return e;
}
function Xn(n, t) {
  var e = n.__transition;
  if (!e || !(e = e[t])) throw new Error("transition not found");
  return e;
}
function Ng(n, t, e) {
  var r = n.__transition, i;
  r[t] = e, e.timer = hu(u, 0, e.time);
  function u(c) {
    e.state = To, e.timer.restart(o, e.delay, e.time), e.delay <= c && o(c - e.delay);
  }
  function o(c) {
    var l, h, f, p;
    if (e.state !== To) return s();
    for (l in r)
      if (p = r[l], p.name === e.name) {
        if (p.state === Yu) return So(o);
        p.state === Us ? (p.state = ai, p.timer.stop(), p.on.call("interrupt", n, n.__data__, p.index, p.group), delete r[l]) : +l < t && (p.state = ai, p.timer.stop(), delete r[l]);
      }
    if (So(function() {
      e.state === Yu && (e.state = Us, e.timer.restart(a, e.delay, e.time), a(c));
    }), e.state = bi, e.on.call("start", n, n.__data__, e.index, e.group), e.state === bi) {
      for (e.state = Yu, i = new Array(f = e.tween.length), l = 0, h = -1; l < f; ++l)
        (p = e.tween[l].value.call(n, n.__data__, e.index, e.group)) && (i[++h] = p);
      i.length = h + 1;
    }
  }
  function a(c) {
    for (var l = c < e.duration ? e.ease.call(null, c / e.duration) : (e.timer.restart(s), e.state = No, 1), h = -1, f = i.length; ++h < f; )
      i[h].call(null, l);
    e.state === No && (e.on.call("end", n, n.__data__, e.index, e.group), s());
  }
  function s() {
    e.state = ai, e.timer.stop(), delete r[t];
    for (var c in r) return;
    delete n.__transition;
  }
}
function Pt(n, t) {
  var e = n.__transition, r, i, u = !0, o;
  if (e) {
    t = t == null ? null : t + "";
    for (o in e) {
      if ((r = e[o]).name !== t) {
        u = !1;
        continue;
      }
      i = r.state > bi && r.state < No, r.state = ai, r.timer.stop(), i && r.on.call("interrupt", n, n.__data__, r.index, r.group), delete e[o];
    }
    u && delete n.__transition;
  }
}
function Eg(n) {
  return this.each(function() {
    Pt(this, n);
  });
}
function kg(n, t) {
  var e, r;
  return function() {
    var i = Bt(this, n), u = i.tween;
    if (u !== e) {
      r = e = u;
      for (var o = 0, a = r.length; o < a; ++o)
        if (r[o].name === t) {
          r = r.slice(), r.splice(o, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function Cg(n, t, e) {
  var r, i;
  if (typeof e != "function") throw new Error();
  return function() {
    var u = Bt(this, n), o = u.tween;
    if (o !== r) {
      i = (r = o).slice();
      for (var a = { name: t, value: e }, s = 0, c = i.length; s < c; ++s)
        if (i[s].name === t) {
          i[s] = a;
          break;
        }
      s === c && i.push(a);
    }
    u.tween = i;
  };
}
function Ag(n, t) {
  var e = this._id;
  if (n += "", arguments.length < 2) {
    for (var r = Xn(this.node(), e).tween, i = 0, u = r.length, o; i < u; ++i)
      if ((o = r[i]).name === n)
        return o.value;
    return null;
  }
  return this.each((t == null ? kg : Cg)(e, n, t));
}
function ba(n, t, e) {
  var r = n._id;
  return n.each(function() {
    var i = Bt(this, r);
    (i.value || (i.value = {}))[t] = e.apply(this, arguments);
  }), function(i) {
    return Xn(i, r).value[t];
  };
}
function vl(n, t) {
  var e;
  return (typeof t == "number" ? $n : t instanceof yt ? sr : (e = yt(t)) ? (t = e, sr) : wa)(n, t);
}
function Rg(n) {
  return function() {
    this.removeAttribute(n);
  };
}
function $g(n) {
  return function() {
    this.removeAttributeNS(n.space, n.local);
  };
}
function Pg(n, t, e) {
  var r, i;
  return function() {
    var u = this.getAttribute(n);
    return u === e ? null : u === r ? i : i = t(r = u, e);
  };
}
function zg(n, t, e) {
  var r, i;
  return function() {
    var u = this.getAttributeNS(n.space, n.local);
    return u === e ? null : u === r ? i : i = t(r = u, e);
  };
}
function Ig(n, t, e) {
  var r, i, u;
  return function() {
    var o, a = e(this);
    return a == null ? void this.removeAttribute(n) : (o = this.getAttribute(n), o === a ? null : o === r && a === i ? u : u = t(r = o, i = a));
  };
}
function Lg(n, t, e) {
  var r, i, u;
  return function() {
    var o, a = e(this);
    return a == null ? void this.removeAttributeNS(n.space, n.local) : (o = this.getAttributeNS(n.space, n.local), o === a ? null : o === r && a === i ? u : u = t(r = o, i = a));
  };
}
function Dg(n, t) {
  var e = Tr(n), r = e === "transform" ? al : vl;
  return this.attrTween(n, typeof t == "function" ? (e.local ? Lg : Ig)(e, r, ba(this, "attr." + n, t)) : t == null ? (e.local ? $g : Rg)(e) : (e.local ? zg : Pg)(e, r, t + ""));
}
function Og(n, t) {
  function e() {
    var r = this, i = t.apply(r, arguments);
    return i && function(u) {
      r.setAttributeNS(n.space, n.local, i(u));
    };
  }
  return e._value = t, e;
}
function Ug(n, t) {
  function e() {
    var r = this, i = t.apply(r, arguments);
    return i && function(u) {
      r.setAttribute(n, i(u));
    };
  }
  return e._value = t, e;
}
function Fg(n, t) {
  var e = "attr." + n;
  if (arguments.length < 2) return (e = this.tween(e)) && e._value;
  if (t == null) return this.tween(e, null);
  if (typeof t != "function") throw new Error();
  var r = Tr(n);
  return this.tween(e, (r.local ? Og : Ug)(r, t));
}
function Yg(n, t) {
  return function() {
    xa(this, n).delay = +t.apply(this, arguments);
  };
}
function qg(n, t) {
  return t = +t, function() {
    xa(this, n).delay = t;
  };
}
function Hg(n) {
  var t = this._id;
  return arguments.length ? this.each((typeof n == "function" ? Yg : qg)(t, n)) : Xn(this.node(), t).delay;
}
function Bg(n, t) {
  return function() {
    Bt(this, n).duration = +t.apply(this, arguments);
  };
}
function Xg(n, t) {
  return t = +t, function() {
    Bt(this, n).duration = t;
  };
}
function Wg(n) {
  var t = this._id;
  return arguments.length ? this.each((typeof n == "function" ? Bg : Xg)(t, n)) : Xn(this.node(), t).duration;
}
function Vg(n, t) {
  if (typeof t != "function") throw new Error();
  return function() {
    Bt(this, n).ease = t;
  };
}
function Zg(n) {
  var t = this._id;
  return arguments.length ? this.each(Vg(t, n)) : Xn(this.node(), t).ease;
}
function Gg(n) {
  typeof n != "function" && (n = fa(n));
  for (var t = this._groups, e = t.length, r = new Array(e), i = 0; i < e; ++i)
    for (var u = t[i], o = u.length, a = r[i] = [], s, c = 0; c < o; ++c)
      (s = u[c]) && n.call(s, s.__data__, c, u) && a.push(s);
  return new Kn(r, this._parents, this._name, this._id);
}
function Qg(n) {
  if (n._id !== this._id) throw new Error();
  for (var t = this._groups, e = n._groups, r = t.length, i = e.length, u = Math.min(r, i), o = new Array(r), a = 0; a < u; ++a)
    for (var s = t[a], c = e[a], l = s.length, h = o[a] = new Array(l), f, p = 0; p < l; ++p)
      (f = s[p] || c[p]) && (h[p] = f);
  for (; a < r; ++a)
    o[a] = t[a];
  return new Kn(o, this._parents, this._name, this._id);
}
function Kg(n) {
  return (n + "").trim().split(/^|\s+/).every(function(t) {
    var e = t.indexOf(".");
    return e >= 0 && (t = t.slice(0, e)), !t || t === "start";
  });
}
function Jg(n, t, e) {
  var r, i, u = Kg(t) ? xa : Bt;
  return function() {
    var o = u(this, n), a = o.on;
    a !== r && (i = (r = a).copy()).on(t, e), o.on = i;
  };
}
function jg(n, t) {
  var e = this._id;
  return arguments.length < 2 ? Xn(this.node(), e).on.on(n) : this.each(Jg(e, n, t));
}
function nd(n) {
  return function() {
    var t = this.parentNode;
    for (var e in this.__transition) if (+e !== n) return;
    t && t.removeChild(this);
  };
}
function td() {
  return this.on("end.remove", nd(this._id));
}
function ed(n) {
  var t = this._name, e = this._id;
  typeof n != "function" && (n = iu(n));
  for (var r = this._groups, i = r.length, u = new Array(i), o = 0; o < i; ++o)
    for (var a = r[o], s = a.length, c = u[o] = new Array(s), l, h, f = 0; f < s; ++f)
      (l = a[f]) && (h = n.call(l, l.__data__, f, a)) && ("__data__" in l && (h.__data__ = l.__data__), c[f] = h, pu(c[f], t, e, f, c, Xn(l, e)));
  return new Kn(u, this._parents, t, e);
}
function rd(n) {
  var t = this._name, e = this._id;
  typeof n != "function" && (n = ca(n));
  for (var r = this._groups, i = r.length, u = [], o = [], a = 0; a < i; ++a)
    for (var s = r[a], c = s.length, l, h = 0; h < c; ++h)
      if (l = s[h]) {
        for (var f = n.call(l, l.__data__, h, s), p, g = Xn(l, e), d = 0, v = f.length; d < v; ++d)
          (p = f[d]) && pu(p, t, e, d, f, g);
        u.push(f), o.push(l);
      }
  return new Kn(u, o, t, e);
}
var id = Ht.prototype.constructor;
function ud() {
  return new id(this._groups, this._parents);
}
function od(n, t) {
  var e, r, i;
  return function() {
    var u = Lt(this, n), o = (this.style.removeProperty(n), Lt(this, n));
    return u === o ? null : u === e && o === r ? i : i = t(e = u, r = o);
  };
}
function ad(n) {
  return function() {
    this.style.removeProperty(n);
  };
}
function sd(n, t, e) {
  var r, i;
  return function() {
    var u = Lt(this, n);
    return u === e ? null : u === r ? i : i = t(r = u, e);
  };
}
function cd(n, t, e) {
  var r, i, u;
  return function() {
    var o = Lt(this, n), a = e(this);
    return a == null && (a = (this.style.removeProperty(n), Lt(this, n))), o === a ? null : o === r && a === i ? u : u = t(r = o, i = a);
  };
}
function fd(n, t, e) {
  var r = (n += "") == "transform" ? ol : vl;
  return t == null ? this.styleTween(n, od(n, r)).on("end.style." + n, ad(n)) : this.styleTween(n, typeof t == "function" ? cd(n, r, ba(this, "style." + n, t)) : sd(n, r, t + ""), e);
}
function ld(n, t, e) {
  function r() {
    var i = this, u = t.apply(i, arguments);
    return u && function(o) {
      i.style.setProperty(n, u(o), e);
    };
  }
  return r._value = t, r;
}
function hd(n, t, e) {
  var r = "style." + (n += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (t == null) return this.tween(r, null);
  if (typeof t != "function") throw new Error();
  return this.tween(r, ld(n, t, e ?? ""));
}
function pd(n) {
  return function() {
    this.textContent = n;
  };
}
function gd(n) {
  return function() {
    var t = n(this);
    this.textContent = t ?? "";
  };
}
function dd(n) {
  return this.tween("text", typeof n == "function" ? gd(ba(this, "text", n)) : pd(n == null ? "" : n + ""));
}
function vd() {
  for (var n = this._name, t = this._id, e = ml(), r = this._groups, i = r.length, u = 0; u < i; ++u)
    for (var o = r[u], a = o.length, s, c = 0; c < a; ++c)
      if (s = o[c]) {
        var l = Xn(s, t);
        pu(s, n, e, c, o, {
          time: l.time + l.delay + l.duration,
          delay: 0,
          duration: l.duration,
          ease: l.ease
        });
      }
  return new Kn(r, this._parents, n, e);
}
var yd = 0;
function Kn(n, t, e, r) {
  this._groups = n, this._parents = t, this._name = e, this._id = r;
}
function yl(n) {
  return Ht().transition(n);
}
function ml() {
  return ++yd;
}
var Vt = Ht.prototype;
Kn.prototype = yl.prototype = {
  constructor: Kn,
  select: ed,
  selectAll: rd,
  filter: Gg,
  merge: Qg,
  selection: ud,
  transition: vd,
  call: Vt.call,
  nodes: Vt.nodes,
  node: Vt.node,
  size: Vt.size,
  empty: Vt.empty,
  each: Vt.each,
  on: jg,
  attr: Dg,
  attrTween: Fg,
  style: fd,
  styleTween: hd,
  text: dd,
  remove: td,
  tween: Ag,
  delay: Hg,
  duration: Wg,
  ease: Zg
};
function md(n) {
  return +n;
}
function _d(n) {
  return n * n;
}
function wd(n) {
  return n * (2 - n);
}
function Fs(n) {
  return ((n *= 2) <= 1 ? n * n : --n * (2 - n) + 1) / 2;
}
function xd(n) {
  return n * n * n;
}
function bd(n) {
  return --n * n * n + 1;
}
function Eo(n) {
  return ((n *= 2) <= 1 ? n * n * n : (n -= 2) * n * n + 2) / 2;
}
var Ma = 3, Md = function n(t) {
  t = +t;
  function e(r) {
    return Math.pow(r, t);
  }
  return e.exponent = n, e;
}(Ma), Sd = function n(t) {
  t = +t;
  function e(r) {
    return 1 - Math.pow(1 - r, t);
  }
  return e.exponent = n, e;
}(Ma), Ys = function n(t) {
  t = +t;
  function e(r) {
    return ((r *= 2) <= 1 ? Math.pow(r, t) : 2 - Math.pow(2 - r, t)) / 2;
  }
  return e.exponent = n, e;
}(Ma), _l = Math.PI, wl = _l / 2;
function Td(n) {
  return 1 - Math.cos(n * wl);
}
function Nd(n) {
  return Math.sin(n * wl);
}
function qs(n) {
  return (1 - Math.cos(_l * n)) / 2;
}
function Ed(n) {
  return Math.pow(2, 10 * n - 10);
}
function kd(n) {
  return 1 - Math.pow(2, -10 * n);
}
function Hs(n) {
  return ((n *= 2) <= 1 ? Math.pow(2, 10 * n - 10) : 2 - Math.pow(2, 10 - 10 * n)) / 2;
}
function Cd(n) {
  return 1 - Math.sqrt(1 - n * n);
}
function Ad(n) {
  return Math.sqrt(1 - --n * n);
}
function Bs(n) {
  return ((n *= 2) <= 1 ? 1 - Math.sqrt(1 - n * n) : Math.sqrt(1 - (n -= 2) * n) + 1) / 2;
}
var ko = 4 / 11, Rd = 6 / 11, $d = 8 / 11, Pd = 3 / 4, zd = 9 / 11, Id = 10 / 11, Ld = 15 / 16, Dd = 21 / 22, Od = 63 / 64, Ur = 1 / ko / ko;
function Ud(n) {
  return 1 - lr(1 - n);
}
function lr(n) {
  return (n = +n) < ko ? Ur * n * n : n < $d ? Ur * (n -= Rd) * n + Pd : n < Id ? Ur * (n -= zd) * n + Ld : Ur * (n -= Dd) * n + Od;
}
function Fd(n) {
  return ((n *= 2) <= 1 ? 1 - lr(1 - n) : lr(n - 1) + 1) / 2;
}
var Sa = 1.70158, Yd = function n(t) {
  t = +t;
  function e(r) {
    return r * r * ((t + 1) * r - t);
  }
  return e.overshoot = n, e;
}(Sa), qd = function n(t) {
  t = +t;
  function e(r) {
    return --r * r * ((t + 1) * r + t) + 1;
  }
  return e.overshoot = n, e;
}(Sa), Xs = function n(t) {
  t = +t;
  function e(r) {
    return ((r *= 2) < 1 ? r * r * ((t + 1) * r - t) : (r -= 2) * r * ((t + 1) * r + t) + 2) / 2;
  }
  return e.overshoot = n, e;
}(Sa), le = 2 * Math.PI, Ta = 1, Na = 0.3, Hd = function n(t, e) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (e /= le);
  function i(u) {
    return t * Math.pow(2, 10 * --u) * Math.sin((r - u) / e);
  }
  return i.amplitude = function(u) {
    return n(u, e * le);
  }, i.period = function(u) {
    return n(t, u);
  }, i;
}(Ta, Na), Ws = function n(t, e) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (e /= le);
  function i(u) {
    return 1 - t * Math.pow(2, -10 * (u = +u)) * Math.sin((u + r) / e);
  }
  return i.amplitude = function(u) {
    return n(u, e * le);
  }, i.period = function(u) {
    return n(t, u);
  }, i;
}(Ta, Na), Bd = function n(t, e) {
  var r = Math.asin(1 / (t = Math.max(1, t))) * (e /= le);
  function i(u) {
    return ((u = u * 2 - 1) < 0 ? t * Math.pow(2, 10 * u) * Math.sin((r - u) / e) : 2 - t * Math.pow(2, -10 * u) * Math.sin((r + u) / e)) / 2;
  }
  return i.amplitude = function(u) {
    return n(u, e * le);
  }, i.period = function(u) {
    return n(t, u);
  }, i;
}(Ta, Na), Co = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: Eo
};
function Xd(n, t) {
  for (var e; !(e = n.__transition) || !(e = e[t]); )
    if (!(n = n.parentNode))
      return Co.time = we(), Co;
  return e;
}
function Wd(n) {
  var t, e;
  n instanceof Kn ? (t = n._id, n = n._name) : (t = ml(), (e = Co).time = we(), n = n == null ? null : n + "");
  for (var r = this._groups, i = r.length, u = 0; u < i; ++u)
    for (var o = r[u], a = o.length, s, c = 0; c < a; ++c)
      (s = o[c]) && pu(s, n, t, c, o, e || Xd(s, t));
  return new Kn(r, this._parents, n, t);
}
Ht.prototype.interrupt = Eg;
Ht.prototype.transition = Wd;
var Vd = [null];
function Zd(n, t) {
  var e = n.__transition, r, i;
  if (e) {
    t = t == null ? null : t + "";
    for (i in e)
      if ((r = e[i]).state > To && r.name === t)
        return new Kn([[n]], Vd, t, +i);
  }
  return null;
}
function Vs(n) {
  return function() {
    return n;
  };
}
function Gd(n, t, e) {
  this.target = n, this.type = t, this.selection = e;
}
function Zs() {
  L.stopImmediatePropagation();
}
function Fr() {
  L.preventDefault(), L.stopImmediatePropagation();
}
var Gs = {}, qu = { name: "space" }, Zt = { name: "handle" }, Gt = { name: "center" }, si = {
  name: "x",
  handles: ["e", "w"].map(hr),
  input: function(n, t) {
    return n && [[n[0], t[0][1]], [n[1], t[1][1]]];
  },
  output: function(n) {
    return n && [n[0][0], n[1][0]];
  }
}, ci = {
  name: "y",
  handles: ["n", "s"].map(hr),
  input: function(n, t) {
    return n && [[t[0][0], n[0]], [t[1][0], n[1]]];
  },
  output: function(n) {
    return n && [n[0][1], n[1][1]];
  }
}, Qd = {
  name: "xy",
  handles: ["n", "e", "s", "w", "nw", "ne", "se", "sw"].map(hr),
  input: function(n) {
    return n;
  },
  output: function(n) {
    return n;
  }
}, nt = {
  overlay: "crosshair",
  selection: "move",
  n: "ns-resize",
  e: "ew-resize",
  s: "ns-resize",
  w: "ew-resize",
  nw: "nwse-resize",
  ne: "nesw-resize",
  se: "nwse-resize",
  sw: "nesw-resize"
}, Qs = {
  e: "w",
  w: "e",
  nw: "ne",
  ne: "nw",
  se: "sw",
  sw: "se"
}, Ks = {
  n: "s",
  s: "n",
  nw: "sw",
  ne: "se",
  se: "ne",
  sw: "nw"
}, Kd = {
  overlay: 1,
  selection: 1,
  n: null,
  e: 1,
  s: null,
  w: -1,
  nw: -1,
  ne: 1,
  se: 1,
  sw: -1
}, Jd = {
  overlay: 1,
  selection: 1,
  n: -1,
  e: null,
  s: 1,
  w: null,
  nw: -1,
  ne: -1,
  se: 1,
  sw: 1
};
function hr(n) {
  return { type: n };
}
function jd() {
  return !L.button;
}
function nv() {
  var n = this.ownerSVGElement || this;
  return [[0, 0], [n.width.baseVal.value, n.height.baseVal.value]];
}
function Hu(n) {
  for (; !n.__brush; ) if (!(n = n.parentNode)) return;
  return n.__brush;
}
function Bu(n) {
  return n[0][0] === n[1][0] || n[0][1] === n[1][1];
}
function tv(n) {
  var t = n.__brush;
  return t ? t.dim.output(t.selection) : null;
}
function ev() {
  return Ea(si);
}
function rv() {
  return Ea(ci);
}
function iv() {
  return Ea(Qd);
}
function Ea(n) {
  var t = nv, e = jd, r = xt(o, "start", "brush", "end"), i = 6, u;
  function o(f) {
    var p = f.property("__brush", h).selectAll(".overlay").data([hr("overlay")]);
    p.enter().append("rect").attr("class", "overlay").attr("pointer-events", "all").attr("cursor", nt.overlay).merge(p).each(function() {
      var d = Hu(this).extent;
      kn(this).attr("x", d[0][0]).attr("y", d[0][1]).attr("width", d[1][0] - d[0][0]).attr("height", d[1][1] - d[0][1]);
    }), f.selectAll(".selection").data([hr("selection")]).enter().append("rect").attr("class", "selection").attr("cursor", nt.selection).attr("fill", "#777").attr("fill-opacity", 0.3).attr("stroke", "#fff").attr("shape-rendering", "crispEdges");
    var g = f.selectAll(".handle").data(n.handles, function(d) {
      return d.type;
    });
    g.exit().remove(), g.enter().append("rect").attr("class", function(d) {
      return "handle handle--" + d.type;
    }).attr("cursor", function(d) {
      return nt[d.type];
    }), f.each(a).attr("fill", "none").attr("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush touchstart.brush", l);
  }
  o.move = function(f, p) {
    f.selection ? f.on("start.brush", function() {
      s(this, arguments).beforestart().start();
    }).on("interrupt.brush end.brush", function() {
      s(this, arguments).end();
    }).tween("brush", function() {
      var g = this, d = g.__brush, v = s(g, arguments), y = d.selection, x = n.input(typeof p == "function" ? p.apply(this, arguments) : p, d.extent), m = Er(y, x);
      function w(M) {
        d.selection = M === 1 && Bu(x) ? null : m(M), a.call(g), v.brush();
      }
      return y && x ? w : w(1);
    }) : f.each(function() {
      var g = this, d = arguments, v = g.__brush, y = n.input(typeof p == "function" ? p.apply(g, d) : p, v.extent), x = s(g, d).beforestart();
      Pt(g), v.selection = y == null || Bu(y) ? null : y, a.call(g), x.start().brush().end();
    });
  };
  function a() {
    var f = kn(this), p = Hu(this).selection;
    p ? (f.selectAll(".selection").style("display", null).attr("x", p[0][0]).attr("y", p[0][1]).attr("width", p[1][0] - p[0][0]).attr("height", p[1][1] - p[0][1]), f.selectAll(".handle").style("display", null).attr("x", function(g) {
      return g.type[g.type.length - 1] === "e" ? p[1][0] - i / 2 : p[0][0] - i / 2;
    }).attr("y", function(g) {
      return g.type[0] === "s" ? p[1][1] - i / 2 : p[0][1] - i / 2;
    }).attr("width", function(g) {
      return g.type === "n" || g.type === "s" ? p[1][0] - p[0][0] + i : i;
    }).attr("height", function(g) {
      return g.type === "e" || g.type === "w" ? p[1][1] - p[0][1] + i : i;
    })) : f.selectAll(".selection,.handle").style("display", "none").attr("x", null).attr("y", null).attr("width", null).attr("height", null);
  }
  function s(f, p) {
    return f.__brush.emitter || new c(f, p);
  }
  function c(f, p) {
    this.that = f, this.args = p, this.state = f.__brush, this.active = 0;
  }
  c.prototype = {
    beforestart: function() {
      return ++this.active === 1 && (this.state.emitter = this, this.starting = !0), this;
    },
    start: function() {
      return this.starting && (this.starting = !1, this.emit("start")), this;
    },
    brush: function() {
      return this.emit("brush"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.state.emitter, this.emit("end")), this;
    },
    emit: function(f) {
      ir(new Gd(o, f, n.output(this.state.selection)), r.apply, r, [f, this.that, this.args]);
    }
  };
  function l() {
    if (L.touches) {
      if (L.changedTouches.length < L.touches.length) return Fr();
    } else if (u) return;
    if (!e.apply(this, arguments)) return;
    var f = this, p = L.target.__data__.type, g = (L.metaKey ? p = "overlay" : p) === "selection" ? Gs : L.altKey ? Gt : Zt, d = n === ci ? null : Kd[p], v = n === si ? null : Jd[p], y = Hu(f), x = y.extent, m = y.selection, w = x[0][0], M, N, S = x[0][1], E, T, $ = x[1][0], A, k, _ = x[1][1], b, C, R, P, q, Y = d && v && L.shiftKey, G, V, tn = ht(f), Q = tn, en = s(f, arguments).beforestart();
    p === "overlay" ? y.selection = m = [
      [M = n === ci ? w : tn[0], E = n === si ? S : tn[1]],
      [A = n === ci ? $ : M, b = n === si ? _ : E]
    ] : (M = m[0][0], E = m[0][1], A = m[1][0], b = m[1][1]), N = M, T = E, k = A, C = b;
    var K = kn(f).attr("pointer-events", "none"), wn = K.selectAll(".overlay").attr("cursor", nt[p]);
    if (L.touches)
      K.on("touchmove.brush", H, !0).on("touchend.brush touchcancel.brush", z, !0);
    else {
      var I = kn(L.view).on("keydown.brush", vn, !0).on("keyup.brush", J, !0).on("mousemove.brush", H, !0).on("mouseup.brush", z, !0);
      ou(L.view);
    }
    Zs(), Pt(f), a.call(f), en.start();
    function H() {
      var rn = ht(f);
      Y && !G && !V && (Math.abs(rn[0] - Q[0]) > Math.abs(rn[1] - Q[1]) ? V = !0 : G = !0), Q = rn, q = !0, Fr(), B();
    }
    function B() {
      var rn;
      switch (R = Q[0] - tn[0], P = Q[1] - tn[1], g) {
        case qu:
        case Gs: {
          d && (R = Math.max(w - M, Math.min($ - A, R)), N = M + R, k = A + R), v && (P = Math.max(S - E, Math.min(_ - b, P)), T = E + P, C = b + P);
          break;
        }
        case Zt: {
          d < 0 ? (R = Math.max(w - M, Math.min($ - M, R)), N = M + R, k = A) : d > 0 && (R = Math.max(w - A, Math.min($ - A, R)), N = M, k = A + R), v < 0 ? (P = Math.max(S - E, Math.min(_ - E, P)), T = E + P, C = b) : v > 0 && (P = Math.max(S - b, Math.min(_ - b, P)), T = E, C = b + P);
          break;
        }
        case Gt: {
          d && (N = Math.max(w, Math.min($, M - R * d)), k = Math.max(w, Math.min($, A + R * d))), v && (T = Math.max(S, Math.min(_, E - P * v)), C = Math.max(S, Math.min(_, b + P * v)));
          break;
        }
      }
      k < N && (d *= -1, rn = M, M = A, A = rn, rn = N, N = k, k = rn, p in Qs && wn.attr("cursor", nt[p = Qs[p]])), C < T && (v *= -1, rn = E, E = b, b = rn, rn = T, T = C, C = rn, p in Ks && wn.attr("cursor", nt[p = Ks[p]])), y.selection && (m = y.selection), G && (N = m[0][0], k = m[1][0]), V && (T = m[0][1], C = m[1][1]), (m[0][0] !== N || m[0][1] !== T || m[1][0] !== k || m[1][1] !== C) && (y.selection = [[N, T], [k, C]], a.call(f), en.brush());
    }
    function z() {
      if (Zs(), L.touches) {
        if (L.touches.length) return;
        u && clearTimeout(u), u = setTimeout(function() {
          u = null;
        }, 500), K.on("touchmove.brush touchend.brush touchcancel.brush", null);
      } else
        au(L.view, q), I.on("keydown.brush keyup.brush mousemove.brush mouseup.brush", null);
      K.attr("pointer-events", "all"), wn.attr("cursor", nt.overlay), y.selection && (m = y.selection), Bu(m) && (y.selection = null, a.call(f)), en.end();
    }
    function vn() {
      switch (L.keyCode) {
        case 16: {
          Y = d && v;
          break;
        }
        case 18: {
          g === Zt && (d && (A = k - R * d, M = N + R * d), v && (b = C - P * v, E = T + P * v), g = Gt, B());
          break;
        }
        case 32: {
          (g === Zt || g === Gt) && (d < 0 ? A = k - R : d > 0 && (M = N - R), v < 0 ? b = C - P : v > 0 && (E = T - P), g = qu, wn.attr("cursor", nt.selection), B());
          break;
        }
        default:
          return;
      }
      Fr();
    }
    function J() {
      switch (L.keyCode) {
        case 16: {
          Y && (G = V = Y = !1, B());
          break;
        }
        case 18: {
          g === Gt && (d < 0 ? A = k : d > 0 && (M = N), v < 0 ? b = C : v > 0 && (E = T), g = Zt, B());
          break;
        }
        case 32: {
          g === qu && (L.altKey ? (d && (A = k - R * d, M = N + R * d), v && (b = C - P * v, E = T + P * v), g = Gt) : (d < 0 ? A = k : d > 0 && (M = N), v < 0 ? b = C : v > 0 && (E = T), g = Zt), wn.attr("cursor", nt[p]), B());
          break;
        }
        default:
          return;
      }
      Fr();
    }
  }
  function h() {
    var f = this.__brush || { selection: null };
    return f.extent = t.apply(this, arguments), f.dim = n, f;
  }
  return o.extent = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : Vs([[+f[0][0], +f[0][1]], [+f[1][0], +f[1][1]]]), o) : t;
  }, o.filter = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : Vs(!!f), o) : e;
  }, o.handleSize = function(f) {
    return arguments.length ? (i = +f, o) : i;
  }, o.on = function() {
    var f = r.on.apply(r, arguments);
    return f === r ? o : f;
  }, o;
}
var Js = Math.cos, js = Math.sin, xl = Math.PI, Yr = xl / 2, nc = xl * 2, tc = Math.max;
function uv(n) {
  return function(t, e) {
    return n(
      t.source.value + t.target.value,
      e.source.value + e.target.value
    );
  };
}
function ov() {
  var n = 0, t = null, e = null, r = null;
  function i(u) {
    var o = u.length, a = [], s = qn(o), c = [], l = [], h = l.groups = new Array(o), f = new Array(o * o), p, g, d, v, y, x;
    for (p = 0, y = -1; ++y < o; ) {
      for (g = 0, x = -1; ++x < o; )
        g += u[y][x];
      a.push(g), c.push(qn(o)), p += g;
    }
    for (t && s.sort(function($, A) {
      return t(a[$], a[A]);
    }), e && c.forEach(function($, A) {
      $.sort(function(k, _) {
        return e(u[A][k], u[A][_]);
      });
    }), p = tc(0, nc - n * o) / p, v = p ? n : nc / o, g = 0, y = -1; ++y < o; ) {
      for (d = g, x = -1; ++x < o; ) {
        var m = s[y], w = c[m][x], M = u[m][w], N = g, S = g += M * p;
        f[w * o + m] = {
          index: m,
          subindex: w,
          startAngle: N,
          endAngle: S,
          value: M
        };
      }
      h[m] = {
        index: m,
        startAngle: d,
        endAngle: g,
        value: a[m]
      }, g += v;
    }
    for (y = -1; ++y < o; )
      for (x = y - 1; ++x < o; ) {
        var E = f[x * o + y], T = f[y * o + x];
        (E.value || T.value) && l.push(E.value < T.value ? { source: T, target: E } : { source: E, target: T });
      }
    return r ? l.sort(r) : l;
  }
  return i.padAngle = function(u) {
    return arguments.length ? (n = tc(0, u), i) : n;
  }, i.sortGroups = function(u) {
    return arguments.length ? (t = u, i) : t;
  }, i.sortSubgroups = function(u) {
    return arguments.length ? (e = u, i) : e;
  }, i.sortChords = function(u) {
    return arguments.length ? (u == null ? r = null : (r = uv(u))._ = u, i) : r && r._;
  }, i;
}
var av = Array.prototype.slice;
function Xu(n) {
  return function() {
    return n;
  };
}
var Ao = Math.PI, Ro = 2 * Ao, Ct = 1e-6, sv = Ro - Ct;
function $o() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null, this._ = "";
}
function Mt() {
  return new $o();
}
$o.prototype = Mt.prototype = {
  constructor: $o,
  moveTo: function(n, t) {
    this._ += "M" + (this._x0 = this._x1 = +n) + "," + (this._y0 = this._y1 = +t);
  },
  closePath: function() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
  },
  lineTo: function(n, t) {
    this._ += "L" + (this._x1 = +n) + "," + (this._y1 = +t);
  },
  quadraticCurveTo: function(n, t, e, r) {
    this._ += "Q" + +n + "," + +t + "," + (this._x1 = +e) + "," + (this._y1 = +r);
  },
  bezierCurveTo: function(n, t, e, r, i, u) {
    this._ += "C" + +n + "," + +t + "," + +e + "," + +r + "," + (this._x1 = +i) + "," + (this._y1 = +u);
  },
  arcTo: function(n, t, e, r, i) {
    n = +n, t = +t, e = +e, r = +r, i = +i;
    var u = this._x1, o = this._y1, a = e - n, s = r - t, c = u - n, l = o - t, h = c * c + l * l;
    if (i < 0) throw new Error("negative radius: " + i);
    if (this._x1 === null)
      this._ += "M" + (this._x1 = n) + "," + (this._y1 = t);
    else if (h > Ct) if (!(Math.abs(l * a - s * c) > Ct) || !i)
      this._ += "L" + (this._x1 = n) + "," + (this._y1 = t);
    else {
      var f = e - u, p = r - o, g = a * a + s * s, d = f * f + p * p, v = Math.sqrt(g), y = Math.sqrt(h), x = i * Math.tan((Ao - Math.acos((g + h - d) / (2 * v * y))) / 2), m = x / y, w = x / v;
      Math.abs(m - 1) > Ct && (this._ += "L" + (n + m * c) + "," + (t + m * l)), this._ += "A" + i + "," + i + ",0,0," + +(l * f > c * p) + "," + (this._x1 = n + w * a) + "," + (this._y1 = t + w * s);
    }
  },
  arc: function(n, t, e, r, i, u) {
    n = +n, t = +t, e = +e;
    var o = e * Math.cos(r), a = e * Math.sin(r), s = n + o, c = t + a, l = 1 ^ u, h = u ? r - i : i - r;
    if (e < 0) throw new Error("negative radius: " + e);
    this._x1 === null ? this._ += "M" + s + "," + c : (Math.abs(this._x1 - s) > Ct || Math.abs(this._y1 - c) > Ct) && (this._ += "L" + s + "," + c), e && (h < 0 && (h = h % Ro + Ro), h > sv ? this._ += "A" + e + "," + e + ",0,1," + l + "," + (n - o) + "," + (t - a) + "A" + e + "," + e + ",0,1," + l + "," + (this._x1 = s) + "," + (this._y1 = c) : h > Ct && (this._ += "A" + e + "," + e + ",0," + +(h >= Ao) + "," + l + "," + (this._x1 = n + e * Math.cos(i)) + "," + (this._y1 = t + e * Math.sin(i))));
  },
  rect: function(n, t, e, r) {
    this._ += "M" + (this._x0 = this._x1 = +n) + "," + (this._y0 = this._y1 = +t) + "h" + +e + "v" + +r + "h" + -e + "Z";
  },
  toString: function() {
    return this._;
  }
};
function cv(n) {
  return n.source;
}
function fv(n) {
  return n.target;
}
function lv(n) {
  return n.radius;
}
function hv(n) {
  return n.startAngle;
}
function pv(n) {
  return n.endAngle;
}
function gv() {
  var n = cv, t = fv, e = lv, r = hv, i = pv, u = null;
  function o() {
    var a, s = av.call(arguments), c = n.apply(this, s), l = t.apply(this, s), h = +e.apply(this, (s[0] = c, s)), f = r.apply(this, s) - Yr, p = i.apply(this, s) - Yr, g = h * Js(f), d = h * js(f), v = +e.apply(this, (s[0] = l, s)), y = r.apply(this, s) - Yr, x = i.apply(this, s) - Yr;
    if (u || (u = a = Mt()), u.moveTo(g, d), u.arc(0, 0, h, f, p), (f !== y || p !== x) && (u.quadraticCurveTo(0, 0, v * Js(y), v * js(y)), u.arc(0, 0, v, y, x)), u.quadraticCurveTo(0, 0, g, d), u.closePath(), a) return u = null, a + "" || null;
  }
  return o.radius = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : Xu(+a), o) : e;
  }, o.startAngle = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : Xu(+a), o) : r;
  }, o.endAngle = function(a) {
    return arguments.length ? (i = typeof a == "function" ? a : Xu(+a), o) : i;
  }, o.source = function(a) {
    return arguments.length ? (n = a, o) : n;
  }, o.target = function(a) {
    return arguments.length ? (t = a, o) : t;
  }, o.context = function(a) {
    return arguments.length ? (u = a ?? null, o) : u;
  }, o;
}
var On = "$";
function Mi() {
}
Mi.prototype = Jn.prototype = {
  constructor: Mi,
  has: function(n) {
    return On + n in this;
  },
  get: function(n) {
    return this[On + n];
  },
  set: function(n, t) {
    return this[On + n] = t, this;
  },
  remove: function(n) {
    var t = On + n;
    return t in this && delete this[t];
  },
  clear: function() {
    for (var n in this) n[0] === On && delete this[n];
  },
  keys: function() {
    var n = [];
    for (var t in this) t[0] === On && n.push(t.slice(1));
    return n;
  },
  values: function() {
    var n = [];
    for (var t in this) t[0] === On && n.push(this[t]);
    return n;
  },
  entries: function() {
    var n = [];
    for (var t in this) t[0] === On && n.push({ key: t.slice(1), value: this[t] });
    return n;
  },
  size: function() {
    var n = 0;
    for (var t in this) t[0] === On && ++n;
    return n;
  },
  empty: function() {
    for (var n in this) if (n[0] === On) return !1;
    return !0;
  },
  each: function(n) {
    for (var t in this) t[0] === On && n(this[t], t.slice(1), this);
  }
};
function Jn(n, t) {
  var e = new Mi();
  if (n instanceof Mi) n.each(function(a, s) {
    e.set(s, a);
  });
  else if (Array.isArray(n)) {
    var r = -1, i = n.length, u;
    if (t == null) for (; ++r < i; ) e.set(r, n[r]);
    else for (; ++r < i; ) e.set(t(u = n[r], r, n), u);
  } else if (n) for (var o in n) e.set(o, n[o]);
  return e;
}
function dv() {
  var n = [], t = [], e, r, i;
  function u(a, s, c, l) {
    if (s >= n.length)
      return e != null && a.sort(e), r != null ? r(a) : a;
    for (var h = -1, f = a.length, p = n[s++], g, d, v = Jn(), y, x = c(); ++h < f; )
      (y = v.get(g = p(d = a[h]) + "")) ? y.push(d) : v.set(g, [d]);
    return v.each(function(m, w) {
      l(x, w, u(m, s, c, l));
    }), x;
  }
  function o(a, s) {
    if (++s > n.length) return a;
    var c, l = t[s - 1];
    return r != null && s >= n.length ? c = a.entries() : (c = [], a.each(function(h, f) {
      c.push({ key: f, values: o(h, s) });
    })), l != null ? c.sort(function(h, f) {
      return l(h.key, f.key);
    }) : c;
  }
  return i = {
    object: function(a) {
      return u(a, 0, vv, yv);
    },
    map: function(a) {
      return u(a, 0, ec, rc);
    },
    entries: function(a) {
      return o(u(a, 0, ec, rc), 0);
    },
    key: function(a) {
      return n.push(a), i;
    },
    sortKeys: function(a) {
      return t[n.length - 1] = a, i;
    },
    sortValues: function(a) {
      return e = a, i;
    },
    rollup: function(a) {
      return r = a, i;
    }
  };
}
function vv() {
  return {};
}
function yv(n, t, e) {
  n[t] = e;
}
function ec() {
  return Jn();
}
function rc(n, t, e) {
  n.set(t, e);
}
function Si() {
}
var Et = Jn.prototype;
Si.prototype = bl.prototype = {
  constructor: Si,
  has: Et.has,
  add: function(n) {
    return n += "", this[On + n] = n, this;
  },
  remove: Et.remove,
  clear: Et.clear,
  values: Et.keys,
  size: Et.size,
  empty: Et.empty,
  each: Et.each
};
function bl(n, t) {
  var e = new Si();
  if (n instanceof Si) n.each(function(u) {
    e.add(u);
  });
  else if (n) {
    var r = -1, i = n.length;
    if (t == null) for (; ++r < i; ) e.add(n[r]);
    else for (; ++r < i; ) e.add(t(n[r], r, n));
  }
  return e;
}
function mv(n) {
  var t = [];
  for (var e in n) t.push(e);
  return t;
}
function _v(n) {
  var t = [];
  for (var e in n) t.push(n[e]);
  return t;
}
function wv(n) {
  var t = [];
  for (var e in n) t.push({ key: e, value: n[e] });
  return t;
}
var ic = {}, Wu = {}, Vu = 34, Ee = 10, Zu = 13;
function Ml(n) {
  return new Function("d", "return {" + n.map(function(t, e) {
    return JSON.stringify(t) + ": d[" + e + "]";
  }).join(",") + "}");
}
function xv(n, t) {
  var e = Ml(n);
  return function(r, i) {
    return t(e(r), i, n);
  };
}
function bv(n) {
  var t = /* @__PURE__ */ Object.create(null), e = [];
  return n.forEach(function(r) {
    for (var i in r)
      i in t || e.push(t[i] = i);
  }), e;
}
function ka(n) {
  var t = new RegExp('["' + n + `
\r]`), e = n.charCodeAt(0);
  function r(c, l) {
    var h, f, p = i(c, function(g, d) {
      if (h) return h(g, d - 1);
      f = g, h = l ? xv(g, l) : Ml(g);
    });
    return p.columns = f || [], p;
  }
  function i(c, l) {
    var h = [], f = c.length, p = 0, g = 0, d, v = f <= 0, y = !1;
    c.charCodeAt(f - 1) === Ee && --f, c.charCodeAt(f - 1) === Zu && --f;
    function x() {
      if (v) return Wu;
      if (y) return y = !1, ic;
      var w, M = p, N;
      if (c.charCodeAt(M) === Vu) {
        for (; p++ < f && c.charCodeAt(p) !== Vu || c.charCodeAt(++p) === Vu; ) ;
        return (w = p) >= f ? v = !0 : (N = c.charCodeAt(p++)) === Ee ? y = !0 : N === Zu && (y = !0, c.charCodeAt(p) === Ee && ++p), c.slice(M + 1, w - 1).replace(/""/g, '"');
      }
      for (; p < f; ) {
        if ((N = c.charCodeAt(w = p++)) === Ee) y = !0;
        else if (N === Zu)
          y = !0, c.charCodeAt(p) === Ee && ++p;
        else if (N !== e) continue;
        return c.slice(M, w);
      }
      return v = !0, c.slice(M, f);
    }
    for (; (d = x()) !== Wu; ) {
      for (var m = []; d !== ic && d !== Wu; ) m.push(d), d = x();
      l && (m = l(m, g++)) == null || h.push(m);
    }
    return h;
  }
  function u(c, l) {
    return l == null && (l = bv(c)), [l.map(s).join(n)].concat(c.map(function(h) {
      return l.map(function(f) {
        return s(h[f]);
      }).join(n);
    })).join(`
`);
  }
  function o(c) {
    return c.map(a).join(`
`);
  }
  function a(c) {
    return c.map(s).join(n);
  }
  function s(c) {
    return c == null ? "" : t.test(c += "") ? '"' + c.replace(/"/g, '""') + '"' : c;
  }
  return {
    parse: r,
    parseRows: i,
    format: u,
    formatRows: o
  };
}
var gu = ka(","), Sl = gu.parse, Mv = gu.parseRows, Sv = gu.format, Tv = gu.formatRows, du = ka("	"), Tl = du.parse, Nv = du.parseRows, Ev = du.format, kv = du.formatRows;
function Cv(n, t) {
  var e;
  n == null && (n = 0), t == null && (t = 0);
  function r() {
    var i, u = e.length, o, a = 0, s = 0;
    for (i = 0; i < u; ++i)
      o = e[i], a += o.x, s += o.y;
    for (a = a / u - n, s = s / u - t, i = 0; i < u; ++i)
      o = e[i], o.x -= a, o.y -= s;
  }
  return r.initialize = function(i) {
    e = i;
  }, r.x = function(i) {
    return arguments.length ? (n = +i, r) : n;
  }, r.y = function(i) {
    return arguments.length ? (t = +i, r) : t;
  }, r;
}
function fn(n) {
  return function() {
    return n;
  };
}
function pt() {
  return (Math.random() - 0.5) * 1e-6;
}
function Av(n) {
  var t = +this._x.call(null, n), e = +this._y.call(null, n);
  return Nl(this.cover(t, e), t, e, n);
}
function Nl(n, t, e, r) {
  if (isNaN(t) || isNaN(e)) return n;
  var i, u = n._root, o = { data: r }, a = n._x0, s = n._y0, c = n._x1, l = n._y1, h, f, p, g, d, v, y, x;
  if (!u) return n._root = o, n;
  for (; u.length; )
    if ((d = t >= (h = (a + c) / 2)) ? a = h : c = h, (v = e >= (f = (s + l) / 2)) ? s = f : l = f, i = u, !(u = u[y = v << 1 | d])) return i[y] = o, n;
  if (p = +n._x.call(null, u.data), g = +n._y.call(null, u.data), t === p && e === g) return o.next = u, i ? i[y] = o : n._root = o, n;
  do
    i = i ? i[y] = new Array(4) : n._root = new Array(4), (d = t >= (h = (a + c) / 2)) ? a = h : c = h, (v = e >= (f = (s + l) / 2)) ? s = f : l = f;
  while ((y = v << 1 | d) === (x = (g >= f) << 1 | p >= h));
  return i[x] = u, i[y] = o, n;
}
function Rv(n) {
  var t, e, r = n.length, i, u, o = new Array(r), a = new Array(r), s = 1 / 0, c = 1 / 0, l = -1 / 0, h = -1 / 0;
  for (e = 0; e < r; ++e)
    isNaN(i = +this._x.call(null, t = n[e])) || isNaN(u = +this._y.call(null, t)) || (o[e] = i, a[e] = u, i < s && (s = i), i > l && (l = i), u < c && (c = u), u > h && (h = u));
  for (l < s && (s = this._x0, l = this._x1), h < c && (c = this._y0, h = this._y1), this.cover(s, c).cover(l, h), e = 0; e < r; ++e)
    Nl(this, o[e], a[e], n[e]);
  return this;
}
function $v(n, t) {
  if (isNaN(n = +n) || isNaN(t = +t)) return this;
  var e = this._x0, r = this._y0, i = this._x1, u = this._y1;
  if (isNaN(e))
    i = (e = Math.floor(n)) + 1, u = (r = Math.floor(t)) + 1;
  else if (e > n || n > i || r > t || t > u) {
    var o = i - e, a = this._root, s, c;
    switch (c = (t < (r + u) / 2) << 1 | n < (e + i) / 2) {
      case 0: {
        do
          s = new Array(4), s[c] = a, a = s;
        while (o *= 2, i = e + o, u = r + o, n > i || t > u);
        break;
      }
      case 1: {
        do
          s = new Array(4), s[c] = a, a = s;
        while (o *= 2, e = i - o, u = r + o, e > n || t > u);
        break;
      }
      case 2: {
        do
          s = new Array(4), s[c] = a, a = s;
        while (o *= 2, i = e + o, r = u - o, n > i || r > t);
        break;
      }
      case 3: {
        do
          s = new Array(4), s[c] = a, a = s;
        while (o *= 2, e = i - o, r = u - o, e > n || r > t);
        break;
      }
    }
    this._root && this._root.length && (this._root = a);
  } else return this;
  return this._x0 = e, this._y0 = r, this._x1 = i, this._y1 = u, this;
}
function Pv() {
  var n = [];
  return this.visit(function(t) {
    if (!t.length) do
      n.push(t.data);
    while (t = t.next);
  }), n;
}
function zv(n) {
  return arguments.length ? this.cover(+n[0][0], +n[0][1]).cover(+n[1][0], +n[1][1]) : isNaN(this._x0) ? void 0 : [[this._x0, this._y0], [this._x1, this._y1]];
}
function Sn(n, t, e, r, i) {
  this.node = n, this.x0 = t, this.y0 = e, this.x1 = r, this.y1 = i;
}
function Iv(n, t, e) {
  var r, i = this._x0, u = this._y0, o, a, s, c, l = this._x1, h = this._y1, f = [], p = this._root, g, d;
  for (p && f.push(new Sn(p, i, u, l, h)), e == null ? e = 1 / 0 : (i = n - e, u = t - e, l = n + e, h = t + e, e *= e); g = f.pop(); )
    if (!(!(p = g.node) || (o = g.x0) > l || (a = g.y0) > h || (s = g.x1) < i || (c = g.y1) < u))
      if (p.length) {
        var v = (o + s) / 2, y = (a + c) / 2;
        f.push(
          new Sn(p[3], v, y, s, c),
          new Sn(p[2], o, y, v, c),
          new Sn(p[1], v, a, s, y),
          new Sn(p[0], o, a, v, y)
        ), (d = (t >= y) << 1 | n >= v) && (g = f[f.length - 1], f[f.length - 1] = f[f.length - 1 - d], f[f.length - 1 - d] = g);
      } else {
        var x = n - +this._x.call(null, p.data), m = t - +this._y.call(null, p.data), w = x * x + m * m;
        if (w < e) {
          var M = Math.sqrt(e = w);
          i = n - M, u = t - M, l = n + M, h = t + M, r = p.data;
        }
      }
  return r;
}
function Lv(n) {
  if (isNaN(l = +this._x.call(null, n)) || isNaN(h = +this._y.call(null, n))) return this;
  var t, e = this._root, r, i, u, o = this._x0, a = this._y0, s = this._x1, c = this._y1, l, h, f, p, g, d, v, y;
  if (!e) return this;
  if (e.length) for (; ; ) {
    if ((g = l >= (f = (o + s) / 2)) ? o = f : s = f, (d = h >= (p = (a + c) / 2)) ? a = p : c = p, t = e, !(e = e[v = d << 1 | g])) return this;
    if (!e.length) break;
    (t[v + 1 & 3] || t[v + 2 & 3] || t[v + 3 & 3]) && (r = t, y = v);
  }
  for (; e.data !== n; ) if (i = e, !(e = e.next)) return this;
  return (u = e.next) && delete e.next, i ? (u ? i.next = u : delete i.next, this) : t ? (u ? t[v] = u : delete t[v], (e = t[0] || t[1] || t[2] || t[3]) && e === (t[3] || t[2] || t[1] || t[0]) && !e.length && (r ? r[y] = e : this._root = e), this) : (this._root = u, this);
}
function Dv(n) {
  for (var t = 0, e = n.length; t < e; ++t) this.remove(n[t]);
  return this;
}
function Ov() {
  return this._root;
}
function Uv() {
  var n = 0;
  return this.visit(function(t) {
    if (!t.length) do
      ++n;
    while (t = t.next);
  }), n;
}
function Fv(n) {
  var t = [], e, r = this._root, i, u, o, a, s;
  for (r && t.push(new Sn(r, this._x0, this._y0, this._x1, this._y1)); e = t.pop(); )
    if (!n(r = e.node, u = e.x0, o = e.y0, a = e.x1, s = e.y1) && r.length) {
      var c = (u + a) / 2, l = (o + s) / 2;
      (i = r[3]) && t.push(new Sn(i, c, l, a, s)), (i = r[2]) && t.push(new Sn(i, u, l, c, s)), (i = r[1]) && t.push(new Sn(i, c, o, a, l)), (i = r[0]) && t.push(new Sn(i, u, o, c, l));
    }
  return this;
}
function Yv(n) {
  var t = [], e = [], r;
  for (this._root && t.push(new Sn(this._root, this._x0, this._y0, this._x1, this._y1)); r = t.pop(); ) {
    var i = r.node;
    if (i.length) {
      var u, o = r.x0, a = r.y0, s = r.x1, c = r.y1, l = (o + s) / 2, h = (a + c) / 2;
      (u = i[0]) && t.push(new Sn(u, o, a, l, h)), (u = i[1]) && t.push(new Sn(u, l, a, s, h)), (u = i[2]) && t.push(new Sn(u, o, h, l, c)), (u = i[3]) && t.push(new Sn(u, l, h, s, c));
    }
    e.push(r);
  }
  for (; r = e.pop(); )
    n(r.node, r.x0, r.y0, r.x1, r.y1);
  return this;
}
function qv(n) {
  return n[0];
}
function Hv(n) {
  return arguments.length ? (this._x = n, this) : this._x;
}
function Bv(n) {
  return n[1];
}
function Xv(n) {
  return arguments.length ? (this._y = n, this) : this._y;
}
function vu(n, t, e) {
  var r = new Ca(t ?? qv, e ?? Bv, NaN, NaN, NaN, NaN);
  return n == null ? r : r.addAll(n);
}
function Ca(n, t, e, r, i, u) {
  this._x = n, this._y = t, this._x0 = e, this._y0 = r, this._x1 = i, this._y1 = u, this._root = void 0;
}
function uc(n) {
  for (var t = { data: n.data }, e = t; n = n.next; ) e = e.next = { data: n.data };
  return t;
}
var En = vu.prototype = Ca.prototype;
En.copy = function() {
  var n = new Ca(this._x, this._y, this._x0, this._y0, this._x1, this._y1), t = this._root, e, r;
  if (!t) return n;
  if (!t.length) return n._root = uc(t), n;
  for (e = [{ source: t, target: n._root = new Array(4) }]; t = e.pop(); )
    for (var i = 0; i < 4; ++i)
      (r = t.source[i]) && (r.length ? e.push({ source: r, target: t.target[i] = new Array(4) }) : t.target[i] = uc(r));
  return n;
};
En.add = Av;
En.addAll = Rv;
En.cover = $v;
En.data = Pv;
En.extent = zv;
En.find = Iv;
En.remove = Lv;
En.removeAll = Dv;
En.root = Ov;
En.size = Uv;
En.visit = Fv;
En.visitAfter = Yv;
En.x = Hv;
En.y = Xv;
function Wv(n) {
  return n.x + n.vx;
}
function Vv(n) {
  return n.y + n.vy;
}
function Zv(n) {
  var t, e, r = 1, i = 1;
  typeof n != "function" && (n = fn(n == null ? 1 : +n));
  function u() {
    for (var s, c = t.length, l, h, f, p, g, d, v = 0; v < i; ++v)
      for (l = vu(t, Wv, Vv).visitAfter(o), s = 0; s < c; ++s)
        h = t[s], g = e[h.index], d = g * g, f = h.x + h.vx, p = h.y + h.vy, l.visit(y);
    function y(x, m, w, M, N) {
      var S = x.data, E = x.r, T = g + E;
      if (S) {
        if (S.index > h.index) {
          var $ = f - S.x - S.vx, A = p - S.y - S.vy, k = $ * $ + A * A;
          k < T * T && ($ === 0 && ($ = pt(), k += $ * $), A === 0 && (A = pt(), k += A * A), k = (T - (k = Math.sqrt(k))) / k * r, h.vx += ($ *= k) * (T = (E *= E) / (d + E)), h.vy += (A *= k) * T, S.vx -= $ * (T = 1 - T), S.vy -= A * T);
        }
        return;
      }
      return m > f + T || M < f - T || w > p + T || N < p - T;
    }
  }
  function o(s) {
    if (s.data) return s.r = e[s.data.index];
    for (var c = s.r = 0; c < 4; ++c)
      s[c] && s[c].r > s.r && (s.r = s[c].r);
  }
  function a() {
    if (t) {
      var s, c = t.length, l;
      for (e = new Array(c), s = 0; s < c; ++s) l = t[s], e[l.index] = +n(l, s, t);
    }
  }
  return u.initialize = function(s) {
    t = s, a();
  }, u.iterations = function(s) {
    return arguments.length ? (i = +s, u) : i;
  }, u.strength = function(s) {
    return arguments.length ? (r = +s, u) : r;
  }, u.radius = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : fn(+s), a(), u) : n;
  }, u;
}
function Gv(n) {
  return n.index;
}
function oc(n, t) {
  var e = n.get(t);
  if (!e) throw new Error("missing: " + t);
  return e;
}
function Qv(n) {
  var t = Gv, e = l, r, i = fn(30), u, o, a, s, c = 1;
  n == null && (n = []);
  function l(d) {
    return 1 / Math.min(a[d.source.index], a[d.target.index]);
  }
  function h(d) {
    for (var v = 0, y = n.length; v < c; ++v)
      for (var x = 0, m, w, M, N, S, E, T; x < y; ++x)
        m = n[x], w = m.source, M = m.target, N = M.x + M.vx - w.x - w.vx || pt(), S = M.y + M.vy - w.y - w.vy || pt(), E = Math.sqrt(N * N + S * S), E = (E - u[x]) / E * d * r[x], N *= E, S *= E, M.vx -= N * (T = s[x]), M.vy -= S * T, w.vx += N * (T = 1 - T), w.vy += S * T;
  }
  function f() {
    if (o) {
      var d, v = o.length, y = n.length, x = Jn(o, t), m;
      for (d = 0, a = new Array(v); d < y; ++d)
        m = n[d], m.index = d, typeof m.source != "object" && (m.source = oc(x, m.source)), typeof m.target != "object" && (m.target = oc(x, m.target)), a[m.source.index] = (a[m.source.index] || 0) + 1, a[m.target.index] = (a[m.target.index] || 0) + 1;
      for (d = 0, s = new Array(y); d < y; ++d)
        m = n[d], s[d] = a[m.source.index] / (a[m.source.index] + a[m.target.index]);
      r = new Array(y), p(), u = new Array(y), g();
    }
  }
  function p() {
    if (o)
      for (var d = 0, v = n.length; d < v; ++d)
        r[d] = +e(n[d], d, n);
  }
  function g() {
    if (o)
      for (var d = 0, v = n.length; d < v; ++d)
        u[d] = +i(n[d], d, n);
  }
  return h.initialize = function(d) {
    o = d, f();
  }, h.links = function(d) {
    return arguments.length ? (n = d, f(), h) : n;
  }, h.id = function(d) {
    return arguments.length ? (t = d, h) : t;
  }, h.iterations = function(d) {
    return arguments.length ? (c = +d, h) : c;
  }, h.strength = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : fn(+d), p(), h) : e;
  }, h.distance = function(d) {
    return arguments.length ? (i = typeof d == "function" ? d : fn(+d), g(), h) : i;
  }, h;
}
function Kv(n) {
  return n.x;
}
function Jv(n) {
  return n.y;
}
var jv = 10, ny = Math.PI * (3 - Math.sqrt(5));
function ty(n) {
  var t, e = 1, r = 1e-3, i = 1 - Math.pow(r, 1 / 300), u = 0, o = 0.6, a = Jn(), s = hu(l), c = xt("tick", "end");
  n == null && (n = []);
  function l() {
    h(), c.call("tick", t), e < r && (s.stop(), c.call("end", t));
  }
  function h() {
    var g, d = n.length, v;
    for (e += (u - e) * i, a.each(function(y) {
      y(e);
    }), g = 0; g < d; ++g)
      v = n[g], v.fx == null ? v.x += v.vx *= o : (v.x = v.fx, v.vx = 0), v.fy == null ? v.y += v.vy *= o : (v.y = v.fy, v.vy = 0);
  }
  function f() {
    for (var g = 0, d = n.length, v; g < d; ++g) {
      if (v = n[g], v.index = g, isNaN(v.x) || isNaN(v.y)) {
        var y = jv * Math.sqrt(g), x = g * ny;
        v.x = y * Math.cos(x), v.y = y * Math.sin(x);
      }
      (isNaN(v.vx) || isNaN(v.vy)) && (v.vx = v.vy = 0);
    }
  }
  function p(g) {
    return g.initialize && g.initialize(n), g;
  }
  return f(), t = {
    tick: h,
    restart: function() {
      return s.restart(l), t;
    },
    stop: function() {
      return s.stop(), t;
    },
    nodes: function(g) {
      return arguments.length ? (n = g, f(), a.each(p), t) : n;
    },
    alpha: function(g) {
      return arguments.length ? (e = +g, t) : e;
    },
    alphaMin: function(g) {
      return arguments.length ? (r = +g, t) : r;
    },
    alphaDecay: function(g) {
      return arguments.length ? (i = +g, t) : +i;
    },
    alphaTarget: function(g) {
      return arguments.length ? (u = +g, t) : u;
    },
    velocityDecay: function(g) {
      return arguments.length ? (o = 1 - g, t) : 1 - o;
    },
    force: function(g, d) {
      return arguments.length > 1 ? (d == null ? a.remove(g) : a.set(g, p(d)), t) : a.get(g);
    },
    find: function(g, d, v) {
      var y = 0, x = n.length, m, w, M, N, S;
      for (v == null ? v = 1 / 0 : v *= v, y = 0; y < x; ++y)
        N = n[y], m = g - N.x, w = d - N.y, M = m * m + w * w, M < v && (S = N, v = M);
      return S;
    },
    on: function(g, d) {
      return arguments.length > 1 ? (c.on(g, d), t) : c.on(g);
    }
  };
}
function ey() {
  var n, t, e, r = fn(-30), i, u = 1, o = 1 / 0, a = 0.81;
  function s(f) {
    var p, g = n.length, d = vu(n, Kv, Jv).visitAfter(l);
    for (e = f, p = 0; p < g; ++p) t = n[p], d.visit(h);
  }
  function c() {
    if (n) {
      var f, p = n.length, g;
      for (i = new Array(p), f = 0; f < p; ++f) g = n[f], i[g.index] = +r(g, f, n);
    }
  }
  function l(f) {
    var p = 0, g, d, v = 0, y, x, m;
    if (f.length) {
      for (y = x = m = 0; m < 4; ++m)
        (g = f[m]) && (d = Math.abs(g.value)) && (p += g.value, v += d, y += d * g.x, x += d * g.y);
      f.x = y / v, f.y = x / v;
    } else {
      g = f, g.x = g.data.x, g.y = g.data.y;
      do
        p += i[g.data.index];
      while (g = g.next);
    }
    f.value = p;
  }
  function h(f, p, g, d) {
    if (!f.value) return !0;
    var v = f.x - t.x, y = f.y - t.y, x = d - p, m = v * v + y * y;
    if (x * x / a < m)
      return m < o && (v === 0 && (v = pt(), m += v * v), y === 0 && (y = pt(), m += y * y), m < u && (m = Math.sqrt(u * m)), t.vx += v * f.value * e / m, t.vy += y * f.value * e / m), !0;
    if (f.length || m >= o) return;
    (f.data !== t || f.next) && (v === 0 && (v = pt(), m += v * v), y === 0 && (y = pt(), m += y * y), m < u && (m = Math.sqrt(u * m)));
    do
      f.data !== t && (x = i[f.data.index] * e / m, t.vx += v * x, t.vy += y * x);
    while (f = f.next);
  }
  return s.initialize = function(f) {
    n = f, c();
  }, s.strength = function(f) {
    return arguments.length ? (r = typeof f == "function" ? f : fn(+f), c(), s) : r;
  }, s.distanceMin = function(f) {
    return arguments.length ? (u = f * f, s) : Math.sqrt(u);
  }, s.distanceMax = function(f) {
    return arguments.length ? (o = f * f, s) : Math.sqrt(o);
  }, s.theta = function(f) {
    return arguments.length ? (a = f * f, s) : Math.sqrt(a);
  }, s;
}
function ry(n, t, e) {
  var r, i = fn(0.1), u, o;
  typeof n != "function" && (n = fn(+n)), t == null && (t = 0), e == null && (e = 0);
  function a(c) {
    for (var l = 0, h = r.length; l < h; ++l) {
      var f = r[l], p = f.x - t || 1e-6, g = f.y - e || 1e-6, d = Math.sqrt(p * p + g * g), v = (o[l] - d) * u[l] * c / d;
      f.vx += p * v, f.vy += g * v;
    }
  }
  function s() {
    if (r) {
      var c, l = r.length;
      for (u = new Array(l), o = new Array(l), c = 0; c < l; ++c)
        o[c] = +n(r[c], c, r), u[c] = isNaN(o[c]) ? 0 : +i(r[c], c, r);
    }
  }
  return a.initialize = function(c) {
    r = c, s();
  }, a.strength = function(c) {
    return arguments.length ? (i = typeof c == "function" ? c : fn(+c), s(), a) : i;
  }, a.radius = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : fn(+c), s(), a) : n;
  }, a.x = function(c) {
    return arguments.length ? (t = +c, a) : t;
  }, a.y = function(c) {
    return arguments.length ? (e = +c, a) : e;
  }, a;
}
function iy(n) {
  var t = fn(0.1), e, r, i;
  typeof n != "function" && (n = fn(n == null ? 0 : +n));
  function u(a) {
    for (var s = 0, c = e.length, l; s < c; ++s)
      l = e[s], l.vx += (i[s] - l.x) * r[s] * a;
  }
  function o() {
    if (e) {
      var a, s = e.length;
      for (r = new Array(s), i = new Array(s), a = 0; a < s; ++a)
        r[a] = isNaN(i[a] = +n(e[a], a, e)) ? 0 : +t(e[a], a, e);
    }
  }
  return u.initialize = function(a) {
    e = a, o();
  }, u.strength = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : fn(+a), o(), u) : t;
  }, u.x = function(a) {
    return arguments.length ? (n = typeof a == "function" ? a : fn(+a), o(), u) : n;
  }, u;
}
function uy(n) {
  var t = fn(0.1), e, r, i;
  typeof n != "function" && (n = fn(n == null ? 0 : +n));
  function u(a) {
    for (var s = 0, c = e.length, l; s < c; ++s)
      l = e[s], l.vy += (i[s] - l.y) * r[s] * a;
  }
  function o() {
    if (e) {
      var a, s = e.length;
      for (r = new Array(s), i = new Array(s), a = 0; a < s; ++a)
        r[a] = isNaN(i[a] = +n(e[a], a, e)) ? 0 : +t(e[a], a, e);
    }
  }
  return u.initialize = function(a) {
    e = a, o();
  }, u.strength = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : fn(+a), o(), u) : t;
  }, u.y = function(a) {
    return arguments.length ? (n = typeof a == "function" ? a : fn(+a), o(), u) : n;
  }, u;
}
function Ti(n, t) {
  if ((e = (n = t ? n.toExponential(t - 1) : n.toExponential()).indexOf("e")) < 0) return null;
  var e, r = n.slice(0, e);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +n.slice(e + 1)
  ];
}
function he(n) {
  return n = Ti(Math.abs(n)), n ? n[1] : NaN;
}
function oy(n, t) {
  return function(e, r) {
    for (var i = e.length, u = [], o = 0, a = n[0], s = 0; i > 0 && a > 0 && (s + a + 1 > r && (a = Math.max(1, r - s)), u.push(e.substring(i -= a, i + a)), !((s += a + 1) > r)); )
      a = n[o = (o + 1) % n.length];
    return u.reverse().join(t);
  };
}
function ay(n) {
  return function(t) {
    return t.replace(/[0-9]/g, function(e) {
      return n[+e];
    });
  };
}
function sy(n, t) {
  n = n.toPrecision(t);
  n: for (var e = n.length, r = 1, i = -1, u; r < e; ++r)
    switch (n[r]) {
      case ".":
        i = u = r;
        break;
      case "0":
        i === 0 && (i = r), u = r;
        break;
      case "e":
        break n;
      default:
        i > 0 && (i = 0);
        break;
    }
  return i > 0 ? n.slice(0, i) + n.slice(u + 1) : n;
}
var El;
function cy(n, t) {
  var e = Ti(n, t);
  if (!e) return n + "";
  var r = e[0], i = e[1], u = i - (El = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
  return u === o ? r : u > o ? r + new Array(u - o + 1).join("0") : u > 0 ? r.slice(0, u) + "." + r.slice(u) : "0." + new Array(1 - u).join("0") + Ti(n, Math.max(0, t + u - 1))[0];
}
function ac(n, t) {
  var e = Ti(n, t);
  if (!e) return n + "";
  var r = e[0], i = e[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const kl = {
  "": sy,
  "%": function(n, t) {
    return (n * 100).toFixed(t);
  },
  b: function(n) {
    return Math.round(n).toString(2);
  },
  c: function(n) {
    return n + "";
  },
  d: function(n) {
    return Math.round(n).toString(10);
  },
  e: function(n, t) {
    return n.toExponential(t);
  },
  f: function(n, t) {
    return n.toFixed(t);
  },
  g: function(n, t) {
    return n.toPrecision(t);
  },
  o: function(n) {
    return Math.round(n).toString(8);
  },
  p: function(n, t) {
    return ac(n * 100, t);
  },
  r: ac,
  s: cy,
  X: function(n) {
    return Math.round(n).toString(16).toUpperCase();
  },
  x: function(n) {
    return Math.round(n).toString(16);
  }
};
var fy = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
function pr(n) {
  return new Aa(n);
}
pr.prototype = Aa.prototype;
function Aa(n) {
  if (!(t = fy.exec(n))) throw new Error("invalid format: " + n);
  var t, e = t[1] || " ", r = t[2] || ">", i = t[3] || "-", u = t[4] || "", o = !!t[5], a = t[6] && +t[6], s = !!t[7], c = t[8] && +t[8].slice(1), l = t[9] || "";
  l === "n" ? (s = !0, l = "g") : kl[l] || (l = ""), (o || e === "0" && r === "=") && (o = !0, e = "0", r = "="), this.fill = e, this.align = r, this.sign = i, this.symbol = u, this.zero = o, this.width = a, this.comma = s, this.precision = c, this.type = l;
}
Aa.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width == null ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0)) + this.type;
};
function sc(n) {
  return n;
}
var cc = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function Cl(n) {
  var t = n.grouping && n.thousands ? oy(n.grouping, n.thousands) : sc, e = n.currency, r = n.decimal, i = n.numerals ? ay(n.numerals) : sc, u = n.percent || "%";
  function o(s) {
    s = pr(s);
    var c = s.fill, l = s.align, h = s.sign, f = s.symbol, p = s.zero, g = s.width, d = s.comma, v = s.precision, y = s.type, x = f === "$" ? e[0] : f === "#" && /[boxX]/.test(y) ? "0" + y.toLowerCase() : "", m = f === "$" ? e[1] : /[%p]/.test(y) ? u : "", w = kl[y], M = !y || /[defgprs%]/.test(y);
    v = v == null ? y ? 6 : 12 : /[gprs]/.test(y) ? Math.max(1, Math.min(21, v)) : Math.max(0, Math.min(20, v));
    function N(S) {
      var E = x, T = m, $, A, k;
      if (y === "c")
        T = w(S) + T, S = "";
      else {
        S = +S;
        var _ = S < 0;
        if (S = w(Math.abs(S), v), _ && +S == 0 && (_ = !1), E = (_ ? h === "(" ? h : "-" : h === "-" || h === "(" ? "" : h) + E, T = (y === "s" ? cc[8 + El / 3] : "") + T + (_ && h === "(" ? ")" : ""), M) {
          for ($ = -1, A = S.length; ++$ < A; )
            if (k = S.charCodeAt($), 48 > k || k > 57) {
              T = (k === 46 ? r + S.slice($ + 1) : S.slice($)) + T, S = S.slice(0, $);
              break;
            }
        }
      }
      d && !p && (S = t(S, 1 / 0));
      var b = E.length + S.length + T.length, C = b < g ? new Array(g - b + 1).join(c) : "";
      switch (d && p && (S = t(C + S, C.length ? g - T.length : 1 / 0), C = ""), l) {
        case "<":
          S = E + S + T + C;
          break;
        case "=":
          S = E + C + S + T;
          break;
        case "^":
          S = C.slice(0, b = C.length >> 1) + E + S + T + C.slice(b);
          break;
        default:
          S = C + E + S + T;
          break;
      }
      return i(S);
    }
    return N.toString = function() {
      return s + "";
    }, N;
  }
  function a(s, c) {
    var l = o((s = pr(s), s.type = "f", s)), h = Math.max(-8, Math.min(8, Math.floor(he(c) / 3))) * 3, f = Math.pow(10, -h), p = cc[8 + h / 3];
    return function(g) {
      return l(f * g) + p;
    };
  }
  return {
    format: o,
    formatPrefix: a
  };
}
var qr, yu, Ra;
Al({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function Al(n) {
  return qr = Cl(n), yu = qr.format, Ra = qr.formatPrefix, qr;
}
function Rl(n) {
  return Math.max(0, -he(Math.abs(n)));
}
function $l(n, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(he(t) / 3))) * 3 - he(Math.abs(n)));
}
function Pl(n, t) {
  return n = Math.abs(n), t = Math.abs(t) - n, Math.max(0, he(t) - he(n)) + 1;
}
function St() {
  return new Ni();
}
function Ni() {
  this.reset();
}
Ni.prototype = {
  constructor: Ni,
  reset: function() {
    this.s = // rounded value
    this.t = 0;
  },
  add: function(n) {
    fc(Hr, n, this.t), fc(this, Hr.s, this.s), this.s ? this.t += Hr.t : this.s = Hr.t;
  },
  valueOf: function() {
    return this.s;
  }
};
var Hr = new Ni();
function fc(n, t, e) {
  var r = n.s = t + e, i = r - t, u = r - i;
  n.t = t - u + (e - i);
}
var U = 1e-6, lc = 1e-12, W = Math.PI, cn = W / 2, Ei = W / 4, Cn = W * 2, un = 180 / W, F = W / 180, Z = Math.abs, xe = Math.atan, Nn = Math.atan2, O = Math.cos, Br = Math.ceil, zl = Math.exp, ki = Math.log, Gu = Math.pow, D = Math.sin, gr = Math.sign || function(n) {
  return n > 0 ? 1 : n < 0 ? -1 : 0;
}, ln = Math.sqrt, $a = Math.tan;
function Il(n) {
  return n > 1 ? 0 : n < -1 ? W : Math.acos(n);
}
function In(n) {
  return n > 1 ? cn : n < -1 ? -cn : Math.asin(n);
}
function hc(n) {
  return (n = D(n / 2)) * n;
}
function on() {
}
function Ci(n, t) {
  n && gc.hasOwnProperty(n.type) && gc[n.type](n, t);
}
var pc = {
  Feature: function(n, t) {
    Ci(n.geometry, t);
  },
  FeatureCollection: function(n, t) {
    for (var e = n.features, r = -1, i = e.length; ++r < i; ) Ci(e[r].geometry, t);
  }
}, gc = {
  Sphere: function(n, t) {
    t.sphere();
  },
  Point: function(n, t) {
    n = n.coordinates, t.point(n[0], n[1], n[2]);
  },
  MultiPoint: function(n, t) {
    for (var e = n.coordinates, r = -1, i = e.length; ++r < i; ) n = e[r], t.point(n[0], n[1], n[2]);
  },
  LineString: function(n, t) {
    Po(n.coordinates, t, 0);
  },
  MultiLineString: function(n, t) {
    for (var e = n.coordinates, r = -1, i = e.length; ++r < i; ) Po(e[r], t, 0);
  },
  Polygon: function(n, t) {
    dc(n.coordinates, t);
  },
  MultiPolygon: function(n, t) {
    for (var e = n.coordinates, r = -1, i = e.length; ++r < i; ) dc(e[r], t);
  },
  GeometryCollection: function(n, t) {
    for (var e = n.geometries, r = -1, i = e.length; ++r < i; ) Ci(e[r], t);
  }
};
function Po(n, t, e) {
  var r = -1, i = n.length - e, u;
  for (t.lineStart(); ++r < i; ) u = n[r], t.point(u[0], u[1], u[2]);
  t.lineEnd();
}
function dc(n, t) {
  var e = -1, r = n.length;
  for (t.polygonStart(); ++e < r; ) Po(n[e], t, 1);
  t.polygonEnd();
}
function Yn(n, t) {
  n && pc.hasOwnProperty(n.type) ? pc[n.type](n, t) : Ci(n, t);
}
var Ai = St(), Ri = St(), Ll, Dl, zo, Io, Lo, jn = {
  point: on,
  lineStart: on,
  lineEnd: on,
  polygonStart: function() {
    Ai.reset(), jn.lineStart = ly, jn.lineEnd = hy;
  },
  polygonEnd: function() {
    var n = +Ai;
    Ri.add(n < 0 ? Cn + n : n), this.lineStart = this.lineEnd = this.point = on;
  },
  sphere: function() {
    Ri.add(Cn);
  }
};
function ly() {
  jn.point = py;
}
function hy() {
  Ol(Ll, Dl);
}
function py(n, t) {
  jn.point = Ol, Ll = n, Dl = t, n *= F, t *= F, zo = n, Io = O(t = t / 2 + Ei), Lo = D(t);
}
function Ol(n, t) {
  n *= F, t *= F, t = t / 2 + Ei;
  var e = n - zo, r = e >= 0 ? 1 : -1, i = r * e, u = O(t), o = D(t), a = Lo * o, s = Io * u + a * O(i), c = a * r * D(i);
  Ai.add(Nn(c, s)), zo = n, Io = u, Lo = o;
}
function gy(n) {
  return Ri.reset(), Yn(n, jn), Ri * 2;
}
function $i(n) {
  return [Nn(n[1], n[0]), In(n[2])];
}
function Ut(n) {
  var t = n[0], e = n[1], r = O(e);
  return [r * O(t), r * D(t), D(e)];
}
function Xr(n, t) {
  return n[0] * t[0] + n[1] * t[1] + n[2] * t[2];
}
function pe(n, t) {
  return [n[1] * t[2] - n[2] * t[1], n[2] * t[0] - n[0] * t[2], n[0] * t[1] - n[1] * t[0]];
}
function Qu(n, t) {
  n[0] += t[0], n[1] += t[1], n[2] += t[2];
}
function Wr(n, t) {
  return [n[0] * t, n[1] * t, n[2] * t];
}
function Pi(n) {
  var t = ln(n[0] * n[0] + n[1] * n[1] + n[2] * n[2]);
  n[0] /= t, n[1] /= t, n[2] /= t;
}
var an, Pn, sn, Un, At, Ul, Fl, oe, Je = St(), ft, ot, tt = {
  point: Do,
  lineStart: vc,
  lineEnd: yc,
  polygonStart: function() {
    tt.point = ql, tt.lineStart = dy, tt.lineEnd = vy, Je.reset(), jn.polygonStart();
  },
  polygonEnd: function() {
    jn.polygonEnd(), tt.point = Do, tt.lineStart = vc, tt.lineEnd = yc, Ai < 0 ? (an = -(sn = 180), Pn = -(Un = 90)) : Je > U ? Un = 90 : Je < -U && (Pn = -90), ot[0] = an, ot[1] = sn;
  }
};
function Do(n, t) {
  ft.push(ot = [an = n, sn = n]), t < Pn && (Pn = t), t > Un && (Un = t);
}
function Yl(n, t) {
  var e = Ut([n * F, t * F]);
  if (oe) {
    var r = pe(oe, e), i = [r[1], -r[0], 0], u = pe(i, r);
    Pi(u), u = $i(u);
    var o = n - At, a = o > 0 ? 1 : -1, s = u[0] * un * a, c, l = Z(o) > 180;
    l ^ (a * At < s && s < a * n) ? (c = u[1] * un, c > Un && (Un = c)) : (s = (s + 360) % 360 - 180, l ^ (a * At < s && s < a * n) ? (c = -u[1] * un, c < Pn && (Pn = c)) : (t < Pn && (Pn = t), t > Un && (Un = t))), l ? n < At ? Rn(an, n) > Rn(an, sn) && (sn = n) : Rn(n, sn) > Rn(an, sn) && (an = n) : sn >= an ? (n < an && (an = n), n > sn && (sn = n)) : n > At ? Rn(an, n) > Rn(an, sn) && (sn = n) : Rn(n, sn) > Rn(an, sn) && (an = n);
  } else
    ft.push(ot = [an = n, sn = n]);
  t < Pn && (Pn = t), t > Un && (Un = t), oe = e, At = n;
}
function vc() {
  tt.point = Yl;
}
function yc() {
  ot[0] = an, ot[1] = sn, tt.point = Do, oe = null;
}
function ql(n, t) {
  if (oe) {
    var e = n - At;
    Je.add(Z(e) > 180 ? e + (e > 0 ? 360 : -360) : e);
  } else
    Ul = n, Fl = t;
  jn.point(n, t), Yl(n, t);
}
function dy() {
  jn.lineStart();
}
function vy() {
  ql(Ul, Fl), jn.lineEnd(), Z(Je) > U && (an = -(sn = 180)), ot[0] = an, ot[1] = sn, oe = null;
}
function Rn(n, t) {
  return (t -= n) < 0 ? t + 360 : t;
}
function yy(n, t) {
  return n[0] - t[0];
}
function mc(n, t) {
  return n[0] <= n[1] ? n[0] <= t && t <= n[1] : t < n[0] || n[1] < t;
}
function my(n) {
  var t, e, r, i, u, o, a;
  if (Un = sn = -(an = Pn = 1 / 0), ft = [], Yn(n, tt), e = ft.length) {
    for (ft.sort(yy), t = 1, r = ft[0], u = [r]; t < e; ++t)
      i = ft[t], mc(r, i[0]) || mc(r, i[1]) ? (Rn(r[0], i[1]) > Rn(r[0], r[1]) && (r[1] = i[1]), Rn(i[0], r[1]) > Rn(r[0], r[1]) && (r[0] = i[0])) : u.push(r = i);
    for (o = -1 / 0, e = u.length - 1, t = 0, r = u[e]; t <= e; r = i, ++t)
      i = u[t], (a = Rn(r[1], i[0])) > o && (o = a, an = i[0], sn = r[1]);
  }
  return ft = ot = null, an === 1 / 0 || Pn === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[an, Pn], [sn, Un]];
}
var Oe, zi, Ii, Li, Di, Oi, Ui, Fi, Oo, Uo, Fo, Hl, Bl, xn, bn, Mn, Hn = {
  sphere: on,
  point: Pa,
  lineStart: _c,
  lineEnd: wc,
  polygonStart: function() {
    Hn.lineStart = xy, Hn.lineEnd = by;
  },
  polygonEnd: function() {
    Hn.lineStart = _c, Hn.lineEnd = wc;
  }
};
function Pa(n, t) {
  n *= F, t *= F;
  var e = O(t);
  kr(e * O(n), e * D(n), D(t));
}
function kr(n, t, e) {
  ++Oe, Ii += (n - Ii) / Oe, Li += (t - Li) / Oe, Di += (e - Di) / Oe;
}
function _c() {
  Hn.point = _y;
}
function _y(n, t) {
  n *= F, t *= F;
  var e = O(t);
  xn = e * O(n), bn = e * D(n), Mn = D(t), Hn.point = wy, kr(xn, bn, Mn);
}
function wy(n, t) {
  n *= F, t *= F;
  var e = O(t), r = e * O(n), i = e * D(n), u = D(t), o = Nn(ln((o = bn * u - Mn * i) * o + (o = Mn * r - xn * u) * o + (o = xn * i - bn * r) * o), xn * r + bn * i + Mn * u);
  zi += o, Oi += o * (xn + (xn = r)), Ui += o * (bn + (bn = i)), Fi += o * (Mn + (Mn = u)), kr(xn, bn, Mn);
}
function wc() {
  Hn.point = Pa;
}
function xy() {
  Hn.point = My;
}
function by() {
  Xl(Hl, Bl), Hn.point = Pa;
}
function My(n, t) {
  Hl = n, Bl = t, n *= F, t *= F, Hn.point = Xl;
  var e = O(t);
  xn = e * O(n), bn = e * D(n), Mn = D(t), kr(xn, bn, Mn);
}
function Xl(n, t) {
  n *= F, t *= F;
  var e = O(t), r = e * O(n), i = e * D(n), u = D(t), o = bn * u - Mn * i, a = Mn * r - xn * u, s = xn * i - bn * r, c = ln(o * o + a * a + s * s), l = In(c), h = c && -l / c;
  Oo += h * o, Uo += h * a, Fo += h * s, zi += l, Oi += l * (xn + (xn = r)), Ui += l * (bn + (bn = i)), Fi += l * (Mn + (Mn = u)), kr(xn, bn, Mn);
}
function Sy(n) {
  Oe = zi = Ii = Li = Di = Oi = Ui = Fi = Oo = Uo = Fo = 0, Yn(n, Hn);
  var t = Oo, e = Uo, r = Fo, i = t * t + e * e + r * r;
  return i < lc && (t = Oi, e = Ui, r = Fi, zi < U && (t = Ii, e = Li, r = Di), i = t * t + e * e + r * r, i < lc) ? [NaN, NaN] : [Nn(e, t) * un, In(r / ln(i)) * un];
}
function Qt(n) {
  return function() {
    return n;
  };
}
function Wl(n, t) {
  function e(r, i) {
    return r = n(r, i), t(r[0], r[1]);
  }
  return n.invert && t.invert && (e.invert = function(r, i) {
    return r = t.invert(r, i), r && n.invert(r[0], r[1]);
  }), e;
}
function Yo(n, t) {
  return [n > W ? n - Cn : n < -W ? n + Cn : n, t];
}
Yo.invert = Yo;
function za(n, t, e) {
  return (n %= Cn) ? t || e ? Wl(bc(n), Mc(t, e)) : bc(n) : t || e ? Mc(t, e) : Yo;
}
function xc(n) {
  return function(t, e) {
    return t += n, [t > W ? t - Cn : t < -W ? t + Cn : t, e];
  };
}
function bc(n) {
  var t = xc(n);
  return t.invert = xc(-n), t;
}
function Mc(n, t) {
  var e = O(n), r = D(n), i = O(t), u = D(t);
  function o(a, s) {
    var c = O(s), l = O(a) * c, h = D(a) * c, f = D(s), p = f * e + l * r;
    return [
      Nn(h * i - p * u, l * e - f * r),
      In(p * i + h * u)
    ];
  }
  return o.invert = function(a, s) {
    var c = O(s), l = O(a) * c, h = D(a) * c, f = D(s), p = f * i - h * u;
    return [
      Nn(h * i + f * u, l * e + p * r),
      In(p * e - l * r)
    ];
  }, o;
}
function Vl(n) {
  n = za(n[0] * F, n[1] * F, n.length > 2 ? n[2] * F : 0);
  function t(e) {
    return e = n(e[0] * F, e[1] * F), e[0] *= un, e[1] *= un, e;
  }
  return t.invert = function(e) {
    return e = n.invert(e[0] * F, e[1] * F), e[0] *= un, e[1] *= un, e;
  }, t;
}
function Zl(n, t, e, r, i, u) {
  if (e) {
    var o = O(t), a = D(t), s = r * e;
    i == null ? (i = t + r * Cn, u = t - s / 2) : (i = Sc(o, i), u = Sc(o, u), (r > 0 ? i < u : i > u) && (i += r * Cn));
    for (var c, l = i; r > 0 ? l > u : l < u; l -= s)
      c = $i([o, -a * O(l), -a * D(l)]), n.point(c[0], c[1]);
  }
}
function Sc(n, t) {
  t = Ut(t), t[0] -= n, Pi(t);
  var e = Il(-t[1]);
  return ((-t[2] < 0 ? -e : e) + Cn - U) % Cn;
}
function Ty() {
  var n = Qt([0, 0]), t = Qt(90), e = Qt(6), r, i, u = { point: o };
  function o(s, c) {
    r.push(s = i(s, c)), s[0] *= un, s[1] *= un;
  }
  function a() {
    var s = n.apply(this, arguments), c = t.apply(this, arguments) * F, l = e.apply(this, arguments) * F;
    return r = [], i = za(-s[0] * F, -s[1] * F, 0).invert, Zl(u, c, l, 1), s = { type: "Polygon", coordinates: [r] }, r = i = null, s;
  }
  return a.center = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : Qt([+s[0], +s[1]]), a) : n;
  }, a.radius = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : Qt(+s), a) : t;
  }, a.precision = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Qt(+s), a) : e;
  }, a;
}
function Gl() {
  var n = [], t;
  return {
    point: function(e, r) {
      t.push([e, r]);
    },
    lineStart: function() {
      n.push(t = []);
    },
    lineEnd: on,
    rejoin: function() {
      n.length > 1 && n.push(n.pop().concat(n.shift()));
    },
    result: function() {
      var e = n;
      return n = [], t = null, e;
    }
  };
}
function fi(n, t) {
  return Z(n[0] - t[0]) < U && Z(n[1] - t[1]) < U;
}
function Vr(n, t, e, r) {
  this.x = n, this.z = t, this.o = e, this.e = r, this.v = !1, this.n = this.p = null;
}
function Ql(n, t, e, r, i) {
  var u = [], o = [], a, s;
  if (n.forEach(function(g) {
    if (!((d = g.length - 1) <= 0)) {
      var d, v = g[0], y = g[d], x;
      if (fi(v, y)) {
        for (i.lineStart(), a = 0; a < d; ++a) i.point((v = g[a])[0], v[1]);
        i.lineEnd();
        return;
      }
      u.push(x = new Vr(v, g, null, !0)), o.push(x.o = new Vr(v, null, x, !1)), u.push(x = new Vr(y, g, null, !1)), o.push(x.o = new Vr(y, null, x, !0));
    }
  }), !!u.length) {
    for (o.sort(t), Tc(u), Tc(o), a = 0, s = o.length; a < s; ++a)
      o[a].e = e = !e;
    for (var c = u[0], l, h; ; ) {
      for (var f = c, p = !0; f.v; ) if ((f = f.n) === c) return;
      l = f.z, i.lineStart();
      do {
        if (f.v = f.o.v = !0, f.e) {
          if (p)
            for (a = 0, s = l.length; a < s; ++a) i.point((h = l[a])[0], h[1]);
          else
            r(f.x, f.n.x, 1, i);
          f = f.n;
        } else {
          if (p)
            for (l = f.p.z, a = l.length - 1; a >= 0; --a) i.point((h = l[a])[0], h[1]);
          else
            r(f.x, f.p.x, -1, i);
          f = f.p;
        }
        f = f.o, l = f.z, p = !p;
      } while (!f.v);
      i.lineEnd();
    }
  }
}
function Tc(n) {
  if (t = n.length) {
    for (var t, e = 0, r = n[0], i; ++e < t; )
      r.n = i = n[e], i.p = r, r = i;
    r.n = i = n[0], i.p = r;
  }
}
var Ku = St();
function Kl(n, t) {
  var e = t[0], r = t[1], i = [D(e), -O(e), 0], u = 0, o = 0;
  Ku.reset();
  for (var a = 0, s = n.length; a < s; ++a)
    if (l = (c = n[a]).length)
      for (var c, l, h = c[l - 1], f = h[0], p = h[1] / 2 + Ei, g = D(p), d = O(p), v = 0; v < l; ++v, f = x, g = w, d = M, h = y) {
        var y = c[v], x = y[0], m = y[1] / 2 + Ei, w = D(m), M = O(m), N = x - f, S = N >= 0 ? 1 : -1, E = S * N, T = E > W, $ = g * w;
        if (Ku.add(Nn($ * S * D(E), d * M + $ * O(E))), u += T ? N + S * Cn : N, T ^ f >= e ^ x >= e) {
          var A = pe(Ut(h), Ut(y));
          Pi(A);
          var k = pe(i, A);
          Pi(k);
          var _ = (T ^ N >= 0 ? -1 : 1) * In(k[2]);
          (r > _ || r === _ && (A[0] || A[1])) && (o += T ^ N >= 0 ? 1 : -1);
        }
      }
  return (u < -U || u < U && Ku < -U) ^ o & 1;
}
function Jl(n, t, e, r) {
  return function(i) {
    var u = t(i), o = Gl(), a = t(o), s = !1, c, l, h, f = {
      point: p,
      lineStart: d,
      lineEnd: v,
      polygonStart: function() {
        f.point = y, f.lineStart = x, f.lineEnd = m, l = [], c = [];
      },
      polygonEnd: function() {
        f.point = p, f.lineStart = d, f.lineEnd = v, l = sa(l);
        var w = Kl(c, r);
        l.length ? (s || (i.polygonStart(), s = !0), Ql(l, Ey, w, e, i)) : w && (s || (i.polygonStart(), s = !0), i.lineStart(), e(null, null, 1, i), i.lineEnd()), s && (i.polygonEnd(), s = !1), l = c = null;
      },
      sphere: function() {
        i.polygonStart(), i.lineStart(), e(null, null, 1, i), i.lineEnd(), i.polygonEnd();
      }
    };
    function p(w, M) {
      n(w, M) && i.point(w, M);
    }
    function g(w, M) {
      u.point(w, M);
    }
    function d() {
      f.point = g, u.lineStart();
    }
    function v() {
      f.point = p, u.lineEnd();
    }
    function y(w, M) {
      h.push([w, M]), a.point(w, M);
    }
    function x() {
      a.lineStart(), h = [];
    }
    function m() {
      y(h[0][0], h[0][1]), a.lineEnd();
      var w = a.clean(), M = o.result(), N, S = M.length, E, T, $;
      if (h.pop(), c.push(h), h = null, !!S) {
        if (w & 1) {
          if (T = M[0], (E = T.length - 1) > 0) {
            for (s || (i.polygonStart(), s = !0), i.lineStart(), N = 0; N < E; ++N) i.point(($ = T[N])[0], $[1]);
            i.lineEnd();
          }
          return;
        }
        S > 1 && w & 2 && M.push(M.pop().concat(M.shift())), l.push(M.filter(Ny));
      }
    }
    return f;
  };
}
function Ny(n) {
  return n.length > 1;
}
function Ey(n, t) {
  return ((n = n.x)[0] < 0 ? n[1] - cn - U : cn - n[1]) - ((t = t.x)[0] < 0 ? t[1] - cn - U : cn - t[1]);
}
const qo = Jl(
  function() {
    return !0;
  },
  ky,
  Ay,
  [-W, -cn]
);
function ky(n) {
  var t = NaN, e = NaN, r = NaN, i;
  return {
    lineStart: function() {
      n.lineStart(), i = 1;
    },
    point: function(u, o) {
      var a = u > 0 ? W : -W, s = Z(u - t);
      Z(s - W) < U ? (n.point(t, e = (e + o) / 2 > 0 ? cn : -cn), n.point(r, e), n.lineEnd(), n.lineStart(), n.point(a, e), n.point(u, e), i = 0) : r !== a && s >= W && (Z(t - r) < U && (t -= r * U), Z(u - a) < U && (u -= a * U), e = Cy(t, e, u, o), n.point(r, e), n.lineEnd(), n.lineStart(), n.point(a, e), i = 0), n.point(t = u, e = o), r = a;
    },
    lineEnd: function() {
      n.lineEnd(), t = e = NaN;
    },
    clean: function() {
      return 2 - i;
    }
  };
}
function Cy(n, t, e, r) {
  var i, u, o = D(n - e);
  return Z(o) > U ? xe((D(t) * (u = O(r)) * D(e) - D(r) * (i = O(t)) * D(n)) / (i * u * o)) : (t + r) / 2;
}
function Ay(n, t, e, r) {
  var i;
  if (n == null)
    i = e * cn, r.point(-W, i), r.point(0, i), r.point(W, i), r.point(W, 0), r.point(W, -i), r.point(0, -i), r.point(-W, -i), r.point(-W, 0), r.point(-W, i);
  else if (Z(n[0] - t[0]) > U) {
    var u = n[0] < t[0] ? W : -W;
    i = e * u / 2, r.point(-u, i), r.point(0, i), r.point(u, i);
  } else
    r.point(t[0], t[1]);
}
function jl(n) {
  var t = O(n), e = 6 * F, r = t > 0, i = Z(t) > U;
  function u(l, h, f, p) {
    Zl(p, n, e, f, l, h);
  }
  function o(l, h) {
    return O(l) * O(h) > t;
  }
  function a(l) {
    var h, f, p, g, d;
    return {
      lineStart: function() {
        g = p = !1, d = 1;
      },
      point: function(v, y) {
        var x = [v, y], m, w = o(v, y), M = r ? w ? 0 : c(v, y) : w ? c(v + (v < 0 ? W : -W), y) : 0;
        if (!h && (g = p = w) && l.lineStart(), w !== p && (m = s(h, x), (!m || fi(h, m) || fi(x, m)) && (x[0] += U, x[1] += U, w = o(x[0], x[1]))), w !== p)
          d = 0, w ? (l.lineStart(), m = s(x, h), l.point(m[0], m[1])) : (m = s(h, x), l.point(m[0], m[1]), l.lineEnd()), h = m;
        else if (i && h && r ^ w) {
          var N;
          !(M & f) && (N = s(x, h, !0)) && (d = 0, r ? (l.lineStart(), l.point(N[0][0], N[0][1]), l.point(N[1][0], N[1][1]), l.lineEnd()) : (l.point(N[1][0], N[1][1]), l.lineEnd(), l.lineStart(), l.point(N[0][0], N[0][1])));
        }
        w && (!h || !fi(h, x)) && l.point(x[0], x[1]), h = x, p = w, f = M;
      },
      lineEnd: function() {
        p && l.lineEnd(), h = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return d | (g && p) << 1;
      }
    };
  }
  function s(l, h, f) {
    var p = Ut(l), g = Ut(h), d = [1, 0, 0], v = pe(p, g), y = Xr(v, v), x = v[0], m = y - x * x;
    if (!m) return !f && l;
    var w = t * y / m, M = -t * x / m, N = pe(d, v), S = Wr(d, w), E = Wr(v, M);
    Qu(S, E);
    var T = N, $ = Xr(S, T), A = Xr(T, T), k = $ * $ - A * (Xr(S, S) - 1);
    if (!(k < 0)) {
      var _ = ln(k), b = Wr(T, (-$ - _) / A);
      if (Qu(b, S), b = $i(b), !f) return b;
      var C = l[0], R = h[0], P = l[1], q = h[1], Y;
      R < C && (Y = C, C = R, R = Y);
      var G = R - C, V = Z(G - W) < U, tn = V || G < U;
      if (!V && q < P && (Y = P, P = q, q = Y), tn ? V ? P + q > 0 ^ b[1] < (Z(b[0] - C) < U ? P : q) : P <= b[1] && b[1] <= q : G > W ^ (C <= b[0] && b[0] <= R)) {
        var Q = Wr(T, (-$ + _) / A);
        return Qu(Q, S), [b, $i(Q)];
      }
    }
  }
  function c(l, h) {
    var f = r ? n : W - n, p = 0;
    return l < -f ? p |= 1 : l > f && (p |= 2), h < -f ? p |= 4 : h > f && (p |= 8), p;
  }
  return Jl(o, a, u, r ? [0, -n] : [-W, n - W]);
}
function Ry(n, t, e, r, i, u) {
  var o = n[0], a = n[1], s = t[0], c = t[1], l = 0, h = 1, f = s - o, p = c - a, g;
  if (g = e - o, !(!f && g > 0)) {
    if (g /= f, f < 0) {
      if (g < l) return;
      g < h && (h = g);
    } else if (f > 0) {
      if (g > h) return;
      g > l && (l = g);
    }
    if (g = i - o, !(!f && g < 0)) {
      if (g /= f, f < 0) {
        if (g > h) return;
        g > l && (l = g);
      } else if (f > 0) {
        if (g < l) return;
        g < h && (h = g);
      }
      if (g = r - a, !(!p && g > 0)) {
        if (g /= p, p < 0) {
          if (g < l) return;
          g < h && (h = g);
        } else if (p > 0) {
          if (g > h) return;
          g > l && (l = g);
        }
        if (g = u - a, !(!p && g < 0)) {
          if (g /= p, p < 0) {
            if (g > h) return;
            g > l && (l = g);
          } else if (p > 0) {
            if (g < l) return;
            g < h && (h = g);
          }
          return l > 0 && (n[0] = o + l * f, n[1] = a + l * p), h < 1 && (t[0] = o + h * f, t[1] = a + h * p), !0;
        }
      }
    }
  }
}
var Ue = 1e9, Zr = -Ue;
function mu(n, t, e, r) {
  function i(c, l) {
    return n <= c && c <= e && t <= l && l <= r;
  }
  function u(c, l, h, f) {
    var p = 0, g = 0;
    if (c == null || (p = o(c, h)) !== (g = o(l, h)) || s(c, l) < 0 ^ h > 0)
      do
        f.point(p === 0 || p === 3 ? n : e, p > 1 ? r : t);
      while ((p = (p + h + 4) % 4) !== g);
    else
      f.point(l[0], l[1]);
  }
  function o(c, l) {
    return Z(c[0] - n) < U ? l > 0 ? 0 : 3 : Z(c[0] - e) < U ? l > 0 ? 2 : 1 : Z(c[1] - t) < U ? l > 0 ? 1 : 0 : l > 0 ? 3 : 2;
  }
  function a(c, l) {
    return s(c.x, l.x);
  }
  function s(c, l) {
    var h = o(c, 1), f = o(l, 1);
    return h !== f ? h - f : h === 0 ? l[1] - c[1] : h === 1 ? c[0] - l[0] : h === 2 ? c[1] - l[1] : l[0] - c[0];
  }
  return function(c) {
    var l = c, h = Gl(), f, p, g, d, v, y, x, m, w, M, N, S = {
      point: E,
      lineStart: k,
      lineEnd: _,
      polygonStart: $,
      polygonEnd: A
    };
    function E(C, R) {
      i(C, R) && l.point(C, R);
    }
    function T() {
      for (var C = 0, R = 0, P = p.length; R < P; ++R)
        for (var q = p[R], Y = 1, G = q.length, V = q[0], tn, Q, en = V[0], K = V[1]; Y < G; ++Y)
          tn = en, Q = K, V = q[Y], en = V[0], K = V[1], Q <= r ? K > r && (en - tn) * (r - Q) > (K - Q) * (n - tn) && ++C : K <= r && (en - tn) * (r - Q) < (K - Q) * (n - tn) && --C;
      return C;
    }
    function $() {
      l = h, f = [], p = [], N = !0;
    }
    function A() {
      var C = T(), R = N && C, P = (f = sa(f)).length;
      (R || P) && (c.polygonStart(), R && (c.lineStart(), u(null, null, 1, c), c.lineEnd()), P && Ql(f, a, C, u, c), c.polygonEnd()), l = c, f = p = g = null;
    }
    function k() {
      S.point = b, p && p.push(g = []), M = !0, w = !1, x = m = NaN;
    }
    function _() {
      f && (b(d, v), y && w && h.rejoin(), f.push(h.result())), S.point = E, w && l.lineEnd();
    }
    function b(C, R) {
      var P = i(C, R);
      if (p && g.push([C, R]), M)
        d = C, v = R, y = P, M = !1, P && (l.lineStart(), l.point(C, R));
      else if (P && w) l.point(C, R);
      else {
        var q = [x = Math.max(Zr, Math.min(Ue, x)), m = Math.max(Zr, Math.min(Ue, m))], Y = [C = Math.max(Zr, Math.min(Ue, C)), R = Math.max(Zr, Math.min(Ue, R))];
        Ry(q, Y, n, t, e, r) ? (w || (l.lineStart(), l.point(q[0], q[1])), l.point(Y[0], Y[1]), P || l.lineEnd(), N = !1) : P && (l.lineStart(), l.point(C, R), N = !1);
      }
      x = C, m = R, w = P;
    }
    return S;
  };
}
function $y() {
  var n = 0, t = 0, e = 960, r = 500, i, u, o;
  return o = {
    stream: function(a) {
      return i && u === a ? i : i = mu(n, t, e, r)(u = a);
    },
    extent: function(a) {
      return arguments.length ? (n = +a[0][0], t = +a[0][1], e = +a[1][0], r = +a[1][1], i = u = null, o) : [[n, t], [e, r]];
    }
  };
}
var Ho = St(), Bo, li, hi, ge = {
  sphere: on,
  point: on,
  lineStart: Py,
  lineEnd: on,
  polygonStart: on,
  polygonEnd: on
};
function Py() {
  ge.point = Iy, ge.lineEnd = zy;
}
function zy() {
  ge.point = ge.lineEnd = on;
}
function Iy(n, t) {
  n *= F, t *= F, Bo = n, li = D(t), hi = O(t), ge.point = Ly;
}
function Ly(n, t) {
  n *= F, t *= F;
  var e = D(t), r = O(t), i = Z(n - Bo), u = O(i), o = D(i), a = r * o, s = hi * e - li * r * u, c = li * e + hi * r * u;
  Ho.add(Nn(ln(a * a + s * s), c)), Bo = n, li = e, hi = r;
}
function nh(n) {
  return Ho.reset(), Yn(n, ge), +Ho;
}
var Xo = [null, null], Dy = { type: "LineString", coordinates: Xo };
function je(n, t) {
  return Xo[0] = n, Xo[1] = t, nh(Dy);
}
var Nc = {
  Feature: function(n, t) {
    return Yi(n.geometry, t);
  },
  FeatureCollection: function(n, t) {
    for (var e = n.features, r = -1, i = e.length; ++r < i; ) if (Yi(e[r].geometry, t)) return !0;
    return !1;
  }
}, Ec = {
  Sphere: function() {
    return !0;
  },
  Point: function(n, t) {
    return kc(n.coordinates, t);
  },
  MultiPoint: function(n, t) {
    for (var e = n.coordinates, r = -1, i = e.length; ++r < i; ) if (kc(e[r], t)) return !0;
    return !1;
  },
  LineString: function(n, t) {
    return Cc(n.coordinates, t);
  },
  MultiLineString: function(n, t) {
    for (var e = n.coordinates, r = -1, i = e.length; ++r < i; ) if (Cc(e[r], t)) return !0;
    return !1;
  },
  Polygon: function(n, t) {
    return Ac(n.coordinates, t);
  },
  MultiPolygon: function(n, t) {
    for (var e = n.coordinates, r = -1, i = e.length; ++r < i; ) if (Ac(e[r], t)) return !0;
    return !1;
  },
  GeometryCollection: function(n, t) {
    for (var e = n.geometries, r = -1, i = e.length; ++r < i; ) if (Yi(e[r], t)) return !0;
    return !1;
  }
};
function Yi(n, t) {
  return n && Ec.hasOwnProperty(n.type) ? Ec[n.type](n, t) : !1;
}
function kc(n, t) {
  return je(n, t) === 0;
}
function Cc(n, t) {
  var e = je(n[0], n[1]), r = je(n[0], t), i = je(t, n[1]);
  return r + i <= e + U;
}
function Ac(n, t) {
  return !!Kl(n.map(Oy), th(t));
}
function Oy(n) {
  return n = n.map(th), n.pop(), n;
}
function th(n) {
  return [n[0] * F, n[1] * F];
}
function Uy(n, t) {
  return (n && Nc.hasOwnProperty(n.type) ? Nc[n.type] : Yi)(n, t);
}
function Rc(n, t, e) {
  var r = qn(n, t - U, e).concat(t);
  return function(i) {
    return r.map(function(u) {
      return [i, u];
    });
  };
}
function $c(n, t, e) {
  var r = qn(n, t - U, e).concat(t);
  return function(i) {
    return r.map(function(u) {
      return [u, i];
    });
  };
}
function eh() {
  var n, t, e, r, i, u, o, a, s = 10, c = s, l = 90, h = 360, f, p, g, d, v = 2.5;
  function y() {
    return { type: "MultiLineString", coordinates: x() };
  }
  function x() {
    return qn(Br(r / l) * l, e, l).map(g).concat(qn(Br(a / h) * h, o, h).map(d)).concat(qn(Br(t / s) * s, n, s).filter(function(m) {
      return Z(m % l) > U;
    }).map(f)).concat(qn(Br(u / c) * c, i, c).filter(function(m) {
      return Z(m % h) > U;
    }).map(p));
  }
  return y.lines = function() {
    return x().map(function(m) {
      return { type: "LineString", coordinates: m };
    });
  }, y.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        g(r).concat(
          d(o).slice(1),
          g(e).reverse().slice(1),
          d(a).reverse().slice(1)
        )
      ]
    };
  }, y.extent = function(m) {
    return arguments.length ? y.extentMajor(m).extentMinor(m) : y.extentMinor();
  }, y.extentMajor = function(m) {
    return arguments.length ? (r = +m[0][0], e = +m[1][0], a = +m[0][1], o = +m[1][1], r > e && (m = r, r = e, e = m), a > o && (m = a, a = o, o = m), y.precision(v)) : [[r, a], [e, o]];
  }, y.extentMinor = function(m) {
    return arguments.length ? (t = +m[0][0], n = +m[1][0], u = +m[0][1], i = +m[1][1], t > n && (m = t, t = n, n = m), u > i && (m = u, u = i, i = m), y.precision(v)) : [[t, u], [n, i]];
  }, y.step = function(m) {
    return arguments.length ? y.stepMajor(m).stepMinor(m) : y.stepMinor();
  }, y.stepMajor = function(m) {
    return arguments.length ? (l = +m[0], h = +m[1], y) : [l, h];
  }, y.stepMinor = function(m) {
    return arguments.length ? (s = +m[0], c = +m[1], y) : [s, c];
  }, y.precision = function(m) {
    return arguments.length ? (v = +m, f = Rc(u, i, 90), p = $c(t, n, v), g = Rc(a, o, 90), d = $c(r, e, v), y) : v;
  }, y.extentMajor([[-180, -90 + U], [180, 90 - U]]).extentMinor([[-180, -80 - U], [180, 80 + U]]);
}
function Fy() {
  return eh()();
}
function Yy(n, t) {
  var e = n[0] * F, r = n[1] * F, i = t[0] * F, u = t[1] * F, o = O(r), a = D(r), s = O(u), c = D(u), l = o * O(e), h = o * D(e), f = s * O(i), p = s * D(i), g = 2 * In(ln(hc(u - r) + o * s * hc(i - e))), d = D(g), v = g ? function(y) {
    var x = D(y *= g) / d, m = D(g - y) / d, w = m * l + x * f, M = m * h + x * p, N = m * a + x * c;
    return [
      Nn(M, w) * un,
      Nn(N, ln(w * w + M * M)) * un
    ];
  } : function() {
    return [e * un, r * un];
  };
  return v.distance = g, v;
}
function zt(n) {
  return n;
}
var Ju = St(), Wo = St(), rh, ih, Vo, Zo, et = {
  point: on,
  lineStart: on,
  lineEnd: on,
  polygonStart: function() {
    et.lineStart = qy, et.lineEnd = By;
  },
  polygonEnd: function() {
    et.lineStart = et.lineEnd = et.point = on, Ju.add(Z(Wo)), Wo.reset();
  },
  result: function() {
    var n = Ju / 2;
    return Ju.reset(), n;
  }
};
function qy() {
  et.point = Hy;
}
function Hy(n, t) {
  et.point = uh, rh = Vo = n, ih = Zo = t;
}
function uh(n, t) {
  Wo.add(Zo * n - Vo * t), Vo = n, Zo = t;
}
function By() {
  uh(rh, ih);
}
var de = 1 / 0, qi = de, dr = -de, Hi = dr, Bi = {
  point: Xy,
  lineStart: on,
  lineEnd: on,
  polygonStart: on,
  polygonEnd: on,
  result: function() {
    var n = [[de, qi], [dr, Hi]];
    return dr = Hi = -(qi = de = 1 / 0), n;
  }
};
function Xy(n, t) {
  n < de && (de = n), n > dr && (dr = n), t < qi && (qi = t), t > Hi && (Hi = t);
}
var Go = 0, Qo = 0, Fe = 0, Xi = 0, Wi = 0, ne = 0, Ko = 0, Jo = 0, Ye = 0, oh, ah, Zn, Gn, Fn = {
  point: Ft,
  lineStart: Pc,
  lineEnd: zc,
  polygonStart: function() {
    Fn.lineStart = Zy, Fn.lineEnd = Gy;
  },
  polygonEnd: function() {
    Fn.point = Ft, Fn.lineStart = Pc, Fn.lineEnd = zc;
  },
  result: function() {
    var n = Ye ? [Ko / Ye, Jo / Ye] : ne ? [Xi / ne, Wi / ne] : Fe ? [Go / Fe, Qo / Fe] : [NaN, NaN];
    return Go = Qo = Fe = Xi = Wi = ne = Ko = Jo = Ye = 0, n;
  }
};
function Ft(n, t) {
  Go += n, Qo += t, ++Fe;
}
function Pc() {
  Fn.point = Wy;
}
function Wy(n, t) {
  Fn.point = Vy, Ft(Zn = n, Gn = t);
}
function Vy(n, t) {
  var e = n - Zn, r = t - Gn, i = ln(e * e + r * r);
  Xi += i * (Zn + n) / 2, Wi += i * (Gn + t) / 2, ne += i, Ft(Zn = n, Gn = t);
}
function zc() {
  Fn.point = Ft;
}
function Zy() {
  Fn.point = Qy;
}
function Gy() {
  sh(oh, ah);
}
function Qy(n, t) {
  Fn.point = sh, Ft(oh = Zn = n, ah = Gn = t);
}
function sh(n, t) {
  var e = n - Zn, r = t - Gn, i = ln(e * e + r * r);
  Xi += i * (Zn + n) / 2, Wi += i * (Gn + t) / 2, ne += i, i = Gn * n - Zn * t, Ko += i * (Zn + n), Jo += i * (Gn + t), Ye += i * 3, Ft(Zn = n, Gn = t);
}
function ch(n) {
  this._context = n;
}
ch.prototype = {
  _radius: 4.5,
  pointRadius: function(n) {
    return this._radius = n, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._context.closePath(), this._point = NaN;
  },
  point: function(n, t) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(n, t), this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(n, t);
        break;
      }
      default: {
        this._context.moveTo(n + this._radius, t), this._context.arc(n, t, this._radius, 0, Cn);
        break;
      }
    }
  },
  result: on
};
var jo = St(), ju, fh, lh, qe, He, vr = {
  point: on,
  lineStart: function() {
    vr.point = Ky;
  },
  lineEnd: function() {
    ju && hh(fh, lh), vr.point = on;
  },
  polygonStart: function() {
    ju = !0;
  },
  polygonEnd: function() {
    ju = null;
  },
  result: function() {
    var n = +jo;
    return jo.reset(), n;
  }
};
function Ky(n, t) {
  vr.point = hh, fh = qe = n, lh = He = t;
}
function hh(n, t) {
  qe -= n, He -= t, jo.add(ln(qe * qe + He * He)), qe = n, He = t;
}
function ph() {
  this._string = [];
}
ph.prototype = {
  _radius: 4.5,
  _circle: Ic(4.5),
  pointRadius: function(n) {
    return (n = +n) !== this._radius && (this._radius = n, this._circle = null), this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._string.push("Z"), this._point = NaN;
  },
  point: function(n, t) {
    switch (this._point) {
      case 0: {
        this._string.push("M", n, ",", t), this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", n, ",", t);
        break;
      }
      default: {
        this._circle == null && (this._circle = Ic(this._radius)), this._string.push("M", n, ",", t, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var n = this._string.join("");
      return this._string = [], n;
    } else
      return null;
  }
};
function Ic(n) {
  return "m0," + n + "a" + n + "," + n + " 0 1,1 0," + -2 * n + "a" + n + "," + n + " 0 1,1 0," + 2 * n + "z";
}
function Jy(n, t) {
  var e = 4.5, r, i;
  function u(o) {
    return o && (typeof e == "function" && i.pointRadius(+e.apply(this, arguments)), Yn(o, r(i))), i.result();
  }
  return u.area = function(o) {
    return Yn(o, r(et)), et.result();
  }, u.measure = function(o) {
    return Yn(o, r(vr)), vr.result();
  }, u.bounds = function(o) {
    return Yn(o, r(Bi)), Bi.result();
  }, u.centroid = function(o) {
    return Yn(o, r(Fn)), Fn.result();
  }, u.projection = function(o) {
    return arguments.length ? (r = o == null ? (n = null, zt) : (n = o).stream, u) : n;
  }, u.context = function(o) {
    return arguments.length ? (i = o == null ? (t = null, new ph()) : new ch(t = o), typeof e != "function" && i.pointRadius(e), u) : t;
  }, u.pointRadius = function(o) {
    return arguments.length ? (e = typeof o == "function" ? o : (i.pointRadius(+o), +o), u) : e;
  }, u.projection(n).context(t);
}
function jy(n) {
  return {
    stream: Cr(n)
  };
}
function Cr(n) {
  return function(t) {
    var e = new na();
    for (var r in n) e[r] = n[r];
    return e.stream = t, e;
  };
}
function na() {
}
na.prototype = {
  constructor: na,
  point: function(n, t) {
    this.stream.point(n, t);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function Ia(n, t, e) {
  var r = n.clipExtent && n.clipExtent();
  return n.scale(150).translate([0, 0]), r != null && n.clipExtent(null), Yn(e, n.stream(Bi)), t(Bi.result()), r != null && n.clipExtent(r), n;
}
function _u(n, t, e) {
  return Ia(n, function(r) {
    var i = t[1][0] - t[0][0], u = t[1][1] - t[0][1], o = Math.min(i / (r[1][0] - r[0][0]), u / (r[1][1] - r[0][1])), a = +t[0][0] + (i - o * (r[1][0] + r[0][0])) / 2, s = +t[0][1] + (u - o * (r[1][1] + r[0][1])) / 2;
    n.scale(150 * o).translate([a, s]);
  }, e);
}
function La(n, t, e) {
  return _u(n, [[0, 0], t], e);
}
function Da(n, t, e) {
  return Ia(n, function(r) {
    var i = +t, u = i / (r[1][0] - r[0][0]), o = (i - u * (r[1][0] + r[0][0])) / 2, a = -u * r[0][1];
    n.scale(150 * u).translate([o, a]);
  }, e);
}
function Oa(n, t, e) {
  return Ia(n, function(r) {
    var i = +t, u = i / (r[1][1] - r[0][1]), o = -u * r[0][0], a = (i - u * (r[1][1] + r[0][1])) / 2;
    n.scale(150 * u).translate([o, a]);
  }, e);
}
var Lc = 16, nm = O(30 * F);
function Dc(n, t) {
  return +t ? em(n, t) : tm(n);
}
function tm(n) {
  return Cr({
    point: function(t, e) {
      t = n(t, e), this.stream.point(t[0], t[1]);
    }
  });
}
function em(n, t) {
  function e(r, i, u, o, a, s, c, l, h, f, p, g, d, v) {
    var y = c - r, x = l - i, m = y * y + x * x;
    if (m > 4 * t && d--) {
      var w = o + f, M = a + p, N = s + g, S = ln(w * w + M * M + N * N), E = In(N /= S), T = Z(Z(N) - 1) < U || Z(u - h) < U ? (u + h) / 2 : Nn(M, w), $ = n(T, E), A = $[0], k = $[1], _ = A - r, b = k - i, C = x * _ - y * b;
      (C * C / m > t || Z((y * _ + x * b) / m - 0.5) > 0.3 || o * f + a * p + s * g < nm) && (e(r, i, u, o, a, s, A, k, T, w /= S, M /= S, N, d, v), v.point(A, k), e(A, k, T, w, M, N, c, l, h, f, p, g, d, v));
    }
  }
  return function(r) {
    var i, u, o, a, s, c, l, h, f, p, g, d, v = {
      point: y,
      lineStart: x,
      lineEnd: w,
      polygonStart: function() {
        r.polygonStart(), v.lineStart = M;
      },
      polygonEnd: function() {
        r.polygonEnd(), v.lineStart = x;
      }
    };
    function y(E, T) {
      E = n(E, T), r.point(E[0], E[1]);
    }
    function x() {
      h = NaN, v.point = m, r.lineStart();
    }
    function m(E, T) {
      var $ = Ut([E, T]), A = n(E, T);
      e(h, f, l, p, g, d, h = A[0], f = A[1], l = E, p = $[0], g = $[1], d = $[2], Lc, r), r.point(h, f);
    }
    function w() {
      v.point = y, r.lineEnd();
    }
    function M() {
      x(), v.point = N, v.lineEnd = S;
    }
    function N(E, T) {
      m(i = E, T), u = h, o = f, a = p, s = g, c = d, v.point = m;
    }
    function S() {
      e(h, f, l, p, g, d, u, o, i, a, s, c, Lc, r), v.lineEnd = w, w();
    }
    return v;
  };
}
var rm = Cr({
  point: function(n, t) {
    this.stream.point(n * F, t * F);
  }
});
function im(n) {
  return Cr({
    point: function(t, e) {
      var r = n(t, e);
      return this.stream.point(r[0], r[1]);
    }
  });
}
function ct(n) {
  return Ua(function() {
    return n;
  })();
}
function Ua(n) {
  var t, e = 150, r = 480, i = 250, u, o, a = 0, s = 0, c = 0, l = 0, h = 0, f, p, g = null, d = qo, v = null, y, x, m, w = zt, M = 0.5, N = Dc(A, M), S, E;
  function T(b) {
    return b = p(b[0] * F, b[1] * F), [b[0] * e + u, o - b[1] * e];
  }
  function $(b) {
    return b = p.invert((b[0] - u) / e, (o - b[1]) / e), b && [b[0] * un, b[1] * un];
  }
  function A(b, C) {
    return b = t(b, C), [b[0] * e + u, o - b[1] * e];
  }
  T.stream = function(b) {
    return S && E === b ? S : S = rm(im(f)(d(N(w(E = b)))));
  }, T.preclip = function(b) {
    return arguments.length ? (d = b, g = void 0, _()) : d;
  }, T.postclip = function(b) {
    return arguments.length ? (w = b, v = y = x = m = null, _()) : w;
  }, T.clipAngle = function(b) {
    return arguments.length ? (d = +b ? jl(g = b * F) : (g = null, qo), _()) : g * un;
  }, T.clipExtent = function(b) {
    return arguments.length ? (w = b == null ? (v = y = x = m = null, zt) : mu(v = +b[0][0], y = +b[0][1], x = +b[1][0], m = +b[1][1]), _()) : v == null ? null : [[v, y], [x, m]];
  }, T.scale = function(b) {
    return arguments.length ? (e = +b, k()) : e;
  }, T.translate = function(b) {
    return arguments.length ? (r = +b[0], i = +b[1], k()) : [r, i];
  }, T.center = function(b) {
    return arguments.length ? (a = b[0] % 360 * F, s = b[1] % 360 * F, k()) : [a * un, s * un];
  }, T.rotate = function(b) {
    return arguments.length ? (c = b[0] % 360 * F, l = b[1] % 360 * F, h = b.length > 2 ? b[2] % 360 * F : 0, k()) : [c * un, l * un, h * un];
  }, T.precision = function(b) {
    return arguments.length ? (N = Dc(A, M = b * b), _()) : ln(M);
  }, T.fitExtent = function(b, C) {
    return _u(T, b, C);
  }, T.fitSize = function(b, C) {
    return La(T, b, C);
  }, T.fitWidth = function(b, C) {
    return Da(T, b, C);
  }, T.fitHeight = function(b, C) {
    return Oa(T, b, C);
  };
  function k() {
    p = Wl(f = za(c, l, h), t);
    var b = t(a, s);
    return u = r - b[0] * e, o = i + b[1] * e, _();
  }
  function _() {
    return S = E = null, T;
  }
  return function() {
    return t = n.apply(this, arguments), T.invert = t.invert && $, k();
  };
}
function Fa(n) {
  var t = 0, e = W / 3, r = Ua(n), i = r(t, e);
  return i.parallels = function(u) {
    return arguments.length ? r(t = u[0] * F, e = u[1] * F) : [t * un, e * un];
  }, i;
}
function um(n) {
  var t = O(n);
  function e(r, i) {
    return [r * t, D(i) / t];
  }
  return e.invert = function(r, i) {
    return [r / t, In(i * t)];
  }, e;
}
function gh(n, t) {
  var e = D(n), r = (e + D(t)) / 2;
  if (Z(r) < U) return um(n);
  var i = 1 + e * (2 * r - e), u = ln(i) / r;
  function o(a, s) {
    var c = ln(i - 2 * r * D(s)) / r;
    return [c * D(a *= r), u - c * O(a)];
  }
  return o.invert = function(a, s) {
    var c = u - s;
    return [Nn(a, Z(c)) / r * gr(c), In((i - (a * a + c * c) * r * r) / (2 * r))];
  }, o;
}
function Vi() {
  return Fa(gh).scale(155.424).center([0, 33.6442]);
}
function dh() {
  return Vi().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function om(n) {
  var t = n.length;
  return {
    point: function(e, r) {
      for (var i = -1; ++i < t; ) n[i].point(e, r);
    },
    sphere: function() {
      for (var e = -1; ++e < t; ) n[e].sphere();
    },
    lineStart: function() {
      for (var e = -1; ++e < t; ) n[e].lineStart();
    },
    lineEnd: function() {
      for (var e = -1; ++e < t; ) n[e].lineEnd();
    },
    polygonStart: function() {
      for (var e = -1; ++e < t; ) n[e].polygonStart();
    },
    polygonEnd: function() {
      for (var e = -1; ++e < t; ) n[e].polygonEnd();
    }
  };
}
function am() {
  var n, t, e = dh(), r, i = Vi().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), u, o = Vi().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), a, s, c = { point: function(f, p) {
    s = [f, p];
  } };
  function l(f) {
    var p = f[0], g = f[1];
    return s = null, r.point(p, g), s || (u.point(p, g), s) || (a.point(p, g), s);
  }
  l.invert = function(f) {
    var p = e.scale(), g = e.translate(), d = (f[0] - g[0]) / p, v = (f[1] - g[1]) / p;
    return (v >= 0.12 && v < 0.234 && d >= -0.425 && d < -0.214 ? i : v >= 0.166 && v < 0.234 && d >= -0.214 && d < -0.115 ? o : e).invert(f);
  }, l.stream = function(f) {
    return n && t === f ? n : n = om([e.stream(t = f), i.stream(f), o.stream(f)]);
  }, l.precision = function(f) {
    return arguments.length ? (e.precision(f), i.precision(f), o.precision(f), h()) : e.precision();
  }, l.scale = function(f) {
    return arguments.length ? (e.scale(f), i.scale(f * 0.35), o.scale(f), l.translate(e.translate())) : e.scale();
  }, l.translate = function(f) {
    if (!arguments.length) return e.translate();
    var p = e.scale(), g = +f[0], d = +f[1];
    return r = e.translate(f).clipExtent([[g - 0.455 * p, d - 0.238 * p], [g + 0.455 * p, d + 0.238 * p]]).stream(c), u = i.translate([g - 0.307 * p, d + 0.201 * p]).clipExtent([[g - 0.425 * p + U, d + 0.12 * p + U], [g - 0.214 * p - U, d + 0.234 * p - U]]).stream(c), a = o.translate([g - 0.205 * p, d + 0.212 * p]).clipExtent([[g - 0.214 * p + U, d + 0.166 * p + U], [g - 0.115 * p - U, d + 0.234 * p - U]]).stream(c), h();
  }, l.fitExtent = function(f, p) {
    return _u(l, f, p);
  }, l.fitSize = function(f, p) {
    return La(l, f, p);
  }, l.fitWidth = function(f, p) {
    return Da(l, f, p);
  }, l.fitHeight = function(f, p) {
    return Oa(l, f, p);
  };
  function h() {
    return n = t = null, l;
  }
  return l.scale(1070);
}
function vh(n) {
  return function(t, e) {
    var r = O(t), i = O(e), u = n(r * i);
    return [
      u * i * D(t),
      u * D(e)
    ];
  };
}
function Ar(n) {
  return function(t, e) {
    var r = ln(t * t + e * e), i = n(r), u = D(i), o = O(i);
    return [
      Nn(t * u, r * o),
      In(r && e * u / r)
    ];
  };
}
var Ya = vh(function(n) {
  return ln(2 / (1 + n));
});
Ya.invert = Ar(function(n) {
  return 2 * In(n / 2);
});
function sm() {
  return ct(Ya).scale(124.75).clipAngle(180 - 1e-3);
}
var qa = vh(function(n) {
  return (n = Il(n)) && n / D(n);
});
qa.invert = Ar(function(n) {
  return n;
});
function cm() {
  return ct(qa).scale(79.4188).clipAngle(180 - 1e-3);
}
function Rr(n, t) {
  return [n, ki($a((cn + t) / 2))];
}
Rr.invert = function(n, t) {
  return [n, 2 * xe(zl(t)) - cn];
};
function fm() {
  return yh(Rr).scale(961 / Cn);
}
function yh(n) {
  var t = ct(n), e = t.center, r = t.scale, i = t.translate, u = t.clipExtent, o = null, a, s, c;
  t.scale = function(h) {
    return arguments.length ? (r(h), l()) : r();
  }, t.translate = function(h) {
    return arguments.length ? (i(h), l()) : i();
  }, t.center = function(h) {
    return arguments.length ? (e(h), l()) : e();
  }, t.clipExtent = function(h) {
    return arguments.length ? (h == null ? o = a = s = c = null : (o = +h[0][0], a = +h[0][1], s = +h[1][0], c = +h[1][1]), l()) : o == null ? null : [[o, a], [s, c]];
  };
  function l() {
    var h = W * r(), f = t(Vl(t.rotate()).invert([0, 0]));
    return u(o == null ? [[f[0] - h, f[1] - h], [f[0] + h, f[1] + h]] : n === Rr ? [[Math.max(f[0] - h, o), a], [Math.min(f[0] + h, s), c]] : [[o, Math.max(f[1] - h, a)], [s, Math.min(f[1] + h, c)]]);
  }
  return l();
}
function Gr(n) {
  return $a((cn + n) / 2);
}
function mh(n, t) {
  var e = O(n), r = n === t ? D(n) : ki(e / O(t)) / ki(Gr(t) / Gr(n)), i = e * Gu(Gr(n), r) / r;
  if (!r) return Rr;
  function u(o, a) {
    i > 0 ? a < -cn + U && (a = -cn + U) : a > cn - U && (a = cn - U);
    var s = i / Gu(Gr(a), r);
    return [s * D(r * o), i - s * O(r * o)];
  }
  return u.invert = function(o, a) {
    var s = i - a, c = gr(r) * ln(o * o + s * s);
    return [Nn(o, Z(s)) / r * gr(s), 2 * xe(Gu(i / c, 1 / r)) - cn];
  }, u;
}
function lm() {
  return Fa(mh).scale(109.5).parallels([30, 30]);
}
function yr(n, t) {
  return [n, t];
}
yr.invert = yr;
function hm() {
  return ct(yr).scale(152.63);
}
function _h(n, t) {
  var e = O(n), r = n === t ? D(n) : (e - O(t)) / (t - n), i = e / r + n;
  if (Z(r) < U) return yr;
  function u(o, a) {
    var s = i - a, c = r * o;
    return [s * D(c), i - s * O(c)];
  }
  return u.invert = function(o, a) {
    var s = i - a;
    return [Nn(o, Z(s)) / r * gr(s), i - gr(r) * ln(o * o + s * s)];
  }, u;
}
function pm() {
  return Fa(_h).scale(131.154).center([0, 13.9389]);
}
function Ha(n, t) {
  var e = O(t), r = O(n) * e;
  return [e * D(n) / r, D(t) / r];
}
Ha.invert = Ar(xe);
function gm() {
  return ct(Ha).scale(144.049).clipAngle(60);
}
function Qr(n, t, e, r) {
  return n === 1 && t === 1 && e === 0 && r === 0 ? zt : Cr({
    point: function(i, u) {
      this.stream.point(i * n + e, u * t + r);
    }
  });
}
function dm() {
  var n = 1, t = 0, e = 0, r = 1, i = 1, u = zt, o = null, a, s, c, l = zt, h, f, p;
  function g() {
    return h = f = null, p;
  }
  return p = {
    stream: function(d) {
      return h && f === d ? h : h = u(l(f = d));
    },
    postclip: function(d) {
      return arguments.length ? (l = d, o = a = s = c = null, g()) : l;
    },
    clipExtent: function(d) {
      return arguments.length ? (l = d == null ? (o = a = s = c = null, zt) : mu(o = +d[0][0], a = +d[0][1], s = +d[1][0], c = +d[1][1]), g()) : o == null ? null : [[o, a], [s, c]];
    },
    scale: function(d) {
      return arguments.length ? (u = Qr((n = +d) * r, n * i, t, e), g()) : n;
    },
    translate: function(d) {
      return arguments.length ? (u = Qr(n * r, n * i, t = +d[0], e = +d[1]), g()) : [t, e];
    },
    reflectX: function(d) {
      return arguments.length ? (u = Qr(n * (r = d ? -1 : 1), n * i, t, e), g()) : r < 0;
    },
    reflectY: function(d) {
      return arguments.length ? (u = Qr(n * r, n * (i = d ? -1 : 1), t, e), g()) : i < 0;
    },
    fitExtent: function(d, v) {
      return _u(p, d, v);
    },
    fitSize: function(d, v) {
      return La(p, d, v);
    },
    fitWidth: function(d, v) {
      return Da(p, d, v);
    },
    fitHeight: function(d, v) {
      return Oa(p, d, v);
    }
  };
}
function Ba(n, t) {
  var e = t * t, r = e * e;
  return [
    n * (0.8707 - 0.131979 * e + r * (-0.013791 + r * (3971e-6 * e - 1529e-6 * r))),
    t * (1.007226 + e * (0.015085 + r * (-0.044475 + 0.028874 * e - 5916e-6 * r)))
  ];
}
Ba.invert = function(n, t) {
  var e = t, r = 25, i;
  do {
    var u = e * e, o = u * u;
    e -= i = (e * (1.007226 + u * (0.015085 + o * (-0.044475 + 0.028874 * u - 5916e-6 * o))) - t) / (1.007226 + u * (0.015085 * 3 + o * (-0.044475 * 7 + 0.028874 * 9 * u - 5916e-6 * 11 * o)));
  } while (Z(i) > U && --r > 0);
  return [
    n / (0.8707 + (u = e * e) * (-0.131979 + u * (-0.013791 + u * u * u * (3971e-6 - 1529e-6 * u)))),
    e
  ];
};
function vm() {
  return ct(Ba).scale(175.295);
}
function Xa(n, t) {
  return [O(t) * D(n), D(t)];
}
Xa.invert = Ar(In);
function ym() {
  return ct(Xa).scale(249.5).clipAngle(90 + U);
}
function Wa(n, t) {
  var e = O(t), r = 1 + O(n) * e;
  return [e * D(n) / r, D(t) / r];
}
Wa.invert = Ar(function(n) {
  return 2 * xe(n);
});
function mm() {
  return ct(Wa).scale(250).clipAngle(142);
}
function Va(n, t) {
  return [ki($a((cn + t) / 2)), -n];
}
Va.invert = function(n, t) {
  return [-t, 2 * xe(zl(n)) - cn];
};
function _m() {
  var n = yh(Va), t = n.center, e = n.rotate;
  return n.center = function(r) {
    return arguments.length ? t([-r[1], r[0]]) : (r = t(), [r[1], -r[0]]);
  }, n.rotate = function(r) {
    return arguments.length ? e([r[0], r[1], r.length > 2 ? r[2] + 90 : 90]) : (r = e(), [r[0], r[1], r[2] - 90]);
  }, e([0, 0, 90]).scale(159.155);
}
function wm(n, t) {
  return n.parent === t.parent ? 1 : 2;
}
function xm(n) {
  return n.reduce(bm, 0) / n.length;
}
function bm(n, t) {
  return n + t.x;
}
function Mm(n) {
  return 1 + n.reduce(Sm, 0);
}
function Sm(n, t) {
  return Math.max(n, t.y);
}
function Tm(n) {
  for (var t; t = n.children; ) n = t[0];
  return n;
}
function Nm(n) {
  for (var t; t = n.children; ) n = t[t.length - 1];
  return n;
}
function Em() {
  var n = wm, t = 1, e = 1, r = !1;
  function i(u) {
    var o, a = 0;
    u.eachAfter(function(f) {
      var p = f.children;
      p ? (f.x = xm(p), f.y = Mm(p)) : (f.x = o ? a += n(f, o) : 0, f.y = 0, o = f);
    });
    var s = Tm(u), c = Nm(u), l = s.x - n(s, c) / 2, h = c.x + n(c, s) / 2;
    return u.eachAfter(r ? function(f) {
      f.x = (f.x - u.x) * t, f.y = (u.y - f.y) * e;
    } : function(f) {
      f.x = (f.x - l) / (h - l) * t, f.y = (1 - (u.y ? f.y / u.y : 1)) * e;
    });
  }
  return i.separation = function(u) {
    return arguments.length ? (n = u, i) : n;
  }, i.size = function(u) {
    return arguments.length ? (r = !1, t = +u[0], e = +u[1], i) : r ? null : [t, e];
  }, i.nodeSize = function(u) {
    return arguments.length ? (r = !0, t = +u[0], e = +u[1], i) : r ? [t, e] : null;
  }, i;
}
function km(n) {
  var t = 0, e = n.children, r = e && e.length;
  if (!r) t = 1;
  else for (; --r >= 0; ) t += e[r].value;
  n.value = t;
}
function Cm() {
  return this.eachAfter(km);
}
function Am(n) {
  var t = this, e, r = [t], i, u, o;
  do
    for (e = r.reverse(), r = []; t = e.pop(); )
      if (n(t), i = t.children, i) for (u = 0, o = i.length; u < o; ++u)
        r.push(i[u]);
  while (r.length);
  return this;
}
function Rm(n) {
  for (var t = this, e = [t], r, i; t = e.pop(); )
    if (n(t), r = t.children, r) for (i = r.length - 1; i >= 0; --i)
      e.push(r[i]);
  return this;
}
function $m(n) {
  for (var t = this, e = [t], r = [], i, u, o; t = e.pop(); )
    if (r.push(t), i = t.children, i) for (u = 0, o = i.length; u < o; ++u)
      e.push(i[u]);
  for (; t = r.pop(); )
    n(t);
  return this;
}
function Pm(n) {
  return this.eachAfter(function(t) {
    for (var e = +n(t.data) || 0, r = t.children, i = r && r.length; --i >= 0; ) e += r[i].value;
    t.value = e;
  });
}
function zm(n) {
  return this.eachBefore(function(t) {
    t.children && t.children.sort(n);
  });
}
function Im(n) {
  for (var t = this, e = Lm(t, n), r = [t]; t !== e; )
    t = t.parent, r.push(t);
  for (var i = r.length; n !== e; )
    r.splice(i, 0, n), n = n.parent;
  return r;
}
function Lm(n, t) {
  if (n === t) return n;
  var e = n.ancestors(), r = t.ancestors(), i = null;
  for (n = e.pop(), t = r.pop(); n === t; )
    i = n, n = e.pop(), t = r.pop();
  return i;
}
function Dm() {
  for (var n = this, t = [n]; n = n.parent; )
    t.push(n);
  return t;
}
function Om() {
  var n = [];
  return this.each(function(t) {
    n.push(t);
  }), n;
}
function Um() {
  var n = [];
  return this.eachBefore(function(t) {
    t.children || n.push(t);
  }), n;
}
function Fm() {
  var n = this, t = [];
  return n.each(function(e) {
    e !== n && t.push({ source: e.parent, target: e });
  }), t;
}
function Za(n, t) {
  var e = new ve(n), r = +n.value && (e.value = n.value), i, u = [e], o, a, s, c;
  for (t == null && (t = qm); i = u.pop(); )
    if (r && (i.value = +i.data.value), (a = t(i.data)) && (c = a.length))
      for (i.children = new Array(c), s = c - 1; s >= 0; --s)
        u.push(o = i.children[s] = new ve(a[s])), o.parent = i, o.depth = i.depth + 1;
  return e.eachBefore(wh);
}
function Ym() {
  return Za(this).eachBefore(Hm);
}
function qm(n) {
  return n.children;
}
function Hm(n) {
  n.data = n.data.data;
}
function wh(n) {
  var t = 0;
  do
    n.height = t;
  while ((n = n.parent) && n.height < ++t);
}
function ve(n) {
  this.data = n, this.depth = this.height = 0, this.parent = null;
}
ve.prototype = Za.prototype = {
  constructor: ve,
  count: Cm,
  each: Am,
  eachAfter: $m,
  eachBefore: Rm,
  sum: Pm,
  sort: zm,
  path: Im,
  ancestors: Dm,
  descendants: Om,
  leaves: Um,
  links: Fm,
  copy: Ym
};
var Bm = Array.prototype.slice;
function Xm(n) {
  for (var t = n.length, e, r; t; )
    r = Math.random() * t-- | 0, e = n[t], n[t] = n[r], n[r] = e;
  return n;
}
function xh(n) {
  for (var t = 0, e = (n = Xm(Bm.call(n))).length, r = [], i, u; t < e; )
    i = n[t], u && bh(u, i) ? ++t : (u = Vm(r = Wm(r, i)), t = 0);
  return u;
}
function Wm(n, t) {
  var e, r;
  if (no(t, n)) return [t];
  for (e = 0; e < n.length; ++e)
    if (Kr(t, n[e]) && no(Be(n[e], t), n))
      return [n[e], t];
  for (e = 0; e < n.length - 1; ++e)
    for (r = e + 1; r < n.length; ++r)
      if (Kr(Be(n[e], n[r]), t) && Kr(Be(n[e], t), n[r]) && Kr(Be(n[r], t), n[e]) && no(Mh(n[e], n[r], t), n))
        return [n[e], n[r], t];
  throw new Error();
}
function Kr(n, t) {
  var e = n.r - t.r, r = t.x - n.x, i = t.y - n.y;
  return e < 0 || e * e < r * r + i * i;
}
function bh(n, t) {
  var e = n.r - t.r + 1e-6, r = t.x - n.x, i = t.y - n.y;
  return e > 0 && e * e > r * r + i * i;
}
function no(n, t) {
  for (var e = 0; e < t.length; ++e)
    if (!bh(n, t[e]))
      return !1;
  return !0;
}
function Vm(n) {
  switch (n.length) {
    case 1:
      return Zm(n[0]);
    case 2:
      return Be(n[0], n[1]);
    case 3:
      return Mh(n[0], n[1], n[2]);
  }
}
function Zm(n) {
  return {
    x: n.x,
    y: n.y,
    r: n.r
  };
}
function Be(n, t) {
  var e = n.x, r = n.y, i = n.r, u = t.x, o = t.y, a = t.r, s = u - e, c = o - r, l = a - i, h = Math.sqrt(s * s + c * c);
  return {
    x: (e + u + s / h * l) / 2,
    y: (r + o + c / h * l) / 2,
    r: (h + i + a) / 2
  };
}
function Mh(n, t, e) {
  var r = n.x, i = n.y, u = n.r, o = t.x, a = t.y, s = t.r, c = e.x, l = e.y, h = e.r, f = r - o, p = r - c, g = i - a, d = i - l, v = s - u, y = h - u, x = r * r + i * i - u * u, m = x - o * o - a * a + s * s, w = x - c * c - l * l + h * h, M = p * g - f * d, N = (g * w - d * m) / (M * 2) - r, S = (d * v - g * y) / M, E = (p * m - f * w) / (M * 2) - i, T = (f * y - p * v) / M, $ = S * S + T * T - 1, A = 2 * (u + N * S + E * T), k = N * N + E * E - u * u, _ = -($ ? (A + Math.sqrt(A * A - 4 * $ * k)) / (2 * $) : k / A);
  return {
    x: r + N + S * _,
    y: i + E + T * _,
    r: _
  };
}
function Oc(n, t, e) {
  var r = n.x, i = n.y, u = t.r + e.r, o = n.r + e.r, a = t.x - r, s = t.y - i, c = a * a + s * s;
  if (c) {
    var l = 0.5 + ((o *= o) - (u *= u)) / (2 * c), h = Math.sqrt(Math.max(0, 2 * u * (o + c) - (o -= c) * o - u * u)) / (2 * c);
    e.x = r + l * a + h * s, e.y = i + l * s - h * a;
  } else
    e.x = r + o, e.y = i;
}
function Uc(n, t) {
  var e = t.x - n.x, r = t.y - n.y, i = n.r + t.r;
  return i * i - 1e-6 > e * e + r * r;
}
function Fc(n) {
  var t = n._, e = n.next._, r = t.r + e.r, i = (t.x * e.r + e.x * t.r) / r, u = (t.y * e.r + e.y * t.r) / r;
  return i * i + u * u;
}
function Jr(n) {
  this._ = n, this.next = null, this.previous = null;
}
function Sh(n) {
  if (!(i = n.length)) return 0;
  var t, e, r, i, u, o, a, s, c, l, h;
  if (t = n[0], t.x = 0, t.y = 0, !(i > 1)) return t.r;
  if (e = n[1], t.x = -e.r, e.x = t.r, e.y = 0, !(i > 2)) return t.r + e.r;
  Oc(e, t, r = n[2]), t = new Jr(t), e = new Jr(e), r = new Jr(r), t.next = r.previous = e, e.next = t.previous = r, r.next = e.previous = t;
  n: for (a = 3; a < i; ++a) {
    Oc(t._, e._, r = n[a]), r = new Jr(r), s = e.next, c = t.previous, l = e._.r, h = t._.r;
    do
      if (l <= h) {
        if (Uc(s._, r._)) {
          e = s, t.next = e, e.previous = t, --a;
          continue n;
        }
        l += s._.r, s = s.next;
      } else {
        if (Uc(c._, r._)) {
          t = c, t.next = e, e.previous = t, --a;
          continue n;
        }
        h += c._.r, c = c.previous;
      }
    while (s !== c.next);
    for (r.previous = t, r.next = e, t.next = e.previous = e = r, u = Fc(t); (r = r.next) !== e; )
      (o = Fc(r)) < u && (t = r, u = o);
    e = t.next;
  }
  for (t = [e._], r = e; (r = r.next) !== e; ) t.push(r._);
  for (r = xh(t), a = 0; a < i; ++a) t = n[a], t.x -= r.x, t.y -= r.y;
  return r.r;
}
function Gm(n) {
  return Sh(n), n;
}
function Qm(n) {
  return n == null ? null : Zi(n);
}
function Zi(n) {
  if (typeof n != "function") throw new Error();
  return n;
}
function Rt() {
  return 0;
}
function jt(n) {
  return function() {
    return n;
  };
}
function Km(n) {
  return Math.sqrt(n.value);
}
function Jm() {
  var n = null, t = 1, e = 1, r = Rt;
  function i(u) {
    return u.x = t / 2, u.y = e / 2, n ? u.eachBefore(Yc(n)).eachAfter(to(r, 0.5)).eachBefore(qc(1)) : u.eachBefore(Yc(Km)).eachAfter(to(Rt, 1)).eachAfter(to(r, u.r / Math.min(t, e))).eachBefore(qc(Math.min(t, e) / (2 * u.r))), u;
  }
  return i.radius = function(u) {
    return arguments.length ? (n = Qm(u), i) : n;
  }, i.size = function(u) {
    return arguments.length ? (t = +u[0], e = +u[1], i) : [t, e];
  }, i.padding = function(u) {
    return arguments.length ? (r = typeof u == "function" ? u : jt(+u), i) : r;
  }, i;
}
function Yc(n) {
  return function(t) {
    t.children || (t.r = Math.max(0, +n(t) || 0));
  };
}
function to(n, t) {
  return function(e) {
    if (r = e.children) {
      var r, i, u = r.length, o = n(e) * t || 0, a;
      if (o) for (i = 0; i < u; ++i) r[i].r += o;
      if (a = Sh(r), o) for (i = 0; i < u; ++i) r[i].r -= o;
      e.r = a + o;
    }
  };
}
function qc(n) {
  return function(t) {
    var e = t.parent;
    t.r *= n, e && (t.x = e.x + n * t.x, t.y = e.y + n * t.y);
  };
}
function Th(n) {
  n.x0 = Math.round(n.x0), n.y0 = Math.round(n.y0), n.x1 = Math.round(n.x1), n.y1 = Math.round(n.y1);
}
function $r(n, t, e, r, i) {
  for (var u = n.children, o, a = -1, s = u.length, c = n.value && (r - t) / n.value; ++a < s; )
    o = u[a], o.y0 = e, o.y1 = i, o.x0 = t, o.x1 = t += o.value * c;
}
function jm() {
  var n = 1, t = 1, e = 0, r = !1;
  function i(o) {
    var a = o.height + 1;
    return o.x0 = o.y0 = e, o.x1 = n, o.y1 = t / a, o.eachBefore(u(t, a)), r && o.eachBefore(Th), o;
  }
  function u(o, a) {
    return function(s) {
      s.children && $r(s, s.x0, o * (s.depth + 1) / a, s.x1, o * (s.depth + 2) / a);
      var c = s.x0, l = s.y0, h = s.x1 - e, f = s.y1 - e;
      h < c && (c = h = (c + h) / 2), f < l && (l = f = (l + f) / 2), s.x0 = c, s.y0 = l, s.x1 = h, s.y1 = f;
    };
  }
  return i.round = function(o) {
    return arguments.length ? (r = !!o, i) : r;
  }, i.size = function(o) {
    return arguments.length ? (n = +o[0], t = +o[1], i) : [n, t];
  }, i.padding = function(o) {
    return arguments.length ? (e = +o, i) : e;
  }, i;
}
var Hc = "$", n2 = { depth: -1 }, Bc = {};
function t2(n) {
  return n.id;
}
function e2(n) {
  return n.parentId;
}
function r2() {
  var n = t2, t = e2;
  function e(r) {
    var i, u, o = r.length, a, s, c, l = new Array(o), h, f, p = {};
    for (u = 0; u < o; ++u)
      i = r[u], c = l[u] = new ve(i), (h = n(i, u, r)) != null && (h += "") && (f = Hc + (c.id = h), p[f] = f in p ? Bc : c);
    for (u = 0; u < o; ++u)
      if (c = l[u], h = t(r[u], u, r), h == null || !(h += "")) {
        if (a) throw new Error("multiple roots");
        a = c;
      } else {
        if (s = p[Hc + h], !s) throw new Error("missing: " + h);
        if (s === Bc) throw new Error("ambiguous: " + h);
        s.children ? s.children.push(c) : s.children = [c], c.parent = s;
      }
    if (!a) throw new Error("no root");
    if (a.parent = n2, a.eachBefore(function(g) {
      g.depth = g.parent.depth + 1, --o;
    }).eachBefore(wh), a.parent = null, o > 0) throw new Error("cycle");
    return a;
  }
  return e.id = function(r) {
    return arguments.length ? (n = Zi(r), e) : n;
  }, e.parentId = function(r) {
    return arguments.length ? (t = Zi(r), e) : t;
  }, e;
}
function i2(n, t) {
  return n.parent === t.parent ? 1 : 2;
}
function eo(n) {
  var t = n.children;
  return t ? t[0] : n.t;
}
function ro(n) {
  var t = n.children;
  return t ? t[t.length - 1] : n.t;
}
function u2(n, t, e) {
  var r = e / (t.i - n.i);
  t.c -= r, t.s += e, n.c += r, t.z += e, t.m += e;
}
function o2(n) {
  for (var t = 0, e = 0, r = n.children, i = r.length, u; --i >= 0; )
    u = r[i], u.z += t, u.m += t, t += u.s + (e += u.c);
}
function a2(n, t, e) {
  return n.a.parent === t.parent ? n.a : e;
}
function pi(n, t) {
  this._ = n, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = t;
}
pi.prototype = Object.create(ve.prototype);
function s2(n) {
  for (var t = new pi(n, 0), e, r = [t], i, u, o, a; e = r.pop(); )
    if (u = e._.children)
      for (e.children = new Array(a = u.length), o = a - 1; o >= 0; --o)
        r.push(i = e.children[o] = new pi(u[o], o)), i.parent = e;
  return (t.parent = new pi(null, 0)).children = [t], t;
}
function c2() {
  var n = i2, t = 1, e = 1, r = null;
  function i(c) {
    var l = s2(c);
    if (l.eachAfter(u), l.parent.m = -l.z, l.eachBefore(o), r) c.eachBefore(s);
    else {
      var h = c, f = c, p = c;
      c.eachBefore(function(x) {
        x.x < h.x && (h = x), x.x > f.x && (f = x), x.depth > p.depth && (p = x);
      });
      var g = h === f ? 1 : n(h, f) / 2, d = g - h.x, v = t / (f.x + g + d), y = e / (p.depth || 1);
      c.eachBefore(function(x) {
        x.x = (x.x + d) * v, x.y = x.depth * y;
      });
    }
    return c;
  }
  function u(c) {
    var l = c.children, h = c.parent.children, f = c.i ? h[c.i - 1] : null;
    if (l) {
      o2(c);
      var p = (l[0].z + l[l.length - 1].z) / 2;
      f ? (c.z = f.z + n(c._, f._), c.m = c.z - p) : c.z = p;
    } else f && (c.z = f.z + n(c._, f._));
    c.parent.A = a(c, f, c.parent.A || h[0]);
  }
  function o(c) {
    c._.x = c.z + c.parent.m, c.m += c.parent.m;
  }
  function a(c, l, h) {
    if (l) {
      for (var f = c, p = c, g = l, d = f.parent.children[0], v = f.m, y = p.m, x = g.m, m = d.m, w; g = ro(g), f = eo(f), g && f; )
        d = eo(d), p = ro(p), p.a = c, w = g.z + x - f.z - v + n(g._, f._), w > 0 && (u2(a2(g, c, h), c, w), v += w, y += w), x += g.m, v += f.m, m += d.m, y += p.m;
      g && !ro(p) && (p.t = g, p.m += x - y), f && !eo(d) && (d.t = f, d.m += v - m, h = c);
    }
    return h;
  }
  function s(c) {
    c.x *= t, c.y = c.depth * e;
  }
  return i.separation = function(c) {
    return arguments.length ? (n = c, i) : n;
  }, i.size = function(c) {
    return arguments.length ? (r = !1, t = +c[0], e = +c[1], i) : r ? null : [t, e];
  }, i.nodeSize = function(c) {
    return arguments.length ? (r = !0, t = +c[0], e = +c[1], i) : r ? [t, e] : null;
  }, i;
}
function wu(n, t, e, r, i) {
  for (var u = n.children, o, a = -1, s = u.length, c = n.value && (i - e) / n.value; ++a < s; )
    o = u[a], o.x0 = t, o.x1 = r, o.y0 = e, o.y1 = e += o.value * c;
}
var Nh = (1 + Math.sqrt(5)) / 2;
function Eh(n, t, e, r, i, u) {
  for (var o = [], a = t.children, s, c, l = 0, h = 0, f = a.length, p, g, d = t.value, v, y, x, m, w, M, N; l < f; ) {
    p = i - e, g = u - r;
    do
      v = a[h++].value;
    while (!v && h < f);
    for (y = x = v, M = Math.max(g / p, p / g) / (d * n), N = v * v * M, w = Math.max(x / N, N / y); h < f; ++h) {
      if (v += c = a[h].value, c < y && (y = c), c > x && (x = c), N = v * v * M, m = Math.max(x / N, N / y), m > w) {
        v -= c;
        break;
      }
      w = m;
    }
    o.push(s = { value: v, dice: p < g, children: a.slice(l, h) }), s.dice ? $r(s, e, r, i, d ? r += g * v / d : u) : wu(s, e, r, d ? e += p * v / d : i, u), d -= v, l = h;
  }
  return o;
}
const kh = function n(t) {
  function e(r, i, u, o, a) {
    Eh(t, r, i, u, o, a);
  }
  return e.ratio = function(r) {
    return n((r = +r) > 1 ? r : 1);
  }, e;
}(Nh);
function f2() {
  var n = kh, t = !1, e = 1, r = 1, i = [0], u = Rt, o = Rt, a = Rt, s = Rt, c = Rt;
  function l(f) {
    return f.x0 = f.y0 = 0, f.x1 = e, f.y1 = r, f.eachBefore(h), i = [0], t && f.eachBefore(Th), f;
  }
  function h(f) {
    var p = i[f.depth], g = f.x0 + p, d = f.y0 + p, v = f.x1 - p, y = f.y1 - p;
    v < g && (g = v = (g + v) / 2), y < d && (d = y = (d + y) / 2), f.x0 = g, f.y0 = d, f.x1 = v, f.y1 = y, f.children && (p = i[f.depth + 1] = u(f) / 2, g += c(f) - p, d += o(f) - p, v -= a(f) - p, y -= s(f) - p, v < g && (g = v = (g + v) / 2), y < d && (d = y = (d + y) / 2), n(f, g, d, v, y));
  }
  return l.round = function(f) {
    return arguments.length ? (t = !!f, l) : t;
  }, l.size = function(f) {
    return arguments.length ? (e = +f[0], r = +f[1], l) : [e, r];
  }, l.tile = function(f) {
    return arguments.length ? (n = Zi(f), l) : n;
  }, l.padding = function(f) {
    return arguments.length ? l.paddingInner(f).paddingOuter(f) : l.paddingInner();
  }, l.paddingInner = function(f) {
    return arguments.length ? (u = typeof f == "function" ? f : jt(+f), l) : u;
  }, l.paddingOuter = function(f) {
    return arguments.length ? l.paddingTop(f).paddingRight(f).paddingBottom(f).paddingLeft(f) : l.paddingTop();
  }, l.paddingTop = function(f) {
    return arguments.length ? (o = typeof f == "function" ? f : jt(+f), l) : o;
  }, l.paddingRight = function(f) {
    return arguments.length ? (a = typeof f == "function" ? f : jt(+f), l) : a;
  }, l.paddingBottom = function(f) {
    return arguments.length ? (s = typeof f == "function" ? f : jt(+f), l) : s;
  }, l.paddingLeft = function(f) {
    return arguments.length ? (c = typeof f == "function" ? f : jt(+f), l) : c;
  }, l;
}
function l2(n, t, e, r, i) {
  var u = n.children, o, a = u.length, s, c = new Array(a + 1);
  for (c[0] = s = o = 0; o < a; ++o)
    c[o + 1] = s += u[o].value;
  l(0, a, n.value, t, e, r, i);
  function l(h, f, p, g, d, v, y) {
    if (h >= f - 1) {
      var x = u[h];
      x.x0 = g, x.y0 = d, x.x1 = v, x.y1 = y;
      return;
    }
    for (var m = c[h], w = p / 2 + m, M = h + 1, N = f - 1; M < N; ) {
      var S = M + N >>> 1;
      c[S] < w ? M = S + 1 : N = S;
    }
    w - c[M - 1] < c[M] - w && h + 1 < M && --M;
    var E = c[M] - m, T = p - E;
    if (v - g > y - d) {
      var $ = (g * T + v * E) / p;
      l(h, M, E, g, d, $, y), l(M, f, T, $, d, v, y);
    } else {
      var A = (d * T + y * E) / p;
      l(h, M, E, g, d, v, A), l(M, f, T, g, A, v, y);
    }
  }
}
function h2(n, t, e, r, i) {
  (n.depth & 1 ? wu : $r)(n, t, e, r, i);
}
const p2 = function n(t) {
  function e(r, i, u, o, a) {
    if ((s = r._squarify) && s.ratio === t)
      for (var s, c, l, h, f = -1, p, g = s.length, d = r.value; ++f < g; ) {
        for (c = s[f], l = c.children, h = c.value = 0, p = l.length; h < p; ++h) c.value += l[h].value;
        c.dice ? $r(c, i, u, o, u += (a - u) * c.value / d) : wu(c, i, u, i += (o - i) * c.value / d, a), d -= c.value;
      }
    else
      r._squarify = s = Eh(t, r, i, u, o, a), s.ratio = t;
  }
  return e.ratio = function(r) {
    return n((r = +r) > 1 ? r : 1);
  }, e;
}(Nh);
function g2(n) {
  for (var t = -1, e = n.length, r, i = n[e - 1], u = 0; ++t < e; )
    r = i, i = n[t], u += r[1] * i[0] - r[0] * i[1];
  return u / 2;
}
function d2(n) {
  for (var t = -1, e = n.length, r = 0, i = 0, u, o = n[e - 1], a, s = 0; ++t < e; )
    u = o, o = n[t], s += a = u[0] * o[1] - o[0] * u[1], r += (u[0] + o[0]) * a, i += (u[1] + o[1]) * a;
  return s *= 3, [r / s, i / s];
}
function v2(n, t, e) {
  return (t[0] - n[0]) * (e[1] - n[1]) - (t[1] - n[1]) * (e[0] - n[0]);
}
function y2(n, t) {
  return n[0] - t[0] || n[1] - t[1];
}
function Xc(n) {
  for (var t = n.length, e = [0, 1], r = 2, i = 2; i < t; ++i) {
    for (; r > 1 && v2(n[e[r - 2]], n[e[r - 1]], n[i]) <= 0; ) --r;
    e[r++] = i;
  }
  return e.slice(0, r);
}
function m2(n) {
  if ((e = n.length) < 3) return null;
  var t, e, r = new Array(e), i = new Array(e);
  for (t = 0; t < e; ++t) r[t] = [+n[t][0], +n[t][1], t];
  for (r.sort(y2), t = 0; t < e; ++t) i[t] = [r[t][0], -r[t][1]];
  var u = Xc(r), o = Xc(i), a = o[0] === u[0], s = o[o.length - 1] === u[u.length - 1], c = [];
  for (t = u.length - 1; t >= 0; --t) c.push(n[r[u[t]][2]]);
  for (t = +a; t < o.length - s; ++t) c.push(n[r[o[t]][2]]);
  return c;
}
function _2(n, t) {
  for (var e = n.length, r = n[e - 1], i = t[0], u = t[1], o = r[0], a = r[1], s, c, l = !1, h = 0; h < e; ++h)
    r = n[h], s = r[0], c = r[1], c > u != a > u && i < (o - s) * (u - c) / (a - c) + s && (l = !l), o = s, a = c;
  return l;
}
function w2(n) {
  for (var t = -1, e = n.length, r = n[e - 1], i, u, o = r[0], a = r[1], s = 0; ++t < e; )
    i = o, u = a, r = n[t], o = r[0], a = r[1], i -= o, u -= a, s += Math.sqrt(i * i + u * u);
  return s;
}
var x2 = [].slice, b2 = {};
function ta(n) {
  this._size = n, this._call = this._error = null, this._tasks = [], this._data = [], this._waiting = this._active = this._ended = this._start = 0;
}
ta.prototype = Ah.prototype = {
  constructor: ta,
  defer: function(n) {
    if (typeof n != "function") throw new Error("invalid callback");
    if (this._call) throw new Error("defer after await");
    if (this._error != null) return this;
    var t = x2.call(arguments, 1);
    return t.push(n), ++this._waiting, this._tasks.push(t), Ch(this), this;
  },
  abort: function() {
    return this._error == null && Ga(this, new Error("abort")), this;
  },
  await: function(n) {
    if (typeof n != "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    return this._call = function(t, e) {
      n.apply(null, [t].concat(e));
    }, Gi(this), this;
  },
  awaitAll: function(n) {
    if (typeof n != "function") throw new Error("invalid callback");
    if (this._call) throw new Error("multiple await");
    return this._call = n, Gi(this), this;
  }
};
function Ch(n) {
  if (!n._start)
    try {
      M2(n);
    } catch (t) {
      if (n._tasks[n._ended + n._active - 1]) Ga(n, t);
      else if (!n._data) throw t;
    }
}
function M2(n) {
  for (; n._start = n._waiting && n._active < n._size; ) {
    var t = n._ended + n._active, e = n._tasks[t], r = e.length - 1, i = e[r];
    e[r] = S2(n, t), --n._waiting, ++n._active, e = i.apply(null, e), n._tasks[t] && (n._tasks[t] = e || b2);
  }
}
function S2(n, t) {
  return function(e, r) {
    n._tasks[t] && (--n._active, ++n._ended, n._tasks[t] = null, n._error == null && (e != null ? Ga(n, e) : (n._data[t] = r, n._waiting ? Ch(n) : Gi(n))));
  };
}
function Ga(n, t) {
  var e = n._tasks.length, r;
  for (n._error = t, n._data = void 0, n._waiting = NaN; --e >= 0; )
    if ((r = n._tasks[e]) && (n._tasks[e] = null, r.abort))
      try {
        r.abort();
      } catch {
      }
  n._active = NaN, Gi(n);
}
function Gi(n) {
  if (!n._active && n._call) {
    var t = n._data;
    n._data = void 0, n._call(n._error, t);
  }
}
function Ah(n) {
  if (n == null) n = 1 / 0;
  else if (!((n = +n) >= 1)) throw new Error("invalid concurrency");
  return new ta(n);
}
function be() {
  return Math.random();
}
const T2 = function n(t) {
  function e(r, i) {
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, arguments.length === 1 ? (i = r, r = 0) : i -= r, function() {
      return t() * i + r;
    };
  }
  return e.source = n, e;
}(be), Rh = function n(t) {
  function e(r, i) {
    var u, o;
    return r = r == null ? 0 : +r, i = i == null ? 1 : +i, function() {
      var a;
      if (u != null) a = u, u = null;
      else do
        u = t() * 2 - 1, a = t() * 2 - 1, o = u * u + a * a;
      while (!o || o > 1);
      return r + i * a * Math.sqrt(-2 * Math.log(o) / o);
    };
  }
  return e.source = n, e;
}(be), N2 = function n(t) {
  function e() {
    var r = Rh.source(t).apply(this, arguments);
    return function() {
      return Math.exp(r());
    };
  }
  return e.source = n, e;
}(be), $h = function n(t) {
  function e(r) {
    return function() {
      for (var i = 0, u = 0; u < r; ++u) i += t();
      return i;
    };
  }
  return e.source = n, e;
}(be), E2 = function n(t) {
  function e(r) {
    var i = $h.source(t)(r);
    return function() {
      return i() / r;
    };
  }
  return e.source = n, e;
}(be), k2 = function n(t) {
  function e(r) {
    return function() {
      return -Math.log(1 - t()) / r;
    };
  }
  return e.source = n, e;
}(be);
function Qa(n, t) {
  var e, r = xt("beforesend", "progress", "load", "error"), i, u = Jn(), o = new XMLHttpRequest(), a = null, s = null, c, l, h = 0;
  typeof XDomainRequest < "u" && !("withCredentials" in o) && /^(http(s)?:)?\/\//.test(n) && (o = new XDomainRequest()), "onload" in o ? o.onload = o.onerror = o.ontimeout = f : o.onreadystatechange = function(p) {
    o.readyState > 3 && f(p);
  };
  function f(p) {
    var g = o.status, d;
    if (!g && A2(o) || g >= 200 && g < 300 || g === 304) {
      if (c)
        try {
          d = c.call(e, o);
        } catch (v) {
          r.call("error", e, v);
          return;
        }
      else
        d = o;
      r.call("load", e, d);
    } else
      r.call("error", e, p);
  }
  if (o.onprogress = function(p) {
    r.call("progress", e, p);
  }, e = {
    header: function(p, g) {
      return p = (p + "").toLowerCase(), arguments.length < 2 ? u.get(p) : (g == null ? u.remove(p) : u.set(p, g + ""), e);
    },
    // If mimeType is non-null and no Accept header is set, a default is used.
    mimeType: function(p) {
      return arguments.length ? (i = p == null ? null : p + "", e) : i;
    },
    // Specifies what type the response value should take;
    // for instance, arraybuffer, blob, document, or text.
    responseType: function(p) {
      return arguments.length ? (l = p, e) : l;
    },
    timeout: function(p) {
      return arguments.length ? (h = +p, e) : h;
    },
    user: function(p) {
      return arguments.length < 1 ? a : (a = p == null ? null : p + "", e);
    },
    password: function(p) {
      return arguments.length < 1 ? s : (s = p == null ? null : p + "", e);
    },
    // Specify how to convert the response content to a specific type;
    // changes the callback value on "load" events.
    response: function(p) {
      return c = p, e;
    },
    // Alias for send("GET", …).
    get: function(p, g) {
      return e.send("GET", p, g);
    },
    // Alias for send("POST", …).
    post: function(p, g) {
      return e.send("POST", p, g);
    },
    // If callback is non-null, it will be used for error and load events.
    send: function(p, g, d) {
      return o.open(p, n, !0, a, s), i != null && !u.has("accept") && u.set("accept", i + ",*/*"), o.setRequestHeader && u.each(function(v, y) {
        o.setRequestHeader(y, v);
      }), i != null && o.overrideMimeType && o.overrideMimeType(i), l != null && (o.responseType = l), h > 0 && (o.timeout = h), d == null && typeof g == "function" && (d = g, g = null), d != null && d.length === 1 && (d = C2(d)), d != null && e.on("error", d).on("load", function(v) {
        d(null, v);
      }), r.call("beforesend", e, o), o.send(g ?? null), e;
    },
    abort: function() {
      return o.abort(), e;
    },
    on: function() {
      var p = r.on.apply(r, arguments);
      return p === r ? e : p;
    }
  }, t != null) {
    if (typeof t != "function") throw new Error("invalid callback: " + t);
    return e.get(t);
  }
  return e;
}
function C2(n) {
  return function(t, e) {
    n(t == null ? e : null);
  };
}
function A2(n) {
  var t = n.responseType;
  return t && t !== "text" ? n.response : n.responseText;
}
function xu(n, t) {
  return function(e, r) {
    var i = Qa(e).mimeType(n).response(t);
    if (r != null) {
      if (typeof r != "function") throw new Error("invalid callback: " + r);
      return i.get(r);
    }
    return i;
  };
}
const R2 = xu("text/html", function(n) {
  return document.createRange().createContextualFragment(n.responseText);
}), $2 = xu("application/json", function(n) {
  return JSON.parse(n.responseText);
}), P2 = xu("text/plain", function(n) {
  return n.responseText;
}), z2 = xu("application/xml", function(n) {
  var t = n.responseXML;
  if (!t) throw new Error("parse error");
  return t;
});
function Ph(n, t) {
  return function(e, r, i) {
    arguments.length < 3 && (i = r, r = null);
    var u = Qa(e).mimeType(n);
    return u.row = function(o) {
      return arguments.length ? u.response(I2(t, r = o)) : r;
    }, u.row(r), i ? u.get(i) : u;
  };
}
function I2(n, t) {
  return function(e) {
    return n(e.responseText, t);
  };
}
const L2 = Ph("text/csv", Sl), D2 = Ph("text/tab-separated-values", Tl);
var zh = Array.prototype, Ka = zh.map, mt = zh.slice, ea = { name: "implicit" };
function Ja(n) {
  var t = Jn(), e = [], r = ea;
  n = n == null ? [] : mt.call(n);
  function i(u) {
    var o = u + "", a = t.get(o);
    if (!a) {
      if (r !== ea) return r;
      t.set(o, a = e.push(u));
    }
    return n[(a - 1) % n.length];
  }
  return i.domain = function(u) {
    if (!arguments.length) return e.slice();
    e = [], t = Jn();
    for (var o = -1, a = u.length, s, c; ++o < a; ) t.has(c = (s = u[o]) + "") || t.set(c, e.push(s));
    return i;
  }, i.range = function(u) {
    return arguments.length ? (n = mt.call(u), i) : n.slice();
  }, i.unknown = function(u) {
    return arguments.length ? (r = u, i) : r;
  }, i.copy = function() {
    return Ja().domain(e).range(n).unknown(r);
  }, i;
}
function ja() {
  var n = Ja().unknown(void 0), t = n.domain, e = n.range, r = [0, 1], i, u, o = !1, a = 0, s = 0, c = 0.5;
  delete n.unknown;
  function l() {
    var h = t().length, f = r[1] < r[0], p = r[f - 0], g = r[1 - f];
    i = (g - p) / Math.max(1, h - a + s * 2), o && (i = Math.floor(i)), p += (g - p - i * (h - a)) * c, u = i * (1 - a), o && (p = Math.round(p), u = Math.round(u));
    var d = qn(h).map(function(v) {
      return p + i * v;
    });
    return e(f ? d.reverse() : d);
  }
  return n.domain = function(h) {
    return arguments.length ? (t(h), l()) : t();
  }, n.range = function(h) {
    return arguments.length ? (r = [+h[0], +h[1]], l()) : r.slice();
  }, n.rangeRound = function(h) {
    return r = [+h[0], +h[1]], o = !0, l();
  }, n.bandwidth = function() {
    return u;
  }, n.step = function() {
    return i;
  }, n.round = function(h) {
    return arguments.length ? (o = !!h, l()) : o;
  }, n.padding = function(h) {
    return arguments.length ? (a = s = Math.max(0, Math.min(1, h)), l()) : a;
  }, n.paddingInner = function(h) {
    return arguments.length ? (a = Math.max(0, Math.min(1, h)), l()) : a;
  }, n.paddingOuter = function(h) {
    return arguments.length ? (s = Math.max(0, Math.min(1, h)), l()) : s;
  }, n.align = function(h) {
    return arguments.length ? (c = Math.max(0, Math.min(1, h)), l()) : c;
  }, n.copy = function() {
    return ja().domain(t()).range(r).round(o).paddingInner(a).paddingOuter(s).align(c);
  }, l();
}
function Ih(n) {
  var t = n.copy;
  return n.padding = n.paddingOuter, delete n.paddingInner, delete n.paddingOuter, n.copy = function() {
    return Ih(t());
  }, n;
}
function O2() {
  return Ih(ja().paddingInner(1));
}
function ns(n) {
  return function() {
    return n;
  };
}
function Lh(n) {
  return +n;
}
var Wc = [0, 1];
function ts(n, t) {
  return (t -= n = +n) ? function(e) {
    return (e - n) / t;
  } : ns(t);
}
function U2(n) {
  return function(t, e) {
    var r = n(t = +t, e = +e);
    return function(i) {
      return i <= t ? 0 : i >= e ? 1 : r(i);
    };
  };
}
function F2(n) {
  return function(t, e) {
    var r = n(t = +t, e = +e);
    return function(i) {
      return i <= 0 ? t : i >= 1 ? e : r(i);
    };
  };
}
function Y2(n, t, e, r) {
  var i = n[0], u = n[1], o = t[0], a = t[1];
  return u < i ? (i = e(u, i), o = r(a, o)) : (i = e(i, u), o = r(o, a)), function(s) {
    return o(i(s));
  };
}
function q2(n, t, e, r) {
  var i = Math.min(n.length, t.length) - 1, u = new Array(i), o = new Array(i), a = -1;
  for (n[i] < n[0] && (n = n.slice().reverse(), t = t.slice().reverse()); ++a < i; )
    u[a] = e(n[a], n[a + 1]), o[a] = r(t[a], t[a + 1]);
  return function(s) {
    var c = It(n, s, 1, i) - 1;
    return o[c](u[c](s));
  };
}
function bu(n, t) {
  return t.domain(n.domain()).range(n.range()).interpolate(n.interpolate()).clamp(n.clamp());
}
function Mu(n, t) {
  var e = Wc, r = Wc, i = Er, u = !1, o, a, s;
  function c() {
    return o = Math.min(e.length, r.length) > 2 ? q2 : Y2, a = s = null, l;
  }
  function l(h) {
    return (a || (a = o(e, r, u ? U2(n) : n, i)))(+h);
  }
  return l.invert = function(h) {
    return (s || (s = o(r, e, ts, u ? F2(t) : t)))(+h);
  }, l.domain = function(h) {
    return arguments.length ? (e = Ka.call(h, Lh), c()) : e.slice();
  }, l.range = function(h) {
    return arguments.length ? (r = mt.call(h), c()) : r.slice();
  }, l.rangeRound = function(h) {
    return r = mt.call(h), i = rl, c();
  }, l.clamp = function(h) {
    return arguments.length ? (u = !!h, c()) : u;
  }, l.interpolate = function(h) {
    return arguments.length ? (i = h, c()) : i;
  }, c();
}
function H2(n, t, e) {
  var r = n[0], i = n[n.length - 1], u = er(r, i, t ?? 10), o;
  switch (e = pr(e ?? ",f"), e.type) {
    case "s": {
      var a = Math.max(Math.abs(r), Math.abs(i));
      return e.precision == null && !isNaN(o = $l(u, a)) && (e.precision = o), Ra(e, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      e.precision == null && !isNaN(o = Pl(u, Math.max(Math.abs(r), Math.abs(i)))) && (e.precision = o - (e.type === "e"));
      break;
    }
    case "f":
    case "%": {
      e.precision == null && !isNaN(o = Rl(u)) && (e.precision = o - (e.type === "%") * 2);
      break;
    }
  }
  return yu(e);
}
function Pr(n) {
  var t = n.domain;
  return n.ticks = function(e) {
    var r = t();
    return aa(r[0], r[r.length - 1], e ?? 10);
  }, n.tickFormat = function(e, r) {
    return H2(t(), e, r);
  }, n.nice = function(e) {
    e == null && (e = 10);
    var r = t(), i = 0, u = r.length - 1, o = r[i], a = r[u], s;
    return a < o && (s = o, o = a, a = s, s = i, i = u, u = s), s = Ke(o, a, e), s > 0 ? (o = Math.floor(o / s) * s, a = Math.ceil(a / s) * s, s = Ke(o, a, e)) : s < 0 && (o = Math.ceil(o * s) / s, a = Math.floor(a * s) / s, s = Ke(o, a, e)), s > 0 ? (r[i] = Math.floor(o / s) * s, r[u] = Math.ceil(a / s) * s, t(r)) : s < 0 && (r[i] = Math.ceil(o * s) / s, r[u] = Math.floor(a * s) / s, t(r)), n;
  }, n;
}
function Dh() {
  var n = Mu(ts, $n);
  return n.copy = function() {
    return bu(n, Dh());
  }, Pr(n);
}
function Oh() {
  var n = [0, 1];
  function t(e) {
    return +e;
  }
  return t.invert = t, t.domain = t.range = function(e) {
    return arguments.length ? (n = Ka.call(e, Lh), t) : n.slice();
  }, t.copy = function() {
    return Oh().domain(n);
  }, Pr(t);
}
function Uh(n, t) {
  n = n.slice();
  var e = 0, r = n.length - 1, i = n[e], u = n[r], o;
  return u < i && (o = e, e = r, r = o, o = i, i = u, u = o), n[e] = t.floor(i), n[r] = t.ceil(u), n;
}
function B2(n, t) {
  return (t = Math.log(t / n)) ? function(e) {
    return Math.log(e / n) / t;
  } : ns(t);
}
function X2(n, t) {
  return n < 0 ? function(e) {
    return -Math.pow(-t, e) * Math.pow(-n, 1 - e);
  } : function(e) {
    return Math.pow(t, e) * Math.pow(n, 1 - e);
  };
}
function W2(n) {
  return isFinite(n) ? +("1e" + n) : n < 0 ? 0 : n;
}
function Vc(n) {
  return n === 10 ? W2 : n === Math.E ? Math.exp : function(t) {
    return Math.pow(n, t);
  };
}
function Zc(n) {
  return n === Math.E ? Math.log : n === 10 && Math.log10 || n === 2 && Math.log2 || (n = Math.log(n), function(t) {
    return Math.log(t) / n;
  });
}
function Gc(n) {
  return function(t) {
    return -n(-t);
  };
}
function Fh() {
  var n = Mu(B2, X2).domain([1, 10]), t = n.domain, e = 10, r = Zc(10), i = Vc(10);
  function u() {
    return r = Zc(e), i = Vc(e), t()[0] < 0 && (r = Gc(r), i = Gc(i)), n;
  }
  return n.base = function(o) {
    return arguments.length ? (e = +o, u()) : e;
  }, n.domain = function(o) {
    return arguments.length ? (t(o), u()) : t();
  }, n.ticks = function(o) {
    var a = t(), s = a[0], c = a[a.length - 1], l;
    (l = c < s) && (h = s, s = c, c = h);
    var h = r(s), f = r(c), p, g, d, v = o == null ? 10 : +o, y = [];
    if (!(e % 1) && f - h < v) {
      if (h = Math.round(h) - 1, f = Math.round(f) + 1, s > 0) {
        for (; h < f; ++h)
          for (g = 1, p = i(h); g < e; ++g)
            if (d = p * g, !(d < s)) {
              if (d > c) break;
              y.push(d);
            }
      } else for (; h < f; ++h)
        for (g = e - 1, p = i(h); g >= 1; --g)
          if (d = p * g, !(d < s)) {
            if (d > c) break;
            y.push(d);
          }
    } else
      y = aa(h, f, Math.min(f - h, v)).map(i);
    return l ? y.reverse() : y;
  }, n.tickFormat = function(o, a) {
    if (a == null && (a = e === 10 ? ".0e" : ","), typeof a != "function" && (a = yu(a)), o === 1 / 0) return a;
    o == null && (o = 10);
    var s = Math.max(1, e * o / n.ticks().length);
    return function(c) {
      var l = c / i(Math.round(r(c)));
      return l * e < e - 0.5 && (l *= e), l <= s ? a(c) : "";
    };
  }, n.nice = function() {
    return t(Uh(t(), {
      floor: function(o) {
        return i(Math.floor(r(o)));
      },
      ceil: function(o) {
        return i(Math.ceil(r(o)));
      }
    }));
  }, n.copy = function() {
    return bu(n, Fh().base(e));
  }, n;
}
function Kt(n, t) {
  return n < 0 ? -Math.pow(-n, t) : Math.pow(n, t);
}
function es() {
  var n = 1, t = Mu(r, i), e = t.domain;
  function r(u, o) {
    return (o = Kt(o, n) - (u = Kt(u, n))) ? function(a) {
      return (Kt(a, n) - u) / o;
    } : ns(o);
  }
  function i(u, o) {
    return o = Kt(o, n) - (u = Kt(u, n)), function(a) {
      return Kt(u + o * a, 1 / n);
    };
  }
  return t.exponent = function(u) {
    return arguments.length ? (n = +u, e(e())) : n;
  }, t.copy = function() {
    return bu(t, es().exponent(n));
  }, Pr(t);
}
function V2() {
  return es().exponent(0.5);
}
function Yh() {
  var n = [], t = [], e = [];
  function r() {
    var u = 0, o = Math.max(1, t.length);
    for (e = new Array(o - 1); ++u < o; ) e[u - 1] = rr(n, u / o);
    return i;
  }
  function i(u) {
    if (!isNaN(u = +u)) return t[It(e, u)];
  }
  return i.invertExtent = function(u) {
    var o = t.indexOf(u);
    return o < 0 ? [NaN, NaN] : [
      o > 0 ? e[o - 1] : n[0],
      o < e.length ? e[o] : n[n.length - 1]
    ];
  }, i.domain = function(u) {
    if (!arguments.length) return n.slice();
    n = [];
    for (var o = 0, a = u.length, s; o < a; ++o) s = u[o], s != null && !isNaN(s = +s) && n.push(s);
    return n.sort(qt), r();
  }, i.range = function(u) {
    return arguments.length ? (t = mt.call(u), r()) : t.slice();
  }, i.quantiles = function() {
    return e.slice();
  }, i.copy = function() {
    return Yh().domain(n).range(t);
  }, i;
}
function qh() {
  var n = 0, t = 1, e = 1, r = [0.5], i = [0, 1];
  function u(a) {
    if (a <= a) return i[It(r, a, 0, e)];
  }
  function o() {
    var a = -1;
    for (r = new Array(e); ++a < e; ) r[a] = ((a + 1) * t - (a - e) * n) / (e + 1);
    return u;
  }
  return u.domain = function(a) {
    return arguments.length ? (n = +a[0], t = +a[1], o()) : [n, t];
  }, u.range = function(a) {
    return arguments.length ? (e = (i = mt.call(a)).length - 1, o()) : i.slice();
  }, u.invertExtent = function(a) {
    var s = i.indexOf(a);
    return s < 0 ? [NaN, NaN] : s < 1 ? [n, r[0]] : s >= e ? [r[e - 1], t] : [r[s - 1], r[s]];
  }, u.copy = function() {
    return qh().domain([n, t]).range(i);
  }, Pr(u);
}
function Hh() {
  var n = [0.5], t = [0, 1], e = 1;
  function r(i) {
    if (i <= i) return t[It(n, i, 0, e)];
  }
  return r.domain = function(i) {
    return arguments.length ? (n = mt.call(i), e = Math.min(n.length, t.length - 1), r) : n.slice();
  }, r.range = function(i) {
    return arguments.length ? (t = mt.call(i), e = Math.min(n.length, t.length - 1), r) : t.slice();
  }, r.invertExtent = function(i) {
    var u = t.indexOf(i);
    return [n[u - 1], n[u]];
  }, r.copy = function() {
    return Hh().domain(n).range(t);
  }, r;
}
var io = /* @__PURE__ */ new Date(), uo = /* @__PURE__ */ new Date();
function hn(n, t, e, r) {
  function i(u) {
    return n(u = /* @__PURE__ */ new Date(+u)), u;
  }
  return i.floor = i, i.ceil = function(u) {
    return n(u = new Date(u - 1)), t(u, 1), n(u), u;
  }, i.round = function(u) {
    var o = i(u), a = i.ceil(u);
    return u - o < a - u ? o : a;
  }, i.offset = function(u, o) {
    return t(u = /* @__PURE__ */ new Date(+u), o == null ? 1 : Math.floor(o)), u;
  }, i.range = function(u, o, a) {
    var s = [], c;
    if (u = i.ceil(u), a = a == null ? 1 : Math.floor(a), !(u < o) || !(a > 0)) return s;
    do
      s.push(c = /* @__PURE__ */ new Date(+u)), t(u, a), n(u);
    while (c < u && u < o);
    return s;
  }, i.filter = function(u) {
    return hn(function(o) {
      if (o >= o) for (; n(o), !u(o); ) o.setTime(o - 1);
    }, function(o, a) {
      if (o >= o)
        if (a < 0) for (; ++a <= 0; )
          for (; t(o, -1), !u(o); )
            ;
        else for (; --a >= 0; )
          for (; t(o, 1), !u(o); )
            ;
    });
  }, e && (i.count = function(u, o) {
    return io.setTime(+u), uo.setTime(+o), n(io), n(uo), Math.floor(e(io, uo));
  }, i.every = function(u) {
    return u = Math.floor(u), !isFinite(u) || !(u > 0) ? null : u > 1 ? i.filter(r ? function(o) {
      return r(o) % u === 0;
    } : function(o) {
      return i.count(0, o) % u === 0;
    }) : i;
  }), i;
}
var Yt = hn(function() {
}, function(n, t) {
  n.setTime(+n + t);
}, function(n, t) {
  return t - n;
});
Yt.every = function(n) {
  return n = Math.floor(n), !isFinite(n) || !(n > 0) ? null : n > 1 ? hn(function(t) {
    t.setTime(Math.floor(t / n) * n);
  }, function(t, e) {
    t.setTime(+t + e * n);
  }, function(t, e) {
    return (e - t) / n;
  }) : Yt;
};
var Qc = Yt.range, jr = 1e3, it = 6e4, lt = 36e5, Bh = 864e5, Xh = 6048e5, mr = hn(function(n) {
  n.setTime(Math.floor(n / jr) * jr);
}, function(n, t) {
  n.setTime(+n + t * jr);
}, function(n, t) {
  return (t - n) / jr;
}, function(n) {
  return n.getUTCSeconds();
}), Kc = mr.range, rs = hn(function(n) {
  n.setTime(Math.floor(n / it) * it);
}, function(n, t) {
  n.setTime(+n + t * it);
}, function(n, t) {
  return (t - n) / it;
}, function(n) {
  return n.getMinutes();
}), Z2 = rs.range, is = hn(function(n) {
  var t = n.getTimezoneOffset() * it % lt;
  t < 0 && (t += lt), n.setTime(Math.floor((+n - t) / lt) * lt + t);
}, function(n, t) {
  n.setTime(+n + t * lt);
}, function(n, t) {
  return (t - n) / lt;
}, function(n) {
  return n.getHours();
}), G2 = is.range, zr = hn(function(n) {
  n.setHours(0, 0, 0, 0);
}, function(n, t) {
  n.setDate(n.getDate() + t);
}, function(n, t) {
  return (t - n - (t.getTimezoneOffset() - n.getTimezoneOffset()) * it) / Bh;
}, function(n) {
  return n.getDate() - 1;
}), Q2 = zr.range;
function Xt(n) {
  return hn(function(t) {
    t.setDate(t.getDate() - (t.getDay() + 7 - n) % 7), t.setHours(0, 0, 0, 0);
  }, function(t, e) {
    t.setDate(t.getDate() + e * 7);
  }, function(t, e) {
    return (e - t - (e.getTimezoneOffset() - t.getTimezoneOffset()) * it) / Xh;
  });
}
var _r = Xt(0), wr = Xt(1), Wh = Xt(2), Vh = Xt(3), nr = Xt(4), Zh = Xt(5), Gh = Xt(6), Jc = _r.range, K2 = wr.range, J2 = Wh.range, j2 = Vh.range, n_ = nr.range, t_ = Zh.range, e_ = Gh.range, us = hn(function(n) {
  n.setDate(1), n.setHours(0, 0, 0, 0);
}, function(n, t) {
  n.setMonth(n.getMonth() + t);
}, function(n, t) {
  return t.getMonth() - n.getMonth() + (t.getFullYear() - n.getFullYear()) * 12;
}, function(n) {
  return n.getMonth();
}), r_ = us.range, at = hn(function(n) {
  n.setMonth(0, 1), n.setHours(0, 0, 0, 0);
}, function(n, t) {
  n.setFullYear(n.getFullYear() + t);
}, function(n, t) {
  return t.getFullYear() - n.getFullYear();
}, function(n) {
  return n.getFullYear();
});
at.every = function(n) {
  return !isFinite(n = Math.floor(n)) || !(n > 0) ? null : hn(function(t) {
    t.setFullYear(Math.floor(t.getFullYear() / n) * n), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, function(t, e) {
    t.setFullYear(t.getFullYear() + e * n);
  });
};
var i_ = at.range, os = hn(function(n) {
  n.setUTCSeconds(0, 0);
}, function(n, t) {
  n.setTime(+n + t * it);
}, function(n, t) {
  return (t - n) / it;
}, function(n) {
  return n.getUTCMinutes();
}), u_ = os.range, as = hn(function(n) {
  n.setUTCMinutes(0, 0, 0);
}, function(n, t) {
  n.setTime(+n + t * lt);
}, function(n, t) {
  return (t - n) / lt;
}, function(n) {
  return n.getUTCHours();
}), o_ = as.range, Ir = hn(function(n) {
  n.setUTCHours(0, 0, 0, 0);
}, function(n, t) {
  n.setUTCDate(n.getUTCDate() + t);
}, function(n, t) {
  return (t - n) / Bh;
}, function(n) {
  return n.getUTCDate() - 1;
}), a_ = Ir.range;
function Wt(n) {
  return hn(function(t) {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - n) % 7), t.setUTCHours(0, 0, 0, 0);
  }, function(t, e) {
    t.setUTCDate(t.getUTCDate() + e * 7);
  }, function(t, e) {
    return (e - t) / Xh;
  });
}
var xr = Wt(0), br = Wt(1), Qh = Wt(2), Kh = Wt(3), tr = Wt(4), Jh = Wt(5), jh = Wt(6), jc = xr.range, s_ = br.range, c_ = Qh.range, f_ = Kh.range, l_ = tr.range, h_ = Jh.range, p_ = jh.range, ss = hn(function(n) {
  n.setUTCDate(1), n.setUTCHours(0, 0, 0, 0);
}, function(n, t) {
  n.setUTCMonth(n.getUTCMonth() + t);
}, function(n, t) {
  return t.getUTCMonth() - n.getUTCMonth() + (t.getUTCFullYear() - n.getUTCFullYear()) * 12;
}, function(n) {
  return n.getUTCMonth();
}), g_ = ss.range, st = hn(function(n) {
  n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
}, function(n, t) {
  n.setUTCFullYear(n.getUTCFullYear() + t);
}, function(n, t) {
  return t.getUTCFullYear() - n.getUTCFullYear();
}, function(n) {
  return n.getUTCFullYear();
});
st.every = function(n) {
  return !isFinite(n = Math.floor(n)) || !(n > 0) ? null : hn(function(t) {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / n) * n), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, function(t, e) {
    t.setUTCFullYear(t.getUTCFullYear() + e * n);
  });
};
var d_ = st.range;
function v_(n) {
  if (0 <= n.y && n.y < 100) {
    var t = new Date(-1, n.m, n.d, n.H, n.M, n.S, n.L);
    return t.setFullYear(n.y), t;
  }
  return new Date(n.y, n.m, n.d, n.H, n.M, n.S, n.L);
}
function ni(n) {
  if (0 <= n.y && n.y < 100) {
    var t = new Date(Date.UTC(-1, n.m, n.d, n.H, n.M, n.S, n.L));
    return t.setUTCFullYear(n.y), t;
  }
  return new Date(Date.UTC(n.y, n.m, n.d, n.H, n.M, n.S, n.L));
}
function ke(n) {
  return { y: n, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0 };
}
function n0(n) {
  var t = n.dateTime, e = n.date, r = n.time, i = n.periods, u = n.days, o = n.shortDays, a = n.months, s = n.shortMonths, c = Ce(i), l = Ae(i), h = Ce(u), f = Ae(u), p = Ce(o), g = Ae(o), d = Ce(a), v = Ae(a), y = Ce(s), x = Ae(s), m = {
    a: P,
    A: q,
    b: Y,
    B: G,
    c: null,
    d: rf,
    e: rf,
    f: F_,
    H: D_,
    I: O_,
    j: U_,
    L: t0,
    m: Y_,
    M: q_,
    p: V,
    Q: af,
    s: sf,
    S: H_,
    u: B_,
    U: X_,
    V: W_,
    w: V_,
    W: Z_,
    x: null,
    X: null,
    y: G_,
    Y: Q_,
    Z: K_,
    "%": of
  }, w = {
    a: tn,
    A: Q,
    b: en,
    B: K,
    c: null,
    d: uf,
    e: uf,
    f: tw,
    H: J_,
    I: j_,
    j: nw,
    L: e0,
    m: ew,
    M: rw,
    p: wn,
    Q: af,
    s: sf,
    S: iw,
    u: uw,
    U: ow,
    V: aw,
    w: sw,
    W: cw,
    x: null,
    X: null,
    y: fw,
    Y: lw,
    Z: hw,
    "%": of
  }, M = {
    a: $,
    A,
    b: k,
    B: _,
    c: b,
    d: tf,
    e: tf,
    f: P_,
    H: ef,
    I: ef,
    j: C_,
    L: $_,
    m: k_,
    M: A_,
    p: T,
    Q: I_,
    s: L_,
    S: R_,
    u: x_,
    U: b_,
    V: M_,
    w: w_,
    W: S_,
    x: C,
    X: R,
    y: N_,
    Y: T_,
    Z: E_,
    "%": z_
  };
  m.x = N(e, m), m.X = N(r, m), m.c = N(t, m), w.x = N(e, w), w.X = N(r, w), w.c = N(t, w);
  function N(I, H) {
    return function(B) {
      var z = [], vn = -1, J = 0, rn = I.length, An, Nt, Ms;
      for (B instanceof Date || (B = /* @__PURE__ */ new Date(+B)); ++vn < rn; )
        I.charCodeAt(vn) === 37 && (z.push(I.slice(J, vn)), (Nt = nf[An = I.charAt(++vn)]) != null ? An = I.charAt(++vn) : Nt = An === "e" ? " " : "0", (Ms = H[An]) && (An = Ms(B, Nt)), z.push(An), J = vn + 1);
      return z.push(I.slice(J, vn)), z.join("");
    };
  }
  function S(I, H) {
    return function(B) {
      var z = ke(1900), vn = E(z, I, B += "", 0), J, rn;
      if (vn != B.length) return null;
      if ("Q" in z) return new Date(z.Q);
      if ("p" in z && (z.H = z.H % 12 + z.p * 12), "V" in z) {
        if (z.V < 1 || z.V > 53) return null;
        "w" in z || (z.w = 1), "Z" in z ? (J = ni(ke(z.y)), rn = J.getUTCDay(), J = rn > 4 || rn === 0 ? br.ceil(J) : br(J), J = Ir.offset(J, (z.V - 1) * 7), z.y = J.getUTCFullYear(), z.m = J.getUTCMonth(), z.d = J.getUTCDate() + (z.w + 6) % 7) : (J = H(ke(z.y)), rn = J.getDay(), J = rn > 4 || rn === 0 ? wr.ceil(J) : wr(J), J = zr.offset(J, (z.V - 1) * 7), z.y = J.getFullYear(), z.m = J.getMonth(), z.d = J.getDate() + (z.w + 6) % 7);
      } else ("W" in z || "U" in z) && ("w" in z || (z.w = "u" in z ? z.u % 7 : "W" in z ? 1 : 0), rn = "Z" in z ? ni(ke(z.y)).getUTCDay() : H(ke(z.y)).getDay(), z.m = 0, z.d = "W" in z ? (z.w + 6) % 7 + z.W * 7 - (rn + 5) % 7 : z.w + z.U * 7 - (rn + 6) % 7);
      return "Z" in z ? (z.H += z.Z / 100 | 0, z.M += z.Z % 100, ni(z)) : H(z);
    };
  }
  function E(I, H, B, z) {
    for (var vn = 0, J = H.length, rn = B.length, An, Nt; vn < J; ) {
      if (z >= rn) return -1;
      if (An = H.charCodeAt(vn++), An === 37) {
        if (An = H.charAt(vn++), Nt = M[An in nf ? H.charAt(vn++) : An], !Nt || (z = Nt(I, B, z)) < 0) return -1;
      } else if (An != B.charCodeAt(z++))
        return -1;
    }
    return z;
  }
  function T(I, H, B) {
    var z = c.exec(H.slice(B));
    return z ? (I.p = l[z[0].toLowerCase()], B + z[0].length) : -1;
  }
  function $(I, H, B) {
    var z = p.exec(H.slice(B));
    return z ? (I.w = g[z[0].toLowerCase()], B + z[0].length) : -1;
  }
  function A(I, H, B) {
    var z = h.exec(H.slice(B));
    return z ? (I.w = f[z[0].toLowerCase()], B + z[0].length) : -1;
  }
  function k(I, H, B) {
    var z = y.exec(H.slice(B));
    return z ? (I.m = x[z[0].toLowerCase()], B + z[0].length) : -1;
  }
  function _(I, H, B) {
    var z = d.exec(H.slice(B));
    return z ? (I.m = v[z[0].toLowerCase()], B + z[0].length) : -1;
  }
  function b(I, H, B) {
    return E(I, t, H, B);
  }
  function C(I, H, B) {
    return E(I, e, H, B);
  }
  function R(I, H, B) {
    return E(I, r, H, B);
  }
  function P(I) {
    return o[I.getDay()];
  }
  function q(I) {
    return u[I.getDay()];
  }
  function Y(I) {
    return s[I.getMonth()];
  }
  function G(I) {
    return a[I.getMonth()];
  }
  function V(I) {
    return i[+(I.getHours() >= 12)];
  }
  function tn(I) {
    return o[I.getUTCDay()];
  }
  function Q(I) {
    return u[I.getUTCDay()];
  }
  function en(I) {
    return s[I.getUTCMonth()];
  }
  function K(I) {
    return a[I.getUTCMonth()];
  }
  function wn(I) {
    return i[+(I.getUTCHours() >= 12)];
  }
  return {
    format: function(I) {
      var H = N(I += "", m);
      return H.toString = function() {
        return I;
      }, H;
    },
    parse: function(I) {
      var H = S(I += "", v_);
      return H.toString = function() {
        return I;
      }, H;
    },
    utcFormat: function(I) {
      var H = N(I += "", w);
      return H.toString = function() {
        return I;
      }, H;
    },
    utcParse: function(I) {
      var H = S(I, ni);
      return H.toString = function() {
        return I;
      }, H;
    }
  };
}
var nf = { "-": "", _: " ", 0: "0" }, dn = /^\s*\d+/, y_ = /^%/, m_ = /[\\^$*+?|[\]().{}]/g;
function nn(n, t, e) {
  var r = n < 0 ? "-" : "", i = (r ? -n : n) + "", u = i.length;
  return r + (u < e ? new Array(e - u + 1).join(t) + i : i);
}
function __(n) {
  return n.replace(m_, "\\$&");
}
function Ce(n) {
  return new RegExp("^(?:" + n.map(__).join("|") + ")", "i");
}
function Ae(n) {
  for (var t = {}, e = -1, r = n.length; ++e < r; ) t[n[e].toLowerCase()] = e;
  return t;
}
function w_(n, t, e) {
  var r = dn.exec(t.slice(e, e + 1));
  return r ? (n.w = +r[0], e + r[0].length) : -1;
}
function x_(n, t, e) {
  var r = dn.exec(t.slice(e, e + 1));
  return r ? (n.u = +r[0], e + r[0].length) : -1;
}
function b_(n, t, e) {
  var r = dn.exec(t.slice(e, e + 2));
  return r ? (n.U = +r[0], e + r[0].length) : -1;
}
function M_(n, t, e) {
  var r = dn.exec(t.slice(e, e + 2));
  return r ? (n.V = +r[0], e + r[0].length) : -1;
}
function S_(n, t, e) {
  var r = dn.exec(t.slice(e, e + 2));
  return r ? (n.W = +r[0], e + r[0].length) : -1;
}
function T_(n, t, e) {
  var r = dn.exec(t.slice(e, e + 4));
  return r ? (n.y = +r[0], e + r[0].length) : -1;
}
function N_(n, t, e) {
  var r = dn.exec(t.slice(e, e + 2));
  return r ? (n.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), e + r[0].length) : -1;
}
function E_(n, t, e) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(e, e + 6));
  return r ? (n.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), e + r[0].length) : -1;
}
function k_(n, t, e) {
  var r = dn.exec(t.slice(e, e + 2));
  return r ? (n.m = r[0] - 1, e + r[0].length) : -1;
}
function tf(n, t, e) {
  var r = dn.exec(t.slice(e, e + 2));
  return r ? (n.d = +r[0], e + r[0].length) : -1;
}
function C_(n, t, e) {
  var r = dn.exec(t.slice(e, e + 3));
  return r ? (n.m = 0, n.d = +r[0], e + r[0].length) : -1;
}
function ef(n, t, e) {
  var r = dn.exec(t.slice(e, e + 2));
  return r ? (n.H = +r[0], e + r[0].length) : -1;
}
function A_(n, t, e) {
  var r = dn.exec(t.slice(e, e + 2));
  return r ? (n.M = +r[0], e + r[0].length) : -1;
}
function R_(n, t, e) {
  var r = dn.exec(t.slice(e, e + 2));
  return r ? (n.S = +r[0], e + r[0].length) : -1;
}
function $_(n, t, e) {
  var r = dn.exec(t.slice(e, e + 3));
  return r ? (n.L = +r[0], e + r[0].length) : -1;
}
function P_(n, t, e) {
  var r = dn.exec(t.slice(e, e + 6));
  return r ? (n.L = Math.floor(r[0] / 1e3), e + r[0].length) : -1;
}
function z_(n, t, e) {
  var r = y_.exec(t.slice(e, e + 1));
  return r ? e + r[0].length : -1;
}
function I_(n, t, e) {
  var r = dn.exec(t.slice(e));
  return r ? (n.Q = +r[0], e + r[0].length) : -1;
}
function L_(n, t, e) {
  var r = dn.exec(t.slice(e));
  return r ? (n.Q = +r[0] * 1e3, e + r[0].length) : -1;
}
function rf(n, t) {
  return nn(n.getDate(), t, 2);
}
function D_(n, t) {
  return nn(n.getHours(), t, 2);
}
function O_(n, t) {
  return nn(n.getHours() % 12 || 12, t, 2);
}
function U_(n, t) {
  return nn(1 + zr.count(at(n), n), t, 3);
}
function t0(n, t) {
  return nn(n.getMilliseconds(), t, 3);
}
function F_(n, t) {
  return t0(n, t) + "000";
}
function Y_(n, t) {
  return nn(n.getMonth() + 1, t, 2);
}
function q_(n, t) {
  return nn(n.getMinutes(), t, 2);
}
function H_(n, t) {
  return nn(n.getSeconds(), t, 2);
}
function B_(n) {
  var t = n.getDay();
  return t === 0 ? 7 : t;
}
function X_(n, t) {
  return nn(_r.count(at(n), n), t, 2);
}
function W_(n, t) {
  var e = n.getDay();
  return n = e >= 4 || e === 0 ? nr(n) : nr.ceil(n), nn(nr.count(at(n), n) + (at(n).getDay() === 4), t, 2);
}
function V_(n) {
  return n.getDay();
}
function Z_(n, t) {
  return nn(wr.count(at(n), n), t, 2);
}
function G_(n, t) {
  return nn(n.getFullYear() % 100, t, 2);
}
function Q_(n, t) {
  return nn(n.getFullYear() % 1e4, t, 4);
}
function K_(n) {
  var t = n.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + nn(t / 60 | 0, "0", 2) + nn(t % 60, "0", 2);
}
function uf(n, t) {
  return nn(n.getUTCDate(), t, 2);
}
function J_(n, t) {
  return nn(n.getUTCHours(), t, 2);
}
function j_(n, t) {
  return nn(n.getUTCHours() % 12 || 12, t, 2);
}
function nw(n, t) {
  return nn(1 + Ir.count(st(n), n), t, 3);
}
function e0(n, t) {
  return nn(n.getUTCMilliseconds(), t, 3);
}
function tw(n, t) {
  return e0(n, t) + "000";
}
function ew(n, t) {
  return nn(n.getUTCMonth() + 1, t, 2);
}
function rw(n, t) {
  return nn(n.getUTCMinutes(), t, 2);
}
function iw(n, t) {
  return nn(n.getUTCSeconds(), t, 2);
}
function uw(n) {
  var t = n.getUTCDay();
  return t === 0 ? 7 : t;
}
function ow(n, t) {
  return nn(xr.count(st(n), n), t, 2);
}
function aw(n, t) {
  var e = n.getUTCDay();
  return n = e >= 4 || e === 0 ? tr(n) : tr.ceil(n), nn(tr.count(st(n), n) + (st(n).getUTCDay() === 4), t, 2);
}
function sw(n) {
  return n.getUTCDay();
}
function cw(n, t) {
  return nn(br.count(st(n), n), t, 2);
}
function fw(n, t) {
  return nn(n.getUTCFullYear() % 100, t, 2);
}
function lw(n, t) {
  return nn(n.getUTCFullYear() % 1e4, t, 4);
}
function hw() {
  return "+0000";
}
function of() {
  return "%";
}
function af(n) {
  return +n;
}
function sf(n) {
  return Math.floor(+n / 1e3);
}
var Jt, cs, r0, Su, fs;
i0({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function i0(n) {
  return Jt = n0(n), cs = Jt.format, r0 = Jt.parse, Su = Jt.utcFormat, fs = Jt.utcParse, Jt;
}
var u0 = "%Y-%m-%dT%H:%M:%S.%LZ";
function pw(n) {
  return n.toISOString();
}
var gw = Date.prototype.toISOString ? pw : Su(u0);
function dw(n) {
  var t = new Date(n);
  return isNaN(t) ? null : t;
}
var vw = +/* @__PURE__ */ new Date("2000-01-01T00:00:00.000Z") ? dw : fs(u0), Xe = 1e3, We = Xe * 60, Ve = We * 60, Mr = Ve * 24, yw = Mr * 7, cf = Mr * 30, oo = Mr * 365;
function mw(n) {
  return new Date(n);
}
function _w(n) {
  return n instanceof Date ? +n : +/* @__PURE__ */ new Date(+n);
}
function ls(n, t, e, r, i, u, o, a, s) {
  var c = Mu(ts, $n), l = c.invert, h = c.domain, f = s(".%L"), p = s(":%S"), g = s("%I:%M"), d = s("%I %p"), v = s("%a %d"), y = s("%b %d"), x = s("%B"), m = s("%Y"), w = [
    [o, 1, Xe],
    [o, 5, 5 * Xe],
    [o, 15, 15 * Xe],
    [o, 30, 30 * Xe],
    [u, 1, We],
    [u, 5, 5 * We],
    [u, 15, 15 * We],
    [u, 30, 30 * We],
    [i, 1, Ve],
    [i, 3, 3 * Ve],
    [i, 6, 6 * Ve],
    [i, 12, 12 * Ve],
    [r, 1, Mr],
    [r, 2, 2 * Mr],
    [e, 1, yw],
    [t, 1, cf],
    [t, 3, 3 * cf],
    [n, 1, oo]
  ];
  function M(S) {
    return (o(S) < S ? f : u(S) < S ? p : i(S) < S ? g : r(S) < S ? d : t(S) < S ? e(S) < S ? v : y : n(S) < S ? x : m)(S);
  }
  function N(S, E, T, $) {
    if (S == null && (S = 10), typeof S == "number") {
      var A = Math.abs(T - E) / S, k = oa(function(_) {
        return _[2];
      }).right(w, A);
      k === w.length ? ($ = er(E / oo, T / oo, S), S = n) : k ? (k = w[A / w[k - 1][2] < w[k][2] / A ? k - 1 : k], $ = k[1], S = k[0]) : ($ = Math.max(er(E, T, S), 1), S = a);
    }
    return $ == null ? S : S.every($);
  }
  return c.invert = function(S) {
    return new Date(l(S));
  }, c.domain = function(S) {
    return arguments.length ? h(Ka.call(S, _w)) : h().map(mw);
  }, c.ticks = function(S, E) {
    var T = h(), $ = T[0], A = T[T.length - 1], k = A < $, _;
    return k && (_ = $, $ = A, A = _), _ = N(S, $, A, E), _ = _ ? _.range($, A + 1) : [], k ? _.reverse() : _;
  }, c.tickFormat = function(S, E) {
    return E == null ? M : s(E);
  }, c.nice = function(S, E) {
    var T = h();
    return (S = N(S, T[0], T[T.length - 1], E)) ? h(Uh(T, S)) : c;
  }, c.copy = function() {
    return bu(c, ls(n, t, e, r, i, u, o, a, s));
  }, c;
}
function ww() {
  return ls(at, us, _r, zr, is, rs, mr, Yt, cs).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]);
}
function xw() {
  return ls(st, ss, xr, Ir, as, os, mr, Yt, Su).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]);
}
function Tt(n) {
  return n.match(/.{6}/g).map(function(t) {
    return "#" + t;
  });
}
const bw = Tt("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"), Mw = Tt("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"), Sw = Tt("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"), Tw = Tt("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"), Nw = fu(Bn(300, 0.5, 0), Bn(-240, 0.5, 1));
var Ew = fu(Bn(-100, 0.75, 0.35), Bn(80, 1.5, 0.8)), kw = fu(Bn(260, 0.75, 0.35), Bn(80, 1.5, 0.8)), ti = Bn();
function Cw(n) {
  (n < 0 || n > 1) && (n -= Math.floor(n));
  var t = Math.abs(n - 0.5);
  return ti.h = 360 * n - 100, ti.s = 1.5 - 1.5 * t, ti.l = 0.8 - 0.9 * t, ti + "";
}
function Tu(n) {
  var t = n.length;
  return function(e) {
    return n[Math.max(0, Math.min(t - 1, Math.floor(e * t)))];
  };
}
const Aw = Tu(Tt("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var Rw = Tu(Tt("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf")), $w = Tu(Tt("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4")), Pw = Tu(Tt("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
function o0(n) {
  var t = 0, e = 1, r = !1;
  function i(u) {
    var o = (u - t) / (e - t);
    return n(r ? Math.max(0, Math.min(1, o)) : o);
  }
  return i.domain = function(u) {
    return arguments.length ? (t = +u[0], e = +u[1], i) : [t, e];
  }, i.clamp = function(u) {
    return arguments.length ? (r = !!u, i) : r;
  }, i.interpolator = function(u) {
    return arguments.length ? (n = u, i) : n;
  }, i.copy = function() {
    return o0(n).domain([t, e]).clamp(r);
  }, Pr(i);
}
function X(n) {
  return function() {
    return n;
  };
}
var ff = Math.abs, yn = Math.atan2, kt = Math.cos, zw = Math.max, ao = Math.min, Wn = Math.sin, te = Math.sqrt, mn = 1e-12, _t = Math.PI, Qi = _t / 2, dt = 2 * _t;
function Iw(n) {
  return n > 1 ? 0 : n < -1 ? _t : Math.acos(n);
}
function lf(n) {
  return n >= 1 ? Qi : n <= -1 ? -Qi : Math.asin(n);
}
function Lw(n) {
  return n.innerRadius;
}
function Dw(n) {
  return n.outerRadius;
}
function Ow(n) {
  return n.startAngle;
}
function Uw(n) {
  return n.endAngle;
}
function Fw(n) {
  return n && n.padAngle;
}
function Yw(n, t, e, r, i, u, o, a) {
  var s = e - n, c = r - t, l = o - i, h = a - u, f = (l * (t - u) - h * (n - i)) / (h * s - l * c);
  return [n + f * s, t + f * c];
}
function ei(n, t, e, r, i, u, o) {
  var a = n - e, s = t - r, c = (o ? u : -u) / te(a * a + s * s), l = c * s, h = -c * a, f = n + l, p = t + h, g = e + l, d = r + h, v = (f + g) / 2, y = (p + d) / 2, x = g - f, m = d - p, w = x * x + m * m, M = i - u, N = f * d - g * p, S = (m < 0 ? -1 : 1) * te(zw(0, M * M * w - N * N)), E = (N * m - x * S) / w, T = (-N * x - m * S) / w, $ = (N * m + x * S) / w, A = (-N * x + m * S) / w, k = E - v, _ = T - y, b = $ - v, C = A - y;
  return k * k + _ * _ > b * b + C * C && (E = $, T = A), {
    cx: E,
    cy: T,
    x01: -l,
    y01: -h,
    x11: E * (i / M - 1),
    y11: T * (i / M - 1)
  };
}
function qw() {
  var n = Lw, t = Dw, e = X(0), r = null, i = Ow, u = Uw, o = Fw, a = null;
  function s() {
    var c, l, h = +n.apply(this, arguments), f = +t.apply(this, arguments), p = i.apply(this, arguments) - Qi, g = u.apply(this, arguments) - Qi, d = ff(g - p), v = g > p;
    if (a || (a = c = Mt()), f < h && (l = f, f = h, h = l), !(f > mn)) a.moveTo(0, 0);
    else if (d > dt - mn)
      a.moveTo(f * kt(p), f * Wn(p)), a.arc(0, 0, f, p, g, !v), h > mn && (a.moveTo(h * kt(g), h * Wn(g)), a.arc(0, 0, h, g, p, v));
    else {
      var y = p, x = g, m = p, w = g, M = d, N = d, S = o.apply(this, arguments) / 2, E = S > mn && (r ? +r.apply(this, arguments) : te(h * h + f * f)), T = ao(ff(f - h) / 2, +e.apply(this, arguments)), $ = T, A = T, k, _;
      if (E > mn) {
        var b = lf(E / h * Wn(S)), C = lf(E / f * Wn(S));
        (M -= b * 2) > mn ? (b *= v ? 1 : -1, m += b, w -= b) : (M = 0, m = w = (p + g) / 2), (N -= C * 2) > mn ? (C *= v ? 1 : -1, y += C, x -= C) : (N = 0, y = x = (p + g) / 2);
      }
      var R = f * kt(y), P = f * Wn(y), q = h * kt(w), Y = h * Wn(w);
      if (T > mn) {
        var G = f * kt(x), V = f * Wn(x), tn = h * kt(m), Q = h * Wn(m);
        if (d < _t) {
          var en = M > mn ? Yw(R, P, tn, Q, G, V, q, Y) : [q, Y], K = R - en[0], wn = P - en[1], I = G - en[0], H = V - en[1], B = 1 / Wn(Iw((K * I + wn * H) / (te(K * K + wn * wn) * te(I * I + H * H))) / 2), z = te(en[0] * en[0] + en[1] * en[1]);
          $ = ao(T, (h - z) / (B - 1)), A = ao(T, (f - z) / (B + 1));
        }
      }
      N > mn ? A > mn ? (k = ei(tn, Q, R, P, f, A, v), _ = ei(G, V, q, Y, f, A, v), a.moveTo(k.cx + k.x01, k.cy + k.y01), A < T ? a.arc(k.cx, k.cy, A, yn(k.y01, k.x01), yn(_.y01, _.x01), !v) : (a.arc(k.cx, k.cy, A, yn(k.y01, k.x01), yn(k.y11, k.x11), !v), a.arc(0, 0, f, yn(k.cy + k.y11, k.cx + k.x11), yn(_.cy + _.y11, _.cx + _.x11), !v), a.arc(_.cx, _.cy, A, yn(_.y11, _.x11), yn(_.y01, _.x01), !v))) : (a.moveTo(R, P), a.arc(0, 0, f, y, x, !v)) : a.moveTo(R, P), !(h > mn) || !(M > mn) ? a.lineTo(q, Y) : $ > mn ? (k = ei(q, Y, G, V, h, -$, v), _ = ei(R, P, tn, Q, h, -$, v), a.lineTo(k.cx + k.x01, k.cy + k.y01), $ < T ? a.arc(k.cx, k.cy, $, yn(k.y01, k.x01), yn(_.y01, _.x01), !v) : (a.arc(k.cx, k.cy, $, yn(k.y01, k.x01), yn(k.y11, k.x11), !v), a.arc(0, 0, h, yn(k.cy + k.y11, k.cx + k.x11), yn(_.cy + _.y11, _.cx + _.x11), v), a.arc(_.cx, _.cy, $, yn(_.y11, _.x11), yn(_.y01, _.x01), !v))) : a.arc(0, 0, h, w, m, v);
    }
    if (a.closePath(), c) return a = null, c + "" || null;
  }
  return s.centroid = function() {
    var c = (+n.apply(this, arguments) + +t.apply(this, arguments)) / 2, l = (+i.apply(this, arguments) + +u.apply(this, arguments)) / 2 - _t / 2;
    return [kt(l) * c, Wn(l) * c];
  }, s.innerRadius = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : X(+c), s) : n;
  }, s.outerRadius = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : X(+c), s) : t;
  }, s.cornerRadius = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : X(+c), s) : e;
  }, s.padRadius = function(c) {
    return arguments.length ? (r = c == null ? null : typeof c == "function" ? c : X(+c), s) : r;
  }, s.startAngle = function(c) {
    return arguments.length ? (i = typeof c == "function" ? c : X(+c), s) : i;
  }, s.endAngle = function(c) {
    return arguments.length ? (u = typeof c == "function" ? c : X(+c), s) : u;
  }, s.padAngle = function(c) {
    return arguments.length ? (o = typeof c == "function" ? c : X(+c), s) : o;
  }, s.context = function(c) {
    return arguments.length ? (a = c ?? null, s) : a;
  }, s;
}
function a0(n) {
  this._context = n;
}
a0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, t) : this._context.moveTo(n, t);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(n, t);
        break;
    }
  }
};
function Nu(n) {
  return new a0(n);
}
function hs(n) {
  return n[0];
}
function ps(n) {
  return n[1];
}
function gs() {
  var n = hs, t = ps, e = X(!0), r = null, i = Nu, u = null;
  function o(a) {
    var s, c = a.length, l, h = !1, f;
    for (r == null && (u = i(f = Mt())), s = 0; s <= c; ++s)
      !(s < c && e(l = a[s], s, a)) === h && ((h = !h) ? u.lineStart() : u.lineEnd()), h && u.point(+n(l, s, a), +t(l, s, a));
    if (f) return u = null, f + "" || null;
  }
  return o.x = function(a) {
    return arguments.length ? (n = typeof a == "function" ? a : X(+a), o) : n;
  }, o.y = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : X(+a), o) : t;
  }, o.defined = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : X(!!a), o) : e;
  }, o.curve = function(a) {
    return arguments.length ? (i = a, r != null && (u = i(r)), o) : i;
  }, o.context = function(a) {
    return arguments.length ? (a == null ? r = u = null : u = i(r = a), o) : r;
  }, o;
}
function s0() {
  var n = hs, t = null, e = X(0), r = ps, i = X(!0), u = null, o = Nu, a = null;
  function s(l) {
    var h, f, p, g = l.length, d, v = !1, y, x = new Array(g), m = new Array(g);
    for (u == null && (a = o(y = Mt())), h = 0; h <= g; ++h) {
      if (!(h < g && i(d = l[h], h, l)) === v)
        if (v = !v)
          f = h, a.areaStart(), a.lineStart();
        else {
          for (a.lineEnd(), a.lineStart(), p = h - 1; p >= f; --p)
            a.point(x[p], m[p]);
          a.lineEnd(), a.areaEnd();
        }
      v && (x[h] = +n(d, h, l), m[h] = +e(d, h, l), a.point(t ? +t(d, h, l) : x[h], r ? +r(d, h, l) : m[h]));
    }
    if (y) return a = null, y + "" || null;
  }
  function c() {
    return gs().defined(i).curve(o).context(u);
  }
  return s.x = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : X(+l), t = null, s) : n;
  }, s.x0 = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : X(+l), s) : n;
  }, s.x1 = function(l) {
    return arguments.length ? (t = l == null ? null : typeof l == "function" ? l : X(+l), s) : t;
  }, s.y = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : X(+l), r = null, s) : e;
  }, s.y0 = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : X(+l), s) : e;
  }, s.y1 = function(l) {
    return arguments.length ? (r = l == null ? null : typeof l == "function" ? l : X(+l), s) : r;
  }, s.lineX0 = s.lineY0 = function() {
    return c().x(n).y(e);
  }, s.lineY1 = function() {
    return c().x(n).y(r);
  }, s.lineX1 = function() {
    return c().x(t).y(e);
  }, s.defined = function(l) {
    return arguments.length ? (i = typeof l == "function" ? l : X(!!l), s) : i;
  }, s.curve = function(l) {
    return arguments.length ? (o = l, u != null && (a = o(u)), s) : o;
  }, s.context = function(l) {
    return arguments.length ? (l == null ? u = a = null : a = o(u = l), s) : u;
  }, s;
}
function Hw(n, t) {
  return t < n ? -1 : t > n ? 1 : t >= n ? 0 : NaN;
}
function Bw(n) {
  return n;
}
function Xw() {
  var n = Bw, t = Hw, e = null, r = X(0), i = X(dt), u = X(0);
  function o(a) {
    var s, c = a.length, l, h, f = 0, p = new Array(c), g = new Array(c), d = +r.apply(this, arguments), v = Math.min(dt, Math.max(-dt, i.apply(this, arguments) - d)), y, x = Math.min(Math.abs(v) / c, u.apply(this, arguments)), m = x * (v < 0 ? -1 : 1), w;
    for (s = 0; s < c; ++s)
      (w = g[p[s] = s] = +n(a[s], s, a)) > 0 && (f += w);
    for (t != null ? p.sort(function(M, N) {
      return t(g[M], g[N]);
    }) : e != null && p.sort(function(M, N) {
      return e(a[M], a[N]);
    }), s = 0, h = f ? (v - c * m) / f : 0; s < c; ++s, d = y)
      l = p[s], w = g[l], y = d + (w > 0 ? w * h : 0) + m, g[l] = {
        data: a[l],
        index: s,
        value: w,
        startAngle: d,
        endAngle: y,
        padAngle: x
      };
    return g;
  }
  return o.value = function(a) {
    return arguments.length ? (n = typeof a == "function" ? a : X(+a), o) : n;
  }, o.sortValues = function(a) {
    return arguments.length ? (t = a, e = null, o) : t;
  }, o.sort = function(a) {
    return arguments.length ? (e = a, t = null, o) : e;
  }, o.startAngle = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : X(+a), o) : r;
  }, o.endAngle = function(a) {
    return arguments.length ? (i = typeof a == "function" ? a : X(+a), o) : i;
  }, o.padAngle = function(a) {
    return arguments.length ? (u = typeof a == "function" ? a : X(+a), o) : u;
  }, o;
}
var c0 = ds(Nu);
function f0(n) {
  this._curve = n;
}
f0.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(n, t) {
    this._curve.point(t * Math.sin(n), t * -Math.cos(n));
  }
};
function ds(n) {
  function t(e) {
    return new f0(n(e));
  }
  return t._curve = n, t;
}
function Ze(n) {
  var t = n.curve;
  return n.angle = n.x, delete n.x, n.radius = n.y, delete n.y, n.curve = function(e) {
    return arguments.length ? t(ds(e)) : t()._curve;
  }, n;
}
function hf() {
  return Ze(gs().curve(c0));
}
function pf() {
  var n = s0().curve(c0), t = n.curve, e = n.lineX0, r = n.lineX1, i = n.lineY0, u = n.lineY1;
  return n.angle = n.x, delete n.x, n.startAngle = n.x0, delete n.x0, n.endAngle = n.x1, delete n.x1, n.radius = n.y, delete n.y, n.innerRadius = n.y0, delete n.y0, n.outerRadius = n.y1, delete n.y1, n.lineStartAngle = function() {
    return Ze(e());
  }, delete n.lineX0, n.lineEndAngle = function() {
    return Ze(r());
  }, delete n.lineX1, n.lineInnerRadius = function() {
    return Ze(i());
  }, delete n.lineY0, n.lineOuterRadius = function() {
    return Ze(u());
  }, delete n.lineY1, n.curve = function(o) {
    return arguments.length ? t(ds(o)) : t()._curve;
  }, n;
}
function Ge(n, t) {
  return [(t = +t) * Math.cos(n -= Math.PI / 2), t * Math.sin(n)];
}
var ra = Array.prototype.slice;
function Ww(n) {
  return n.source;
}
function Vw(n) {
  return n.target;
}
function vs(n) {
  var t = Ww, e = Vw, r = hs, i = ps, u = null;
  function o() {
    var a, s = ra.call(arguments), c = t.apply(this, s), l = e.apply(this, s);
    if (u || (u = a = Mt()), n(u, +r.apply(this, (s[0] = c, s)), +i.apply(this, s), +r.apply(this, (s[0] = l, s)), +i.apply(this, s)), a) return u = null, a + "" || null;
  }
  return o.source = function(a) {
    return arguments.length ? (t = a, o) : t;
  }, o.target = function(a) {
    return arguments.length ? (e = a, o) : e;
  }, o.x = function(a) {
    return arguments.length ? (r = typeof a == "function" ? a : X(+a), o) : r;
  }, o.y = function(a) {
    return arguments.length ? (i = typeof a == "function" ? a : X(+a), o) : i;
  }, o.context = function(a) {
    return arguments.length ? (u = a ?? null, o) : u;
  }, o;
}
function Zw(n, t, e, r, i) {
  n.moveTo(t, e), n.bezierCurveTo(t = (t + r) / 2, e, t, i, r, i);
}
function Gw(n, t, e, r, i) {
  n.moveTo(t, e), n.bezierCurveTo(t, e = (e + i) / 2, r, e, r, i);
}
function Qw(n, t, e, r, i) {
  var u = Ge(t, e), o = Ge(t, e = (e + i) / 2), a = Ge(r, e), s = Ge(r, i);
  n.moveTo(u[0], u[1]), n.bezierCurveTo(o[0], o[1], a[0], a[1], s[0], s[1]);
}
function Kw() {
  return vs(Zw);
}
function Jw() {
  return vs(Gw);
}
function jw() {
  var n = vs(Qw);
  return n.angle = n.x, delete n.x, n.radius = n.y, delete n.y, n;
}
const ys = {
  draw: function(n, t) {
    var e = Math.sqrt(t / _t);
    n.moveTo(e, 0), n.arc(0, 0, e, 0, dt);
  }
}, l0 = {
  draw: function(n, t) {
    var e = Math.sqrt(t / 5) / 2;
    n.moveTo(-3 * e, -e), n.lineTo(-e, -e), n.lineTo(-e, -3 * e), n.lineTo(e, -3 * e), n.lineTo(e, -e), n.lineTo(3 * e, -e), n.lineTo(3 * e, e), n.lineTo(e, e), n.lineTo(e, 3 * e), n.lineTo(-e, 3 * e), n.lineTo(-e, e), n.lineTo(-3 * e, e), n.closePath();
  }
};
var h0 = Math.sqrt(1 / 3), nx = h0 * 2;
const p0 = {
  draw: function(n, t) {
    var e = Math.sqrt(t / nx), r = e * h0;
    n.moveTo(0, -e), n.lineTo(r, 0), n.lineTo(0, e), n.lineTo(-r, 0), n.closePath();
  }
};
var tx = 0.8908130915292852, g0 = Math.sin(_t / 10) / Math.sin(7 * _t / 10), ex = Math.sin(dt / 10) * g0, rx = -Math.cos(dt / 10) * g0;
const d0 = {
  draw: function(n, t) {
    var e = Math.sqrt(t * tx), r = ex * e, i = rx * e;
    n.moveTo(0, -e), n.lineTo(r, i);
    for (var u = 1; u < 5; ++u) {
      var o = dt * u / 5, a = Math.cos(o), s = Math.sin(o);
      n.lineTo(s * e, -a * e), n.lineTo(a * r - s * i, s * r + a * i);
    }
    n.closePath();
  }
}, v0 = {
  draw: function(n, t) {
    var e = Math.sqrt(t), r = -e / 2;
    n.rect(r, r, e, e);
  }
};
var so = Math.sqrt(3);
const y0 = {
  draw: function(n, t) {
    var e = -Math.sqrt(t / (so * 3));
    n.moveTo(0, e * 2), n.lineTo(-so * e, -e), n.lineTo(so * e, -e), n.closePath();
  }
};
var Ln = -0.5, Dn = Math.sqrt(3) / 2, ia = 1 / Math.sqrt(12), ix = (ia / 2 + 1) * 3;
const m0 = {
  draw: function(n, t) {
    var e = Math.sqrt(t / ix), r = e / 2, i = e * ia, u = r, o = e * ia + e, a = -u, s = o;
    n.moveTo(r, i), n.lineTo(u, o), n.lineTo(a, s), n.lineTo(Ln * r - Dn * i, Dn * r + Ln * i), n.lineTo(Ln * u - Dn * o, Dn * u + Ln * o), n.lineTo(Ln * a - Dn * s, Dn * a + Ln * s), n.lineTo(Ln * r + Dn * i, Ln * i - Dn * r), n.lineTo(Ln * u + Dn * o, Ln * o - Dn * u), n.lineTo(Ln * a + Dn * s, Ln * s - Dn * a), n.closePath();
  }
};
var ux = [
  ys,
  l0,
  p0,
  v0,
  d0,
  y0,
  m0
];
function ox() {
  var n = X(ys), t = X(64), e = null;
  function r() {
    var i;
    if (e || (e = i = Mt()), n.apply(this, arguments).draw(e, +t.apply(this, arguments)), i) return e = null, i + "" || null;
  }
  return r.type = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : X(i), r) : n;
  }, r.size = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : X(+i), r) : t;
  }, r.context = function(i) {
    return arguments.length ? (e = i ?? null, r) : e;
  }, r;
}
function wt() {
}
function Ki(n, t, e) {
  n._context.bezierCurveTo(
    (2 * n._x0 + n._x1) / 3,
    (2 * n._y0 + n._y1) / 3,
    (n._x0 + 2 * n._x1) / 3,
    (n._y0 + 2 * n._y1) / 3,
    (n._x0 + 4 * n._x1 + t) / 6,
    (n._y0 + 4 * n._y1 + e) / 6
  );
}
function Eu(n) {
  this._context = n;
}
Eu.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        Ki(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, t) : this._context.moveTo(n, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        Ki(this, n, t);
        break;
    }
    this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = t;
  }
};
function ax(n) {
  return new Eu(n);
}
function _0(n) {
  this._context = n;
}
_0.prototype = {
  areaStart: wt,
  areaEnd: wt,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = n, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = n, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = n, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + n) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        Ki(this, n, t);
        break;
    }
    this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = t;
  }
};
function sx(n) {
  return new _0(n);
}
function w0(n) {
  this._context = n;
}
w0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var e = (this._x0 + 4 * this._x1 + n) / 6, r = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(e, r) : this._context.moveTo(e, r);
        break;
      case 3:
        this._point = 4;
      default:
        Ki(this, n, t);
        break;
    }
    this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = t;
  }
};
function cx(n) {
  return new w0(n);
}
function x0(n, t) {
  this._basis = new Eu(n), this._beta = t;
}
x0.prototype = {
  lineStart: function() {
    this._x = [], this._y = [], this._basis.lineStart();
  },
  lineEnd: function() {
    var n = this._x, t = this._y, e = n.length - 1;
    if (e > 0)
      for (var r = n[0], i = t[0], u = n[e] - r, o = t[e] - i, a = -1, s; ++a <= e; )
        s = a / e, this._basis.point(
          this._beta * n[a] + (1 - this._beta) * (r + s * u),
          this._beta * t[a] + (1 - this._beta) * (i + s * o)
        );
    this._x = this._y = null, this._basis.lineEnd();
  },
  point: function(n, t) {
    this._x.push(+n), this._y.push(+t);
  }
};
const fx = function n(t) {
  function e(r) {
    return t === 1 ? new Eu(r) : new x0(r, t);
  }
  return e.beta = function(r) {
    return n(+r);
  }, e;
}(0.85);
function Ji(n, t, e) {
  n._context.bezierCurveTo(
    n._x1 + n._k * (n._x2 - n._x0),
    n._y1 + n._k * (n._y2 - n._y0),
    n._x2 + n._k * (n._x1 - t),
    n._y2 + n._k * (n._y1 - e),
    n._x2,
    n._y2
  );
}
function ms(n, t) {
  this._context = n, this._k = (1 - t) / 6;
}
ms.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        Ji(this, this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, t) : this._context.moveTo(n, t);
        break;
      case 1:
        this._point = 2, this._x1 = n, this._y1 = t;
        break;
      case 2:
        this._point = 3;
      default:
        Ji(this, n, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const lx = function n(t) {
  function e(r) {
    return new ms(r, t);
  }
  return e.tension = function(r) {
    return n(+r);
  }, e;
}(0);
function _s(n, t) {
  this._context = n, this._k = (1 - t) / 6;
}
_s.prototype = {
  areaStart: wt,
  areaEnd: wt,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1, this._x3 = n, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = n, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = n, this._y5 = t;
        break;
      default:
        Ji(this, n, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const hx = function n(t) {
  function e(r) {
    return new _s(r, t);
  }
  return e.tension = function(r) {
    return n(+r);
  }, e;
}(0);
function ws(n, t) {
  this._context = n, this._k = (1 - t) / 6;
}
ws.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        Ji(this, n, t);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const px = function n(t) {
  function e(r) {
    return new ws(r, t);
  }
  return e.tension = function(r) {
    return n(+r);
  }, e;
}(0);
function xs(n, t, e) {
  var r = n._x1, i = n._y1, u = n._x2, o = n._y2;
  if (n._l01_a > mn) {
    var a = 2 * n._l01_2a + 3 * n._l01_a * n._l12_a + n._l12_2a, s = 3 * n._l01_a * (n._l01_a + n._l12_a);
    r = (r * a - n._x0 * n._l12_2a + n._x2 * n._l01_2a) / s, i = (i * a - n._y0 * n._l12_2a + n._y2 * n._l01_2a) / s;
  }
  if (n._l23_a > mn) {
    var c = 2 * n._l23_2a + 3 * n._l23_a * n._l12_a + n._l12_2a, l = 3 * n._l23_a * (n._l23_a + n._l12_a);
    u = (u * c + n._x1 * n._l23_2a - t * n._l12_2a) / l, o = (o * c + n._y1 * n._l23_2a - e * n._l12_2a) / l;
  }
  n._context.bezierCurveTo(r, i, u, o, n._x2, n._y2);
}
function b0(n, t) {
  this._context = n, this._alpha = t;
}
b0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    if (n = +n, t = +t, this._point) {
      var e = this._x2 - n, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(e * e + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, t) : this._context.moveTo(n, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        xs(this, n, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const gx = function n(t) {
  function e(r) {
    return t ? new b0(r, t) : new ms(r, 0);
  }
  return e.alpha = function(r) {
    return n(+r);
  }, e;
}(0.5);
function M0(n, t) {
  this._context = n, this._alpha = t;
}
M0.prototype = {
  areaStart: wt,
  areaEnd: wt,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(n, t) {
    if (n = +n, t = +t, this._point) {
      var e = this._x2 - n, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(e * e + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1, this._x3 = n, this._y3 = t;
        break;
      case 1:
        this._point = 2, this._context.moveTo(this._x4 = n, this._y4 = t);
        break;
      case 2:
        this._point = 3, this._x5 = n, this._y5 = t;
        break;
      default:
        xs(this, n, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const dx = function n(t) {
  function e(r) {
    return t ? new M0(r, t) : new _s(r, 0);
  }
  return e.alpha = function(r) {
    return n(+r);
  }, e;
}(0.5);
function S0(n, t) {
  this._context = n, this._alpha = t;
}
S0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    if (n = +n, t = +t, this._point) {
      var e = this._x2 - n, r = this._y2 - t;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(e * e + r * r, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        xs(this, n, t);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = n, this._y0 = this._y1, this._y1 = this._y2, this._y2 = t;
  }
};
const vx = function n(t) {
  function e(r) {
    return t ? new S0(r, t) : new ws(r, 0);
  }
  return e.alpha = function(r) {
    return n(+r);
  }, e;
}(0.5);
function T0(n) {
  this._context = n;
}
T0.prototype = {
  areaStart: wt,
  areaEnd: wt,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(n, t) {
    n = +n, t = +t, this._point ? this._context.lineTo(n, t) : (this._point = 1, this._context.moveTo(n, t));
  }
};
function yx(n) {
  return new T0(n);
}
function gf(n) {
  return n < 0 ? -1 : 1;
}
function df(n, t, e) {
  var r = n._x1 - n._x0, i = t - n._x1, u = (n._y1 - n._y0) / (r || i < 0 && -0), o = (e - n._y1) / (i || r < 0 && -0), a = (u * i + o * r) / (r + i);
  return (gf(u) + gf(o)) * Math.min(Math.abs(u), Math.abs(o), 0.5 * Math.abs(a)) || 0;
}
function vf(n, t) {
  var e = n._x1 - n._x0;
  return e ? (3 * (n._y1 - n._y0) / e - t) / 2 : t;
}
function co(n, t, e) {
  var r = n._x0, i = n._y0, u = n._x1, o = n._y1, a = (u - r) / 3;
  n._context.bezierCurveTo(r + a, i + a * t, u - a, o - a * e, u, o);
}
function ji(n) {
  this._context = n;
}
ji.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        co(this, this._t0, vf(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, t) {
    var e = NaN;
    if (n = +n, t = +t, !(n === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(n, t) : this._context.moveTo(n, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, co(this, vf(this, e = df(this, n, t)), e);
          break;
        default:
          co(this, this._t0, e = df(this, n, t));
          break;
      }
      this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = t, this._t0 = e;
    }
  }
};
function N0(n) {
  this._context = new E0(n);
}
(N0.prototype = Object.create(ji.prototype)).point = function(n, t) {
  ji.prototype.point.call(this, t, n);
};
function E0(n) {
  this._context = n;
}
E0.prototype = {
  moveTo: function(n, t) {
    this._context.moveTo(t, n);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(n, t) {
    this._context.lineTo(t, n);
  },
  bezierCurveTo: function(n, t, e, r, i, u) {
    this._context.bezierCurveTo(t, n, r, e, u, i);
  }
};
function mx(n) {
  return new ji(n);
}
function _x(n) {
  return new N0(n);
}
function k0(n) {
  this._context = n;
}
k0.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var n = this._x, t = this._y, e = n.length;
    if (e)
      if (this._line ? this._context.lineTo(n[0], t[0]) : this._context.moveTo(n[0], t[0]), e === 2)
        this._context.lineTo(n[1], t[1]);
      else
        for (var r = yf(n), i = yf(t), u = 0, o = 1; o < e; ++u, ++o)
          this._context.bezierCurveTo(r[0][u], i[0][u], r[1][u], i[1][u], n[o], t[o]);
    (this._line || this._line !== 0 && e === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(n, t) {
    this._x.push(+n), this._y.push(+t);
  }
};
function yf(n) {
  var t, e = n.length - 1, r, i = new Array(e), u = new Array(e), o = new Array(e);
  for (i[0] = 0, u[0] = 2, o[0] = n[0] + 2 * n[1], t = 1; t < e - 1; ++t) i[t] = 1, u[t] = 4, o[t] = 4 * n[t] + 2 * n[t + 1];
  for (i[e - 1] = 2, u[e - 1] = 7, o[e - 1] = 8 * n[e - 1] + n[e], t = 1; t < e; ++t) r = i[t] / u[t - 1], u[t] -= r, o[t] -= r * o[t - 1];
  for (i[e - 1] = o[e - 1] / u[e - 1], t = e - 2; t >= 0; --t) i[t] = (o[t] - i[t + 1]) / u[t];
  for (u[e - 1] = (n[e] + i[e - 1]) / 2, t = 0; t < e - 1; ++t) u[t] = 2 * n[t + 1] - i[t + 1];
  return [i, u];
}
function wx(n) {
  return new k0(n);
}
function ku(n, t) {
  this._context = n, this._t = t;
}
ku.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(n, t) {
    switch (n = +n, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, t) : this._context.moveTo(n, t);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(n, t);
        else {
          var e = this._x * (1 - this._t) + n * this._t;
          this._context.lineTo(e, this._y), this._context.lineTo(e, t);
        }
        break;
      }
    }
    this._x = n, this._y = t;
  }
};
function xx(n) {
  return new ku(n, 0.5);
}
function bx(n) {
  return new ku(n, 0);
}
function Mx(n) {
  return new ku(n, 1);
}
function ye(n, t) {
  if ((o = n.length) > 1)
    for (var e = 1, r, i, u = n[t[0]], o, a = u.length; e < o; ++e)
      for (i = u, u = n[t[e]], r = 0; r < a; ++r)
        u[r][1] += u[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function me(n) {
  for (var t = n.length, e = new Array(t); --t >= 0; ) e[t] = t;
  return e;
}
function Sx(n, t) {
  return n[t];
}
function Tx() {
  var n = X([]), t = me, e = ye, r = Sx;
  function i(u) {
    var o = n.apply(this, arguments), a, s = u.length, c = o.length, l = new Array(c), h;
    for (a = 0; a < c; ++a) {
      for (var f = o[a], p = l[a] = new Array(s), g = 0, d; g < s; ++g)
        p[g] = d = [0, +r(u[g], f, g, u)], d.data = u[g];
      p.key = f;
    }
    for (a = 0, h = t(l); a < c; ++a)
      l[h[a]].index = a;
    return e(l, h), l;
  }
  return i.keys = function(u) {
    return arguments.length ? (n = typeof u == "function" ? u : X(ra.call(u)), i) : n;
  }, i.value = function(u) {
    return arguments.length ? (r = typeof u == "function" ? u : X(+u), i) : r;
  }, i.order = function(u) {
    return arguments.length ? (t = u == null ? me : typeof u == "function" ? u : X(ra.call(u)), i) : t;
  }, i.offset = function(u) {
    return arguments.length ? (e = u ?? ye, i) : e;
  }, i;
}
function Nx(n, t) {
  if ((r = n.length) > 0) {
    for (var e, r, i = 0, u = n[0].length, o; i < u; ++i) {
      for (o = e = 0; e < r; ++e) o += n[e][i][1] || 0;
      if (o) for (e = 0; e < r; ++e) n[e][i][1] /= o;
    }
    ye(n, t);
  }
}
function Ex(n, t) {
  if ((s = n.length) > 1)
    for (var e, r = 0, i, u, o, a, s, c = n[t[0]].length; r < c; ++r)
      for (o = a = 0, e = 0; e < s; ++e)
        (u = (i = n[t[e]][r])[1] - i[0]) >= 0 ? (i[0] = o, i[1] = o += u) : u < 0 ? (i[1] = a, i[0] = a += u) : i[0] = o;
}
function kx(n, t) {
  if ((i = n.length) > 0) {
    for (var e = 0, r = n[t[0]], i, u = r.length; e < u; ++e) {
      for (var o = 0, a = 0; o < i; ++o) a += n[o][e][1] || 0;
      r[e][1] += r[e][0] = -a / 2;
    }
    ye(n, t);
  }
}
function Cx(n, t) {
  if (!(!((o = n.length) > 0) || !((u = (i = n[t[0]]).length) > 0))) {
    for (var e = 0, r = 1, i, u, o; r < u; ++r) {
      for (var a = 0, s = 0, c = 0; a < o; ++a) {
        for (var l = n[t[a]], h = l[r][1] || 0, f = l[r - 1][1] || 0, p = (h - f) / 2, g = 0; g < a; ++g) {
          var d = n[t[g]], v = d[r][1] || 0, y = d[r - 1][1] || 0;
          p += v - y;
        }
        s += h, c += p * h;
      }
      i[r - 1][1] += i[r - 1][0] = e, s && (e -= c / s);
    }
    i[r - 1][1] += i[r - 1][0] = e, ye(n, t);
  }
}
function C0(n) {
  var t = n.map(A0);
  return me(n).sort(function(e, r) {
    return t[e] - t[r];
  });
}
function A0(n) {
  for (var t = 0, e = -1, r = n.length, i; ++e < r; ) (i = +n[e][1]) && (t += i);
  return t;
}
function Ax(n) {
  return C0(n).reverse();
}
function Rx(n) {
  var t = n.length, e, r, i = n.map(A0), u = me(n).sort(function(l, h) {
    return i[h] - i[l];
  }), o = 0, a = 0, s = [], c = [];
  for (e = 0; e < t; ++e)
    r = u[e], o < a ? (o += i[r], s.push(r)) : (a += i[r], c.push(r));
  return c.reverse().concat(s);
}
function $x(n) {
  return me(n).reverse();
}
function mf(n) {
  return function() {
    return n;
  };
}
function Px(n) {
  return n[0];
}
function zx(n) {
  return n[1];
}
function nu() {
  this._ = null;
}
function Cu(n) {
  n.U = // parent node
  n.C = // color - true for red, false for black
  n.L = // left node
  n.R = // right node
  n.P = // previous node
  n.N = null;
}
nu.prototype = {
  constructor: nu,
  insert: function(n, t) {
    var e, r, i;
    if (n) {
      if (t.P = n, t.N = n.N, n.N && (n.N.P = t), n.N = t, n.R) {
        for (n = n.R; n.L; ) n = n.L;
        n.L = t;
      } else
        n.R = t;
      e = n;
    } else this._ ? (n = _f(this._), t.P = null, t.N = n, n.P = n.L = t, e = n) : (t.P = t.N = null, this._ = t, e = null);
    for (t.L = t.R = null, t.U = e, t.C = !0, n = t; e && e.C; )
      r = e.U, e === r.L ? (i = r.R, i && i.C ? (e.C = i.C = !1, r.C = !0, n = r) : (n === e.R && (Re(this, e), n = e, e = n.U), e.C = !1, r.C = !0, $e(this, r))) : (i = r.L, i && i.C ? (e.C = i.C = !1, r.C = !0, n = r) : (n === e.L && ($e(this, e), n = e, e = n.U), e.C = !1, r.C = !0, Re(this, r))), e = n.U;
    this._.C = !1;
  },
  remove: function(n) {
    n.N && (n.N.P = n.P), n.P && (n.P.N = n.N), n.N = n.P = null;
    var t = n.U, e, r = n.L, i = n.R, u, o;
    if (r ? i ? u = _f(i) : u = r : u = i, t ? t.L === n ? t.L = u : t.R = u : this._ = u, r && i ? (o = u.C, u.C = n.C, u.L = r, r.U = u, u !== i ? (t = u.U, u.U = n.U, n = u.R, t.L = n, u.R = i, i.U = u) : (u.U = t, t = u, n = u.R)) : (o = n.C, n = u), n && (n.U = t), !o) {
      if (n && n.C) {
        n.C = !1;
        return;
      }
      do {
        if (n === this._) break;
        if (n === t.L) {
          if (e = t.R, e.C && (e.C = !1, t.C = !0, Re(this, t), e = t.R), e.L && e.L.C || e.R && e.R.C) {
            (!e.R || !e.R.C) && (e.L.C = !1, e.C = !0, $e(this, e), e = t.R), e.C = t.C, t.C = e.R.C = !1, Re(this, t), n = this._;
            break;
          }
        } else if (e = t.L, e.C && (e.C = !1, t.C = !0, $e(this, t), e = t.L), e.L && e.L.C || e.R && e.R.C) {
          (!e.L || !e.L.C) && (e.R.C = !1, e.C = !0, Re(this, e), e = t.L), e.C = t.C, t.C = e.L.C = !1, $e(this, t), n = this._;
          break;
        }
        e.C = !0, n = t, t = t.U;
      } while (!n.C);
      n && (n.C = !1);
    }
  }
};
function Re(n, t) {
  var e = t, r = t.R, i = e.U;
  i ? i.L === e ? i.L = r : i.R = r : n._ = r, r.U = i, e.U = r, e.R = r.L, e.R && (e.R.U = e), r.L = e;
}
function $e(n, t) {
  var e = t, r = t.L, i = e.U;
  i ? i.L === e ? i.L = r : i.R = r : n._ = r, r.U = i, e.U = r, e.L = r.R, e.L && (e.L.U = e), r.R = e;
}
function _f(n) {
  for (; n.L; ) n = n.L;
  return n;
}
function Qe(n, t, e, r) {
  var i = [null, null], u = _n.push(i) - 1;
  return i.left = n, i.right = t, e && tu(i, n, t, e), r && tu(i, t, n, r), zn[n.index].halfedges.push(u), zn[t.index].halfedges.push(u), i;
}
function Pe(n, t, e) {
  var r = [t, e];
  return r.left = n, r;
}
function tu(n, t, e, r) {
  !n[0] && !n[1] ? (n[0] = r, n.left = t, n.right = e) : n.left === e ? n[1] = r : n[0] = r;
}
function Ix(n, t, e, r, i) {
  var u = n[0], o = n[1], a = u[0], s = u[1], c = o[0], l = o[1], h = 0, f = 1, p = c - a, g = l - s, d;
  if (d = t - a, !(!p && d > 0)) {
    if (d /= p, p < 0) {
      if (d < h) return;
      d < f && (f = d);
    } else if (p > 0) {
      if (d > f) return;
      d > h && (h = d);
    }
    if (d = r - a, !(!p && d < 0)) {
      if (d /= p, p < 0) {
        if (d > f) return;
        d > h && (h = d);
      } else if (p > 0) {
        if (d < h) return;
        d < f && (f = d);
      }
      if (d = e - s, !(!g && d > 0)) {
        if (d /= g, g < 0) {
          if (d < h) return;
          d < f && (f = d);
        } else if (g > 0) {
          if (d > f) return;
          d > h && (h = d);
        }
        if (d = i - s, !(!g && d < 0)) {
          if (d /= g, g < 0) {
            if (d > f) return;
            d > h && (h = d);
          } else if (g > 0) {
            if (d < h) return;
            d < f && (f = d);
          }
          return !(h > 0) && !(f < 1) || (h > 0 && (n[0] = [a + h * p, s + h * g]), f < 1 && (n[1] = [a + f * p, s + f * g])), !0;
        }
      }
    }
  }
}
function Lx(n, t, e, r, i) {
  var u = n[1];
  if (u) return !0;
  var o = n[0], a = n.left, s = n.right, c = a[0], l = a[1], h = s[0], f = s[1], p = (c + h) / 2, g = (l + f) / 2, d, v;
  if (f === l) {
    if (p < t || p >= r) return;
    if (c > h) {
      if (!o) o = [p, e];
      else if (o[1] >= i) return;
      u = [p, i];
    } else {
      if (!o) o = [p, i];
      else if (o[1] < e) return;
      u = [p, e];
    }
  } else if (d = (c - h) / (f - l), v = g - d * p, d < -1 || d > 1)
    if (c > h) {
      if (!o) o = [(e - v) / d, e];
      else if (o[1] >= i) return;
      u = [(i - v) / d, i];
    } else {
      if (!o) o = [(i - v) / d, i];
      else if (o[1] < e) return;
      u = [(e - v) / d, e];
    }
  else if (l < f) {
    if (!o) o = [t, d * t + v];
    else if (o[0] >= r) return;
    u = [r, d * r + v];
  } else {
    if (!o) o = [r, d * r + v];
    else if (o[0] < t) return;
    u = [t, d * t + v];
  }
  return n[0] = o, n[1] = u, !0;
}
function Dx(n, t, e, r) {
  for (var i = _n.length, u; i--; )
    (!Lx(u = _n[i], n, t, e, r) || !Ix(u, n, t, e, r) || !(Math.abs(u[0][0] - u[1][0]) > j || Math.abs(u[0][1] - u[1][1]) > j)) && delete _n[i];
}
function Ox(n) {
  return zn[n.index] = {
    site: n,
    halfedges: []
  };
}
function Ux(n, t) {
  var e = n.site, r = t.left, i = t.right;
  return e === i && (i = r, r = e), i ? Math.atan2(i[1] - r[1], i[0] - r[0]) : (e === r ? (r = t[1], i = t[0]) : (r = t[0], i = t[1]), Math.atan2(r[0] - i[0], i[1] - r[1]));
}
function R0(n, t) {
  return t[+(t.left !== n.site)];
}
function Fx(n, t) {
  return t[+(t.left === n.site)];
}
function Yx() {
  for (var n = 0, t = zn.length, e, r, i, u; n < t; ++n)
    if ((e = zn[n]) && (u = (r = e.halfedges).length)) {
      var o = new Array(u), a = new Array(u);
      for (i = 0; i < u; ++i) o[i] = i, a[i] = Ux(e, _n[r[i]]);
      for (o.sort(function(s, c) {
        return a[c] - a[s];
      }), i = 0; i < u; ++i) a[i] = r[o[i]];
      for (i = 0; i < u; ++i) r[i] = a[i];
    }
}
function qx(n, t, e, r) {
  var i = zn.length, u, o, a, s, c, l, h, f, p, g, d, v, y = !0;
  for (u = 0; u < i; ++u)
    if (o = zn[u]) {
      for (a = o.site, c = o.halfedges, s = c.length; s--; )
        _n[c[s]] || c.splice(s, 1);
      for (s = 0, l = c.length; s < l; )
        g = Fx(o, _n[c[s]]), d = g[0], v = g[1], h = R0(o, _n[c[++s % l]]), f = h[0], p = h[1], (Math.abs(d - f) > j || Math.abs(v - p) > j) && (c.splice(s, 0, _n.push(Pe(
          a,
          g,
          Math.abs(d - n) < j && r - v > j ? [n, Math.abs(f - n) < j ? p : r] : Math.abs(v - r) < j && e - d > j ? [Math.abs(p - r) < j ? f : e, r] : Math.abs(d - e) < j && v - t > j ? [e, Math.abs(f - e) < j ? p : t] : Math.abs(v - t) < j && d - n > j ? [Math.abs(p - t) < j ? f : n, t] : null
        )) - 1), ++l);
      l && (y = !1);
    }
  if (y) {
    var x, m, w, M = 1 / 0;
    for (u = 0, y = null; u < i; ++u)
      (o = zn[u]) && (a = o.site, x = a[0] - n, m = a[1] - t, w = x * x + m * m, w < M && (M = w, y = o));
    if (y) {
      var N = [n, t], S = [n, r], E = [e, r], T = [e, t];
      y.halfedges.push(
        _n.push(Pe(a = y.site, N, S)) - 1,
        _n.push(Pe(a, S, E)) - 1,
        _n.push(Pe(a, E, T)) - 1,
        _n.push(Pe(a, T, N)) - 1
      );
    }
  }
  for (u = 0; u < i; ++u)
    (o = zn[u]) && (o.halfedges.length || delete zn[u]);
}
var $0 = [], bs;
function Hx() {
  Cu(this), this.x = this.y = this.arc = this.site = this.cy = null;
}
function ee(n) {
  var t = n.P, e = n.N;
  if (!(!t || !e)) {
    var r = t.site, i = n.site, u = e.site;
    if (r !== u) {
      var o = i[0], a = i[1], s = r[0] - o, c = r[1] - a, l = u[0] - o, h = u[1] - a, f = 2 * (s * h - c * l);
      if (!(f >= -1e-12)) {
        var p = s * s + c * c, g = l * l + h * h, d = (h * p - c * g) / f, v = (s * g - l * p) / f, y = $0.pop() || new Hx();
        y.arc = n, y.site = i, y.x = d + o, y.y = (y.cy = v + a) + Math.sqrt(d * d + v * v), n.circle = y;
        for (var x = null, m = Sr._; m; )
          if (y.y < m.y || y.y === m.y && y.x <= m.x)
            if (m.L) m = m.L;
            else {
              x = m.P;
              break;
            }
          else if (m.R) m = m.R;
          else {
            x = m;
            break;
          }
        Sr.insert(x, y), x || (bs = y);
      }
    }
  }
}
function ae(n) {
  var t = n.circle;
  t && (t.P || (bs = t.N), Sr.remove(t), $0.push(t), Cu(t), n.circle = null);
}
var P0 = [];
function Bx() {
  Cu(this), this.edge = this.site = this.circle = null;
}
function wf(n) {
  var t = P0.pop() || new Bx();
  return t.site = n, t;
}
function fo(n) {
  ae(n), se.remove(n), P0.push(n), Cu(n);
}
function Xx(n) {
  var t = n.circle, e = t.x, r = t.cy, i = [e, r], u = n.P, o = n.N, a = [n];
  fo(n);
  for (var s = u; s.circle && Math.abs(e - s.circle.x) < j && Math.abs(r - s.circle.cy) < j; )
    u = s.P, a.unshift(s), fo(s), s = u;
  a.unshift(s), ae(s);
  for (var c = o; c.circle && Math.abs(e - c.circle.x) < j && Math.abs(r - c.circle.cy) < j; )
    o = c.N, a.push(c), fo(c), c = o;
  a.push(c), ae(c);
  var l = a.length, h;
  for (h = 1; h < l; ++h)
    c = a[h], s = a[h - 1], tu(c.edge, s.site, c.site, i);
  s = a[0], c = a[l - 1], c.edge = Qe(s.site, c.site, null, i), ee(s), ee(c);
}
function Wx(n) {
  for (var t = n[0], e = n[1], r, i, u, o, a = se._; a; )
    if (u = z0(a, e) - t, u > j) a = a.L;
    else if (o = t - Vx(a, e), o > j) {
      if (!a.R) {
        r = a;
        break;
      }
      a = a.R;
    } else {
      u > -j ? (r = a.P, i = a) : o > -j ? (r = a, i = a.N) : r = i = a;
      break;
    }
  Ox(n);
  var s = wf(n);
  if (se.insert(r, s), !(!r && !i)) {
    if (r === i) {
      ae(r), i = wf(r.site), se.insert(s, i), s.edge = i.edge = Qe(r.site, s.site), ee(r), ee(i);
      return;
    }
    if (!i) {
      s.edge = Qe(r.site, s.site);
      return;
    }
    ae(r), ae(i);
    var c = r.site, l = c[0], h = c[1], f = n[0] - l, p = n[1] - h, g = i.site, d = g[0] - l, v = g[1] - h, y = 2 * (f * v - p * d), x = f * f + p * p, m = d * d + v * v, w = [(v * x - p * m) / y + l, (f * m - d * x) / y + h];
    tu(i.edge, c, g, w), s.edge = Qe(c, n, null, w), i.edge = Qe(n, g, null, w), ee(r), ee(i);
  }
}
function z0(n, t) {
  var e = n.site, r = e[0], i = e[1], u = i - t;
  if (!u) return r;
  var o = n.P;
  if (!o) return -1 / 0;
  e = o.site;
  var a = e[0], s = e[1], c = s - t;
  if (!c) return a;
  var l = a - r, h = 1 / u - 1 / c, f = l / c;
  return h ? (-f + Math.sqrt(f * f - 2 * h * (l * l / (-2 * c) - s + c / 2 + i - u / 2))) / h + r : (r + a) / 2;
}
function Vx(n, t) {
  var e = n.N;
  if (e) return z0(e, t);
  var r = n.site;
  return r[1] === t ? r[0] : 1 / 0;
}
var j = 1e-6, se, zn, Sr, _n;
function Zx(n, t, e) {
  return (n[0] - e[0]) * (t[1] - n[1]) - (n[0] - t[0]) * (e[1] - n[1]);
}
function Gx(n, t) {
  return t[1] - n[1] || t[0] - n[0];
}
function ua(n, t) {
  var e = n.sort(Gx).pop(), r, i, u;
  for (_n = [], zn = new Array(n.length), se = new nu(), Sr = new nu(); ; )
    if (u = bs, e && (!u || e[1] < u.y || e[1] === u.y && e[0] < u.x))
      (e[0] !== r || e[1] !== i) && (Wx(e), r = e[0], i = e[1]), e = n.pop();
    else if (u)
      Xx(u.arc);
    else
      break;
  if (Yx(), t) {
    var o = +t[0][0], a = +t[0][1], s = +t[1][0], c = +t[1][1];
    Dx(o, a, s, c), qx(o, a, s, c);
  }
  this.edges = _n, this.cells = zn, se = Sr = _n = zn = null;
}
ua.prototype = {
  constructor: ua,
  polygons: function() {
    var n = this.edges;
    return this.cells.map(function(t) {
      var e = t.halfedges.map(function(r) {
        return R0(t, n[r]);
      });
      return e.data = t.site.data, e;
    });
  },
  triangles: function() {
    var n = [], t = this.edges;
    return this.cells.forEach(function(e, r) {
      if (a = (u = e.halfedges).length)
        for (var i = e.site, u, o = -1, a, s, c = t[u[a - 1]], l = c.left === i ? c.right : c.left; ++o < a; )
          s = l, c = t[u[o]], l = c.left === i ? c.right : c.left, s && l && r < s.index && r < l.index && Zx(i, s, l) < 0 && n.push([i.data, s.data, l.data]);
    }), n;
  },
  links: function() {
    return this.edges.filter(function(n) {
      return n.right;
    }).map(function(n) {
      return {
        source: n.left.data,
        target: n.right.data
      };
    });
  },
  find: function(n, t, e) {
    for (var r = this, i, u = r._found || 0, o = r.cells.length, a; !(a = r.cells[u]); ) if (++u >= o) return null;
    var s = n - a.site[0], c = t - a.site[1], l = s * s + c * c;
    do
      a = r.cells[i = u], u = null, a.halfedges.forEach(function(h) {
        var f = r.edges[h], p = f.left;
        if (!((p === a.site || !p) && !(p = f.right))) {
          var g = n - p[0], d = t - p[1], v = g * g + d * d;
          v < l && (l = v, u = p.index);
        }
      });
    while (u !== null);
    return r._found = i, e == null || l <= e * e ? a.site : null;
  }
};
function Qx() {
  var n = Px, t = zx, e = null;
  function r(i) {
    return new ua(i.map(function(u, o) {
      var a = [Math.round(n(u, o, i) / j) * j, Math.round(t(u, o, i) / j) * j];
      return a.index = o, a.data = u, a;
    }), e);
  }
  return r.polygons = function(i) {
    return r(i).polygons();
  }, r.links = function(i) {
    return r(i).links();
  }, r.triangles = function(i) {
    return r(i).triangles();
  }, r.x = function(i) {
    return arguments.length ? (n = typeof i == "function" ? i : mf(+i), r) : n;
  }, r.y = function(i) {
    return arguments.length ? (t = typeof i == "function" ? i : mf(+i), r) : t;
  }, r.extent = function(i) {
    return arguments.length ? (e = i == null ? null : [[+i[0][0], +i[0][1]], [+i[1][0], +i[1][1]]], r) : e && [[e[0][0], e[0][1]], [e[1][0], e[1][1]]];
  }, r.size = function(i) {
    return arguments.length ? (e = i == null ? null : [[0, 0], [+i[0], +i[1]]], r) : e && [e[1][0] - e[0][0], e[1][1] - e[0][1]];
  }, r;
}
function ri(n) {
  return function() {
    return n;
  };
}
function Kx(n, t, e) {
  this.target = n, this.type = t, this.transform = e;
}
function ut(n, t, e) {
  this.k = n, this.x = t, this.y = e;
}
ut.prototype = {
  constructor: ut,
  scale: function(n) {
    return n === 1 ? this : new ut(this.k * n, this.x, this.y);
  },
  translate: function(n, t) {
    return n === 0 & t === 0 ? this : new ut(this.k, this.x + this.k * n, this.y + this.k * t);
  },
  apply: function(n) {
    return [n[0] * this.k + this.x, n[1] * this.k + this.y];
  },
  applyX: function(n) {
    return n * this.k + this.x;
  },
  applyY: function(n) {
    return n * this.k + this.y;
  },
  invert: function(n) {
    return [(n[0] - this.x) / this.k, (n[1] - this.y) / this.k];
  },
  invertX: function(n) {
    return (n - this.x) / this.k;
  },
  invertY: function(n) {
    return (n - this.y) / this.k;
  },
  rescaleX: function(n) {
    return n.copy().domain(n.range().map(this.invertX, this).map(n.invert, n));
  },
  rescaleY: function(n) {
    return n.copy().domain(n.range().map(this.invertY, this).map(n.invert, n));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var Au = new ut(1, 0, 0);
I0.prototype = ut.prototype;
function I0(n) {
  return n.__zoom || Au;
}
function lo() {
  L.stopImmediatePropagation();
}
function ze() {
  L.preventDefault(), L.stopImmediatePropagation();
}
function Jx() {
  return !L.button;
}
function jx() {
  var n = this, t, e;
  return n instanceof SVGElement ? (n = n.ownerSVGElement || n, t = n.width.baseVal.value, e = n.height.baseVal.value) : (t = n.clientWidth, e = n.clientHeight), [[0, 0], [t, e]];
}
function xf() {
  return this.__zoom || Au;
}
function n3() {
  return -L.deltaY * (L.deltaMode ? 120 : 1) / 500;
}
function t3() {
  return "ontouchstart" in this;
}
function e3(n, t, e) {
  var r = n.invertX(t[0][0]) - e[0][0], i = n.invertX(t[1][0]) - e[1][0], u = n.invertY(t[0][1]) - e[0][1], o = n.invertY(t[1][1]) - e[1][1];
  return n.translate(
    i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i),
    o > u ? (u + o) / 2 : Math.min(0, u) || Math.max(0, o)
  );
}
function r3() {
  var n = Jx, t = jx, e = e3, r = n3, i = t3, u = [0, 1 / 0], o = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], a = 250, s = sl, c = [], l = xt("start", "zoom", "end"), h, f, p = 500, g = 150, d = 0;
  function v(_) {
    _.property("__zoom", xf).on("wheel.zoom", S).on("mousedown.zoom", E).on("dblclick.zoom", T).filter(i).on("touchstart.zoom", $).on("touchmove.zoom", A).on("touchend.zoom touchcancel.zoom", k).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  v.transform = function(_, b) {
    var C = _.selection ? _.selection() : _;
    C.property("__zoom", xf), _ !== C ? w(_, b) : C.interrupt().each(function() {
      M(this, arguments).start().zoom(null, typeof b == "function" ? b.apply(this, arguments) : b).end();
    });
  }, v.scaleBy = function(_, b) {
    v.scaleTo(_, function() {
      var C = this.__zoom.k, R = typeof b == "function" ? b.apply(this, arguments) : b;
      return C * R;
    });
  }, v.scaleTo = function(_, b) {
    v.transform(_, function() {
      var C = t.apply(this, arguments), R = this.__zoom, P = m(C), q = R.invert(P), Y = typeof b == "function" ? b.apply(this, arguments) : b;
      return e(x(y(R, Y), P, q), C, o);
    });
  }, v.translateBy = function(_, b, C) {
    v.transform(_, function() {
      return e(this.__zoom.translate(
        typeof b == "function" ? b.apply(this, arguments) : b,
        typeof C == "function" ? C.apply(this, arguments) : C
      ), t.apply(this, arguments), o);
    });
  }, v.translateTo = function(_, b, C) {
    v.transform(_, function() {
      var R = t.apply(this, arguments), P = this.__zoom, q = m(R);
      return e(Au.translate(q[0], q[1]).scale(P.k).translate(
        typeof b == "function" ? -b.apply(this, arguments) : -b,
        typeof C == "function" ? -C.apply(this, arguments) : -C
      ), R, o);
    });
  };
  function y(_, b) {
    return b = Math.max(u[0], Math.min(u[1], b)), b === _.k ? _ : new ut(b, _.x, _.y);
  }
  function x(_, b, C) {
    var R = b[0] - C[0] * _.k, P = b[1] - C[1] * _.k;
    return R === _.x && P === _.y ? _ : new ut(_.k, R, P);
  }
  function m(_) {
    return [(+_[0][0] + +_[1][0]) / 2, (+_[0][1] + +_[1][1]) / 2];
  }
  function w(_, b, C) {
    _.on("start.zoom", function() {
      M(this, arguments).start();
    }).on("interrupt.zoom end.zoom", function() {
      M(this, arguments).end();
    }).tween("zoom", function() {
      var R = this, P = arguments, q = M(R, P), Y = t.apply(R, P), G = C || m(Y), V = Math.max(Y[1][0] - Y[0][0], Y[1][1] - Y[0][1]), tn = R.__zoom, Q = typeof b == "function" ? b.apply(R, P) : b, en = s(tn.invert(G).concat(V / tn.k), Q.invert(G).concat(V / Q.k));
      return function(K) {
        if (K === 1) K = Q;
        else {
          var wn = en(K), I = V / wn[2];
          K = new ut(I, G[0] - wn[0] * I, G[1] - wn[1] * I);
        }
        q.zoom(null, K);
      };
    });
  }
  function M(_, b) {
    for (var C = 0, R = c.length, P; C < R; ++C)
      if ((P = c[C]).that === _)
        return P;
    return new N(_, b);
  }
  function N(_, b) {
    this.that = _, this.args = b, this.index = -1, this.active = 0, this.extent = t.apply(_, b);
  }
  N.prototype = {
    start: function() {
      return ++this.active === 1 && (this.index = c.push(this) - 1, this.emit("start")), this;
    },
    zoom: function(_, b) {
      return this.mouse && _ !== "mouse" && (this.mouse[1] = b.invert(this.mouse[0])), this.touch0 && _ !== "touch" && (this.touch0[1] = b.invert(this.touch0[0])), this.touch1 && _ !== "touch" && (this.touch1[1] = b.invert(this.touch1[0])), this.that.__zoom = b, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (c.splice(this.index, 1), this.index = -1, this.emit("end")), this;
    },
    emit: function(_) {
      ir(new Kx(v, _, this.that.__zoom), l.apply, l, [_, this.that, this.args]);
    }
  };
  function S() {
    if (!n.apply(this, arguments)) return;
    var _ = M(this, arguments), b = this.__zoom, C = Math.max(u[0], Math.min(u[1], b.k * Math.pow(2, r.apply(this, arguments)))), R = ht(this);
    if (_.wheel)
      (_.mouse[0][0] !== R[0] || _.mouse[0][1] !== R[1]) && (_.mouse[1] = b.invert(_.mouse[0] = R)), clearTimeout(_.wheel);
    else {
      if (b.k === C) return;
      _.mouse = [R, b.invert(R)], Pt(this), _.start();
    }
    ze(), _.wheel = setTimeout(P, g), _.zoom("mouse", e(x(y(b, C), _.mouse[0], _.mouse[1]), _.extent, o));
    function P() {
      _.wheel = null, _.end();
    }
  }
  function E() {
    if (f || !n.apply(this, arguments)) return;
    var _ = M(this, arguments), b = kn(L.view).on("mousemove.zoom", q, !0).on("mouseup.zoom", Y, !0), C = ht(this), R = L.clientX, P = L.clientY;
    ou(L.view), lo(), _.mouse = [C, this.__zoom.invert(C)], Pt(this), _.start();
    function q() {
      if (ze(), !_.moved) {
        var G = L.clientX - R, V = L.clientY - P;
        _.moved = G * G + V * V > d;
      }
      _.zoom("mouse", e(x(_.that.__zoom, _.mouse[0] = ht(_.that), _.mouse[1]), _.extent, o));
    }
    function Y() {
      b.on("mousemove.zoom mouseup.zoom", null), au(L.view, _.moved), ze(), _.end();
    }
  }
  function T() {
    if (n.apply(this, arguments)) {
      var _ = this.__zoom, b = ht(this), C = _.invert(b), R = _.k * (L.shiftKey ? 0.5 : 2), P = e(x(y(_, R), b, C), t.apply(this, arguments), o);
      ze(), a > 0 ? kn(this).transition().duration(a).call(w, P, b) : kn(this).call(v.transform, P);
    }
  }
  function $() {
    if (n.apply(this, arguments)) {
      var _ = M(this, arguments), b = L.changedTouches, C, R = b.length, P, q, Y;
      for (lo(), P = 0; P < R; ++P)
        q = b[P], Y = di(this, b, q.identifier), Y = [Y, this.__zoom.invert(Y), q.identifier], _.touch0 ? _.touch1 || (_.touch1 = Y) : (_.touch0 = Y, C = !0);
      if (h && (h = clearTimeout(h), !_.touch1)) {
        _.end(), Y = kn(this).on("dblclick.zoom"), Y && Y.apply(this, arguments);
        return;
      }
      C && (h = setTimeout(function() {
        h = null;
      }, p), Pt(this), _.start());
    }
  }
  function A() {
    var _ = M(this, arguments), b = L.changedTouches, C = b.length, R, P, q, Y;
    for (ze(), h && (h = clearTimeout(h)), R = 0; R < C; ++R)
      P = b[R], q = di(this, b, P.identifier), _.touch0 && _.touch0[2] === P.identifier ? _.touch0[0] = q : _.touch1 && _.touch1[2] === P.identifier && (_.touch1[0] = q);
    if (P = _.that.__zoom, _.touch1) {
      var G = _.touch0[0], V = _.touch0[1], tn = _.touch1[0], Q = _.touch1[1], en = (en = tn[0] - G[0]) * en + (en = tn[1] - G[1]) * en, K = (K = Q[0] - V[0]) * K + (K = Q[1] - V[1]) * K;
      P = y(P, Math.sqrt(en / K)), q = [(G[0] + tn[0]) / 2, (G[1] + tn[1]) / 2], Y = [(V[0] + Q[0]) / 2, (V[1] + Q[1]) / 2];
    } else if (_.touch0) q = _.touch0[0], Y = _.touch0[1];
    else return;
    _.zoom("touch", e(x(P, q, Y), _.extent, o));
  }
  function k() {
    var _ = M(this, arguments), b = L.changedTouches, C = b.length, R, P;
    for (lo(), f && clearTimeout(f), f = setTimeout(function() {
      f = null;
    }, p), R = 0; R < C; ++R)
      P = b[R], _.touch0 && _.touch0[2] === P.identifier ? delete _.touch0 : _.touch1 && _.touch1[2] === P.identifier && delete _.touch1;
    _.touch1 && !_.touch0 && (_.touch0 = _.touch1, delete _.touch1), _.touch0 ? _.touch0[1] = this.__zoom.invert(_.touch0[0]) : _.end();
  }
  return v.wheelDelta = function(_) {
    return arguments.length ? (r = typeof _ == "function" ? _ : ri(+_), v) : r;
  }, v.filter = function(_) {
    return arguments.length ? (n = typeof _ == "function" ? _ : ri(!!_), v) : n;
  }, v.touchable = function(_) {
    return arguments.length ? (i = typeof _ == "function" ? _ : ri(!!_), v) : i;
  }, v.extent = function(_) {
    return arguments.length ? (t = typeof _ == "function" ? _ : ri([[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]]), v) : t;
  }, v.scaleExtent = function(_) {
    return arguments.length ? (u[0] = +_[0], u[1] = +_[1], v) : [u[0], u[1]];
  }, v.translateExtent = function(_) {
    return arguments.length ? (o[0][0] = +_[0][0], o[1][0] = +_[1][0], o[0][1] = +_[0][1], o[1][1] = +_[1][1], v) : [[o[0][0], o[0][1]], [o[1][0], o[1][1]]];
  }, v.constrain = function(_) {
    return arguments.length ? (e = _, v) : e;
  }, v.duration = function(_) {
    return arguments.length ? (a = +_, v) : a;
  }, v.interpolate = function(_) {
    return arguments.length ? (s = _, v) : s;
  }, v.on = function() {
    var _ = l.on.apply(l, arguments);
    return _ === l ? v : _;
  }, v.clickDistance = function(_) {
    return arguments.length ? (d = (_ = +_) * _, v) : Math.sqrt(d);
  }, v;
}
const i3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  active: Zd,
  arc: qw,
  area: s0,
  areaRadial: pf,
  ascending: qt,
  axisBottom: l1,
  axisLeft: h1,
  axisRight: f1,
  axisTop: c1,
  bisect: It,
  bisectLeft: O0,
  bisectRight: It,
  bisector: oa,
  brush: iv,
  brushSelection: tv,
  brushX: ev,
  brushY: rv,
  chord: ov,
  clientPoint: uu,
  cluster: Em,
  color: yt,
  create: Ip,
  creator: ru,
  cross: F0,
  csv: L2,
  csvFormat: Sv,
  csvFormatRows: Tv,
  csvParse: Sl,
  csvParseRows: Mv,
  cubehelix: Bn,
  curveBasis: ax,
  curveBasisClosed: sx,
  curveBasisOpen: cx,
  curveBundle: fx,
  curveCardinal: lx,
  curveCardinalClosed: hx,
  curveCardinalOpen: px,
  curveCatmullRom: gx,
  curveCatmullRomClosed: dx,
  curveCatmullRomOpen: vx,
  curveLinear: Nu,
  curveLinearClosed: yx,
  curveMonotoneX: mx,
  curveMonotoneY: _x,
  curveNatural: wx,
  curveStep: xx,
  curveStepAfter: Mx,
  curveStepBefore: bx,
  customEvent: ir,
  descending: Y0,
  deviation: Tf,
  dispatch: xt,
  drag: Hp,
  dragDisable: ou,
  dragEnable: au,
  dsvFormat: ka,
  easeBack: Xs,
  easeBackIn: Yd,
  easeBackInOut: Xs,
  easeBackOut: qd,
  easeBounce: lr,
  easeBounceIn: Ud,
  easeBounceInOut: Fd,
  easeBounceOut: lr,
  easeCircle: Bs,
  easeCircleIn: Cd,
  easeCircleInOut: Bs,
  easeCircleOut: Ad,
  easeCubic: Eo,
  easeCubicIn: xd,
  easeCubicInOut: Eo,
  easeCubicOut: bd,
  easeElastic: Ws,
  easeElasticIn: Hd,
  easeElasticInOut: Bd,
  easeElasticOut: Ws,
  easeExp: Hs,
  easeExpIn: Ed,
  easeExpInOut: Hs,
  easeExpOut: kd,
  easeLinear: md,
  easePoly: Ys,
  easePolyIn: Md,
  easePolyInOut: Ys,
  easePolyOut: Sd,
  easeQuad: Fs,
  easeQuadIn: _d,
  easeQuadInOut: Fs,
  easeQuadOut: wd,
  easeSin: qs,
  easeSinIn: Td,
  easeSinInOut: qs,
  easeSinOut: Nd,
  entries: wv,
  get event() {
    return L;
  },
  extent: Nf,
  forceCenter: Cv,
  forceCollide: Zv,
  forceLink: Qv,
  forceManyBody: ey,
  forceRadial: ry,
  forceSimulation: ty,
  forceX: iy,
  forceY: uy,
  get format() {
    return yu;
  },
  formatDefaultLocale: Al,
  formatLocale: Cl,
  get formatPrefix() {
    return Ra;
  },
  formatSpecifier: pr,
  geoAlbers: dh,
  geoAlbersUsa: am,
  geoArea: gy,
  geoAzimuthalEqualArea: sm,
  geoAzimuthalEqualAreaRaw: Ya,
  geoAzimuthalEquidistant: cm,
  geoAzimuthalEquidistantRaw: qa,
  geoBounds: my,
  geoCentroid: Sy,
  geoCircle: Ty,
  geoClipAntimeridian: qo,
  geoClipCircle: jl,
  geoClipExtent: $y,
  geoClipRectangle: mu,
  geoConicConformal: lm,
  geoConicConformalRaw: mh,
  geoConicEqualArea: Vi,
  geoConicEqualAreaRaw: gh,
  geoConicEquidistant: pm,
  geoConicEquidistantRaw: _h,
  geoContains: Uy,
  geoDistance: je,
  geoEquirectangular: hm,
  geoEquirectangularRaw: yr,
  geoGnomonic: gm,
  geoGnomonicRaw: Ha,
  geoGraticule: eh,
  geoGraticule10: Fy,
  geoIdentity: dm,
  geoInterpolate: Yy,
  geoLength: nh,
  geoMercator: fm,
  geoMercatorRaw: Rr,
  geoNaturalEarth1: vm,
  geoNaturalEarth1Raw: Ba,
  geoOrthographic: ym,
  geoOrthographicRaw: Xa,
  geoPath: Jy,
  geoProjection: ct,
  geoProjectionMutator: Ua,
  geoRotation: Vl,
  geoStereographic: mm,
  geoStereographicRaw: Wa,
  geoStream: Yn,
  geoTransform: jy,
  geoTransverseMercator: _m,
  geoTransverseMercatorRaw: Va,
  hcl: _i,
  hierarchy: Za,
  histogram: X0,
  hsl: vi,
  html: R2,
  interpolate: Er,
  interpolateArray: nl,
  interpolateBasis: Qf,
  interpolateBasisClosed: Kf,
  interpolateCool: kw,
  interpolateCubehelix: mg,
  interpolateCubehelixDefault: Nw,
  interpolateCubehelixLong: fu,
  interpolateDate: tl,
  interpolateHcl: vg,
  interpolateHclLong: yg,
  interpolateHsl: pg,
  interpolateHslLong: gg,
  interpolateInferno: $w,
  interpolateLab: dg,
  interpolateMagma: Rw,
  interpolateNumber: $n,
  interpolateObject: el,
  interpolatePlasma: Pw,
  interpolateRainbow: Cw,
  interpolateRgb: sr,
  interpolateRgbBasis: ig,
  interpolateRgbBasisClosed: ug,
  interpolateRound: rl,
  interpolateString: wa,
  interpolateTransformCss: ol,
  interpolateTransformSvg: al,
  interpolateViridis: Aw,
  interpolateWarm: Ew,
  interpolateZoom: sl,
  interrupt: Pt,
  interval: Mg,
  isoFormat: gw,
  isoParse: vw,
  json: $2,
  keys: mv,
  lab: mi,
  line: gs,
  lineRadial: hf,
  linkHorizontal: Kw,
  linkRadial: jw,
  linkVertical: Jw,
  local: Ff,
  map: Jn,
  matcher: fa,
  max: Z0,
  mean: G0,
  median: Q0,
  merge: sa,
  min: Cf,
  mouse: ht,
  namespace: Tr,
  namespaces: mo,
  nest: dv,
  now: we,
  pack: Jm,
  packEnclose: xh,
  packSiblings: Gm,
  pairs: U0,
  partition: jm,
  path: Mt,
  permute: K0,
  pie: Xw,
  pointRadial: Ge,
  polygonArea: g2,
  polygonCentroid: d2,
  polygonContains: _2,
  polygonHull: m2,
  polygonLength: w2,
  precisionFixed: Rl,
  precisionPrefix: $l,
  precisionRound: Pl,
  quadtree: vu,
  quantile: rr,
  quantize: _g,
  queue: Ah,
  radialArea: pf,
  radialLine: hf,
  randomBates: E2,
  randomExponential: k2,
  randomIrwinHall: $h,
  randomLogNormal: N2,
  randomNormal: Rh,
  randomUniform: T2,
  range: qn,
  request: Qa,
  rgb: or,
  ribbon: gv,
  scaleBand: ja,
  scaleIdentity: Oh,
  scaleImplicit: ea,
  scaleLinear: Dh,
  scaleLog: Fh,
  scaleOrdinal: Ja,
  scalePoint: O2,
  scalePow: es,
  scaleQuantile: Yh,
  scaleQuantize: qh,
  scaleSequential: o0,
  scaleSqrt: V2,
  scaleThreshold: Hh,
  scaleTime: ww,
  scaleUtc: xw,
  scan: J0,
  schemeCategory10: bw,
  schemeCategory20: Tw,
  schemeCategory20b: Mw,
  schemeCategory20c: Sw,
  select: kn,
  selectAll: Dp,
  selection: Ht,
  selector: iu,
  selectorAll: ca,
  set: bl,
  shuffle: j0,
  stack: Tx,
  stackOffsetDiverging: Ex,
  stackOffsetExpand: Nx,
  stackOffsetNone: ye,
  stackOffsetSilhouette: kx,
  stackOffsetWiggle: Cx,
  stackOrderAscending: C0,
  stackOrderDescending: Ax,
  stackOrderInsideOut: Rx,
  stackOrderNone: me,
  stackOrderReverse: $x,
  stratify: r2,
  style: Lt,
  sum: n1,
  symbol: ox,
  symbolCircle: ys,
  symbolCross: l0,
  symbolDiamond: p0,
  symbolSquare: v0,
  symbolStar: d0,
  symbolTriangle: y0,
  symbolWye: m0,
  symbols: ux,
  text: P2,
  thresholdFreedmanDiaconis: W0,
  thresholdScott: V0,
  thresholdSturges: kf,
  tickIncrement: Ke,
  tickStep: er,
  ticks: aa,
  timeDay: zr,
  timeDays: Q2,
  get timeFormat() {
    return cs;
  },
  timeFormatDefaultLocale: i0,
  timeFormatLocale: n0,
  timeFriday: Zh,
  timeFridays: t_,
  timeHour: is,
  timeHours: G2,
  timeInterval: hn,
  timeMillisecond: Yt,
  timeMilliseconds: Qc,
  timeMinute: rs,
  timeMinutes: Z2,
  timeMonday: wr,
  timeMondays: K2,
  timeMonth: us,
  timeMonths: r_,
  get timeParse() {
    return r0;
  },
  timeSaturday: Gh,
  timeSaturdays: e_,
  timeSecond: mr,
  timeSeconds: Kc,
  timeSunday: _r,
  timeSundays: Jc,
  timeThursday: nr,
  timeThursdays: n_,
  timeTuesday: Wh,
  timeTuesdays: J2,
  timeWednesday: Vh,
  timeWednesdays: j2,
  timeWeek: _r,
  timeWeeks: Jc,
  timeYear: at,
  timeYears: i_,
  timeout: So,
  timer: hu,
  timerFlush: gl,
  touch: di,
  touches: Op,
  transition: yl,
  transpose: Af,
  tree: c2,
  treemap: f2,
  treemapBinary: l2,
  treemapDice: $r,
  treemapResquarify: p2,
  treemapSlice: wu,
  treemapSliceDice: h2,
  treemapSquarify: kh,
  tsv: D2,
  tsvFormat: Ev,
  tsvFormatRows: kv,
  tsvParse: Tl,
  tsvParseRows: Nv,
  utcDay: Ir,
  utcDays: a_,
  get utcFormat() {
    return Su;
  },
  utcFriday: Jh,
  utcFridays: h_,
  utcHour: as,
  utcHours: o_,
  utcMillisecond: Yt,
  utcMilliseconds: Qc,
  utcMinute: os,
  utcMinutes: u_,
  utcMonday: br,
  utcMondays: s_,
  utcMonth: ss,
  utcMonths: g_,
  get utcParse() {
    return fs;
  },
  utcSaturday: jh,
  utcSaturdays: p_,
  utcSecond: mr,
  utcSeconds: Kc,
  utcSunday: xr,
  utcSundays: jc,
  utcThursday: tr,
  utcThursdays: l_,
  utcTuesday: Qh,
  utcTuesdays: c_,
  utcWednesday: Kh,
  utcWednesdays: f_,
  utcWeek: xr,
  utcWeeks: jc,
  utcYear: st,
  utcYears: d_,
  values: _v,
  variance: Sf,
  version: L0,
  voronoi: Qx,
  window: la,
  xml: z2,
  zip: e1,
  zoom: r3,
  zoomIdentity: Au,
  zoomTransform: I0
}, Symbol.toStringTag, { value: "Module" }));
export {
  am as a,
  Nf as b,
  bw as c,
  i3 as d,
  hm as e,
  Tw as f,
  vg as h,
  Jy as i,
  Dh as l,
  Ja as o,
  qh as q,
  V2 as s,
  Hh as t
};
//# sourceMappingURL=d3-BR7QU6TO.js.map
